function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  background: ",
        ";\n  pointer-events: none;\n  z-index: 1;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  z-index: 2;\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  /* No negative margins — see the module note. */\n  margin: 0;\n  max-width: 100%;\n  padding: 3px ",
        " 3px 7px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background ",
        " ",
        ",\n    border-color ",
        " ",
        ",\n    color ",
        " ",
        ";\n\n  /* The LABEL truncates, not the pill. Without min-width:0 a flex item refuses to shrink below\n     its content, so the pill overflows its cell and is CLIPPED mid-border by overflow:hidden —\n     it reads as broken rather than as truncated. Same trap as variant B's glyph; caught on a\n     render with realistic long equipment names. */\n  > span {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  /* The locate glyph is muted at rest, so a column of these reads as labels first and\n     affordances second. */\n  > svg {\n    width: 11px;\n    height: 11px;\n    flex: none;\n    color: ",
        ";\n    transition: color ",
        " ",
        ";\n  }\n\n  /* Tag is-active — the fill-on-hover card 18 calls for. */\n  &:hover,\n  &:focus-visible {\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n  }\n  &:hover > svg,\n  &:focus-visible > svg {\n    color: ",
        ";\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-align: left;\n  cursor: pointer;\n  transition: color ",
        " ",
        ";\n\n  /* The LABEL is what truncates, not the button. A flex item defaults to min-width:auto, so\n     without this the span refuses to shrink, the button overflows its cell, and the trailing\n     glyph lands outside the cell's overflow:hidden — i.e. the affordance disappears in exactly\n     the dense tables this variant exists for. Measured, not guessed: every row clipped. */\n  > span {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  > svg {\n    width: 10px;\n    height: 10px;\n    flex: none;\n    color: ",
        ";\n    transition: color ",
        " ",
        ";\n  }\n\n  &:hover,\n  &:focus-visible {\n    color: ",
        ";\n  }\n  &:hover > svg,\n  &:focus-visible > svg {\n    color: ",
        ";\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  > * {\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-variant-numeric: tabular-nums;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  font-variant-numeric: tabular-nums;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex: 0 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  font-variant-numeric: tabular-nums;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: block;\n  /* 6px / radius 3px — a rail, not a swatch. Half the old chip's height, because it is now read\n     along its length rather than as a block of colour. */\n  height: 6px;\n  border-radius: 3px;\n  background: ",
        ";\n  /* Takes 56px where the column has it and shrinks to 20px where it does not; never grows past\n     56px, so a very wide table does not turn the indicator into the column. */\n  flex: 0 1 56px;\n  min-width: 20px;\n  overflow: hidden;\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0 auto 0 0;\n  border-radius: 3px;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  padding: 0 ",
        " ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  flex-direction: column;\n  gap: ",
        ";\n  border-left: 3px solid ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ';\n  /* \uD83D\uDEA8 NORMAL INK, NOT THE SERIES FILL. The Embeddable original set its column heads in the series\n     colours and this component did too until 2026-08-30 — measured at ~2.3:1 for A and ~3.5:1 for\n     B on the light surface, so BOTH failed WCAG 1.4.3 and A failed even the 3:1 large-text floor.\n     primitives/color.ts forbids it in terms: "An accent tint is a FILL; it is never legible as\n     text ... never set label colour from the fill token itself."\n\n     AND IT CANNOT SIMPLY BE SWAPPED FOR THE PAIRED INK, because only ONE of the pair has one:\n     inkOn.aqua is documented against CHART_PALETTE[0], and NOTHING is paired with\n     CHART_PALETTE[1]. Colouring A and leaving B would break "never mix rows" the other way. So\n     both take normal ink and the series identity stays on the 3px rule beside them — a FILL used\n     as a fill — which is what the sibling ComparisonTable does (a colour chip beside normal ink).\n\n     OPEN FOR ROB: should the column heads be coloured at all, and if so what text-safe ink pairs\n     with CHART_PALETTE[1]? Recorded in the design-system epic\'s 6B. */\n  color: ',
        ";\n  overflow-wrap: anywhere;\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  background-image: linear-gradient(",
        ");\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  white-space: nowrap;\n  ",
        "\n  ",
        "\n  visibility: ",
        ";\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n  height: 100%;\n  min-height: ",
        ";\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n  /* ⚠️ min-width: 0 IS WHAT MAKES THE THREE-BLOCK LAYOUT POSSIBLE (U9). A flex item defaults to\n     min-width: auto, which floors it at its MIN-CONTENT width — and this component's rows are\n     Inline rows carrying a long equipment name beside a long detail string, so min-content is\n     several hundred pixels. Three of them side by side in one panelLayout row therefore refused\n     to shrink and ran straight out of the card: MEASURED at 1442px of content in a 1152px card\n     at a 1568px viewport, and identically at 1100px and 900px. With this, each takes its third.\n     (No backticks in here: this is a styled-components template literal, and one would\n     terminate it — the same trap MetricTable's Indicator comment records.) */\n  min-width: 0;\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  border-left: 3px solid ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  margin: 0 0 ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 30px;\n  padding: ",
        " ",
        "px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  position: relative;\n  transition:\n    background ",
        " ",
        ",\n    border-color ",
        " ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n\n  & > i[data-rail] {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  text-align: left;\n  font-family: ",
        ";\n  font-size: 13px;\n  font-weight: ",
        ";\n  line-height: 1.3;\n  color: ",
        ";\n\n  &:focus-visible {\n    outline: none;\n    /* focus.tight, not focus.ring: a 30px row is exactly the dense case whose neighbours the\n       bloom would crowd. Assigned per consumer, per the token's own note. */\n    box-shadow: ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-width: 0;\n\n  & .tl-cb-label {\n    min-width: 0;\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ';\n  /* ink[2], and the reason is a TWO-GROUND check rather than a one-ground one.\n     This row treatment gives text three possible backgrounds — white, the hover wash\n     (rgba(cyan,.05) -> #F2FCFC) and the SELECTED wash (rgba(cyan,.08) -> #EBFAFB) — and WCAG\n     1.4.3 AA\'s 4.5:1 has to hold on the WORST of them, not on white.\n        ink[4] (#7F8691, the mockup\'s choice): 3.67 / 3.51 / 3.43  — fails all three.\n        ink[3] (#6D737E):                      4.77 / 4.57 / 4.45  — passes white, FAILS the\n                                               selected wash. A 4.45 that reads as "basically\n                                               4.5" is still a fail, and a caption that goes\n                                               unreadable exactly when you select the row is a\n                                               poor trade.\n        ink[2] (#565C66):                      6.73 / 6.45 / 6.29  — passes on all three.\n     At 10px this is unambiguously "normal" text, not large, so 3:1 never applies. A deliberate\n     departure from the mockup: the caption is the ONE thing on the row that tells two\n     identically-named nodes apart, so it is the last thing that should be hard to read. */\n  color: ',
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: 11px;\n  font-weight: ",
        ";\n  color: ",
        ";\n  flex: none;\n  text-align: right;\n  min-width: 22px;\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  width: 7px;\n  height: 7px;\n  border-radius: ",
        ";\n  flex: none;\n  background: ",
        ";\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  background: none;\n  border: 0;\n  cursor: pointer;\n  width: ",
        "px;\n  height: ",
        "px;\n  flex: none;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  border-radius: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  width: ",
        "px;\n  flex: none;\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  & > span {\n    width: 18px;\n    height: 18px;\n    box-sizing: border-box;\n    border-radius: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    background: linear-gradient(180deg, rgba(",
        ", 0.1) 0%, rgba(",
        ", 0.16) 100%);\n    border: 1px solid transparent;\n    border-top-color: rgba(",
        ", 0.55);\n    border-left-color: rgba(",
        ", 0.5);\n    border-bottom-color: rgba(",
        ", 0.28);\n    border-right-color: rgba(",
        ", 0.3);\n    box-shadow:\n      inset 1px 1px 0 ",
        ",\n      1px 2px 4px -2px rgba(",
        ", 0.3),\n      0 0 0 1px rgba(",
        ", 0.06);\n    transition: all 0.18s ease;\n  }\n\n  /* The checked dot. Opacity-animated rather than mounted/unmounted so the transition runs. */\n  & > span::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: ",
        ";\n    background: ",
        ";\n    opacity: 0;\n    transition: opacity 0.18s ease;\n  }\n\n  /* Driven off the ARIA state on the button, so the visual can never disagree with the\n     announced one — there is no separate selected prop to forget to pass. */\n  [aria-checked='true'] > & > span {\n    background: linear-gradient(180deg, rgba(",
        ", 0.95) 0%, rgba(",
        ", 0.75) 100%);\n    border-top-color: rgba(",
        ", 0.95);\n    border-left-color: rgba(",
        ", 0.85);\n    border-bottom-color: rgba(",
        ", 0.55);\n    border-right-color: rgba(",
        ", 0.6);\n    box-shadow:\n      inset 1px 1px 0 ",
        ",\n      1px 2px 5px -1px rgba(",
        ", 0.5),\n      0 0 0 1px rgba(",
        ", 0.1);\n  }\n  [aria-checked='true'] > & > span::after {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  /* The design system's Input wraps itself in a width:100% element, so each field has to be\n     told to share the row rather than each demanding all of it. min-width lets the pair shrink\n     inside a w:3 rail cell instead of pushing the arrow out of the card.\n     WARNING: TARGETED BY THE WRAPPER'S OWN CLASS, not by a bare child selector. A structural\n     selector couples this\n     to the DS component's internal element type AND would catch any direct-child div added to\n     this row later — two ways to break at a distance, on a control whose whole defect was that\n     it had drifted from the design system unnoticed. (Copilot. And no backticks in here: this\n     is a styled-components template literal and one would terminate it.) */\n  .tl-input-wrap {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  /* ⚠️ THE ONE PIECE OF NATIVE CHROME THE CHASSIS CANNOT REACH. The calendar glyph is a UA\n     pseudo-element, unaffected by appearance:none on the input, and it paints solid black —\n     the single loudest thing in a rail of muted design-system controls, and the specific\n     detail U20 names. Dropped to the muted ink's own weight rather than hidden: hiding it\n     would remove the only affordance saying the field opens a picker. Cursor follows, because\n     it is a button and did not look like one. */\n  input::-webkit-calendar-picker-indicator {\n    opacity: 0.45;\n    cursor: pointer;\n  }\n  /* WARNING: :focus AS WELL AS :focus-visible. Clicking into a date field focuses it WITHOUT\n     matching :focus-visible, so a mouse user — the majority on this control — got the resting\n     state while the comment above claimed hover/focus. (Copilot.) */\n  input:hover::-webkit-calendar-picker-indicator,\n  input:focus::-webkit-calendar-picker-indicator,\n  input:focus-visible::-webkit-calendar-picker-indicator {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: ",
        ";\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  gap: ",
        ";\n  padding: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  /* The card DOES specify a weight (font:500 12px), which an earlier pass missed.\n     No backticks in here — inside a styled template literal they end the template. */\n  font-weight: ",
        ";\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  background: ",
        ';\n  /* The lift is what says "selected" — see the token\'s note. */\n  box-shadow: ',
        ";\n  transition:\n    background ",
        " ",
        ",\n    box-shadow ",
        " ",
        ';\n\n  /* Card 16 \xa76 specifies NO hover for .tl-seg. Dropping hover feedback from an interactive\n     control would be an affordance regression, so an unselected pill hovers to the SAME white\n     as the selected one WITHOUT the lift: it reads as "this could become selected" and cannot\n     be mistaken for selected, because the shadow is what marks selection. Token-only, and no\n     new value. (The obvious candidate, surface.hover, is byte-identical to the new TRACK\n     colour, so it would have been invisible.) Logged as a small DS gap for Rob. */\n  &:hover:not(:disabled) {\n    background: ',
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  padding: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
import { BaseDropdown_default, TLSpinner_default } from "./chunk-VQB55EFK.mjs";
import { bandHistogramPropsSchema, barChartPropsSchema, capacityTreemapPropsSchema, chartHeaderPropsSchema, comparisonChartPropsSchema, comparisonKpiPropsSchema, comparisonTablePropsSchema, dateRangePickerPropsSchema, dayTypeSelectPropsSchema, entitySpotlightPropsSchema, equipmentCheckTablePropsSchema, gymMultiSelectPropsSchema, gymSelectPropsSchema, heatmapPropsSchema, hierarchicalFilterPropsSchema, kpiCardLivePropsSchema, kpiCardPropsSchema, metricTablePropsSchema, panelCardPropsSchema, rankedRowsPropsSchema, roomSelectPropsSchema, suggestionsPropsSchema, timeSeriesChartPropsSchema } from "./chunk-L6FNNBQC.mjs";
import { visuallyHidden } from "./chunk-MLHALTYO.mjs";
// src/charts/core/registry.ts
import { Chart, LineController, BarController, LineElement, PointElement, BarElement, CategoryScale, LinearScale, Legend, Tooltip, Filler } from "chart.js";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";
// src/charts/theme/peakBandsPlugin.ts
import { chartTheme } from "@repo/design-tokens";
var PEAK_BANDS_PLUGIN_ID = "peakBands";
var peakBandsPlugin = {
    id: PEAK_BANDS_PLUGIN_ID,
    // `beforeDatasetsDraw`, not `beforeDraw`: the band is a backdrop for the data, so it must
    // paint after the grid but UNDER the lines/bars. `beforeDraw` would put it below the grid;
    // `afterDatasetsDraw` would veil the data it is meant to sit behind.
    beforeDatasetsDraw: function beforeDatasetsDraw(chart, _args, options) {
        var bands = options === null || options === void 0 ? void 0 : options.bands;
        if (!bands || bands.length === 0) return;
        var ctx = chart.ctx, chartArea = chart.chartArea;
        var x = chart.scales.x;
        if (!ctx || !chartArea || !x) return;
        var band = chartTheme.base.peakBand;
        var top = chartArea.top, bottom = chartArea.bottom, left = chartArea.left, right = chartArea.right;
        var height = bottom - top;
        if (height <= 0) return;
        ctx.save();
        ctx.fillStyle = band.fill;
        ctx.strokeStyle = band.edgeColor;
        ctx.lineWidth = 1;
        ctx.setLineDash(_to_consumable_array(band.edgeDash));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var b = _step.value;
                if (typeof b.xMin !== "number" || typeof b.xMax !== "number") continue;
                var a = x.getPixelForValue(b.xMin);
                var z = x.getPixelForValue(b.xMax);
                if (!Number.isFinite(a) || !Number.isFinite(z)) continue;
                var lo = Math.max(left, Math.min(a, z));
                var hi = Math.min(right, Math.max(a, z));
                var width = hi - lo;
                if (width <= 0) continue;
                ctx.fillRect(lo, top, width, height);
                if (width > 1) ctx.strokeRect(lo + 0.5, top + 0.5, width - 1, height - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        ctx.restore();
    }
};
// src/charts/core/registry.ts
var registered = false;
function registerCharts() {
    if (registered) return;
    Chart.register(LineController, BarController, LineElement, PointElement, BarElement, CategoryScale, LinearScale, Legend, Tooltip, Filler, // Phase 2 (CP9): the matrix mark (Heatmap, CP11) and the treemap mark
    // (CapacityTreemap, CP12). Registered here with everything else so a chart can
    // never render against an unregistered controller — the same guarantee the rest
    // of this list gives, and the reason `useChartJs` calls `registerCharts()` again
    // on first use.
    MatrixController, MatrixElement, TreemapController, TreemapElement, // DS8: our own ~40-line peak-band plugin, in place of `chartjs-plugin-annotation`. It is
    // inert unless a chart passes `options.plugins.peakBands.bands`, so registering it
    // globally costs nothing on the charts that never opt in.
    peakBandsPlugin);
    registered = true;
}
// src/charts/theme/applyChartTheme.ts
import { Chart as Chart2 } from "chart.js";
import { chartTheme as chartTheme2 } from "@repo/design-tokens";
var asScale = function(slot) {
    return slot;
};
function setFont(host, key, family, size) {
    var existing = host[key] && _type_of(host[key]) === "object" ? host[key] : {};
    host[key] = _object_spread_props(_object_spread({}, existing), {
        family: family,
        size: size
    });
}
function pxToNumber(value) {
    var match = /^(-?\d+(?:\.\d+)?)px$/.exec(value.trim());
    if (!match) {
        throw new Error("applyChartTheme: expected a 'px' token value, received \"".concat(value, '"'));
    }
    return Number(match[1]);
}
function durationToMs(value) {
    var match = /^(-?\d+(?:\.\d+)?)(ms|s)$/.exec(value.trim());
    if (!match) {
        throw new Error("applyChartTheme: expected an 's'/'ms' token value, received \"".concat(value, '"'));
    }
    var n = Number(match[1]);
    return match[2] === "s" ? n * 1e3 : n;
}
var applied = false;
function applyChartTheme() {
    if (applied) return;
    applied = true;
    registerCharts();
    Chart2.defaults.font.family = chartTheme2.legend.fontFamily;
    Chart2.defaults.font.size = pxToNumber(chartTheme2.legend.fontSize);
    Chart2.defaults.font.weight = chartTheme2.legend.fontWeight;
    Chart2.defaults.color = chartTheme2.legend.text;
    var base = chartTheme2.base;
    var line2 = Chart2.defaults.elements.line;
    line2.tension = base.line.tension;
    line2.borderWidth = base.line.borderWidth;
    line2.borderCapStyle = base.line.capStyle;
    line2.borderJoinStyle = base.line.joinStyle;
    var point = Chart2.defaults.elements.point;
    point.radius = base.point.radius;
    point.hoverRadius = base.point.hoverRadius;
    point.hitRadius = base.point.hitRadius;
    point.borderWidth = 0;
    point.hoverBorderWidth = base.point.hoverRingWidth;
    point.hoverBorderColor = base.point.hoverRingColor;
    var bar = Chart2.defaults.elements.bar;
    bar.borderRadius = base.bar.borderRadius;
    bar.borderSkipped = base.bar.borderSkipped;
    var barDataset = Chart2.defaults.datasets.bar;
    barDataset.maxBarThickness = base.bar.maxThickness;
    Chart2.defaults.animation = base.animation.firstPaint;
    var scale = asScale(Chart2.defaults.scale);
    scale.ticks.color = base.tick.color;
    setFont(scale.ticks, "font", base.tick.fontFamily, pxToNumber(base.tick.fontSize));
    scale.title.color = chartTheme2.axis.title;
    scale.grid.color = base.grid.color;
    scale.border.color = chartTheme2.grid.border;
    var legendLabels = Chart2.defaults.plugins.legend.labels;
    legendLabels.color = chartTheme2.legend.text;
    setFont(legendLabels, "font", chartTheme2.legend.fontFamily, pxToNumber(chartTheme2.legend.fontSize));
    var tooltip = Chart2.defaults.plugins.tooltip;
    tooltip.backgroundColor = chartTheme2.tooltip.surface;
    tooltip.titleColor = chartTheme2.tooltip.text;
    tooltip.bodyColor = chartTheme2.tooltip.text;
    tooltip.cornerRadius = pxToNumber(chartTheme2.tooltip.radius);
    tooltip.usePointStyle = chartTheme2.tooltip.usePointStyle;
    var tooltipFontSize = pxToNumber(chartTheme2.tooltip.fontSize);
    setFont(tooltip, "titleFont", chartTheme2.tooltip.fontFamily, tooltipFontSize);
    setFont(tooltip, "bodyFont", chartTheme2.tooltip.bodyFontFamily, tooltipFontSize);
    var colors = Chart2.defaults.plugins.colors;
    if (colors) colors.enabled = false;
}
// src/charts/core/useChartJs.ts
import { useCallback, useEffect, useRef } from "react";
import { Chart as Chart3 } from "chart.js";
import { chartTheme as chartTheme3 } from "@repo/design-tokens";
function samePluginSet(a, b) {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    return a.length === b.length && a.every(function(plugin, i) {
        return plugin === b[i];
    });
}
function useChartJs(config, pluginInputs) {
    var chartRef = useRef(null);
    var canvasElRef = useRef(null);
    var observerRef = useRef(null);
    var configRef = useRef(config);
    configRef.current = config;
    var pluginInputsRef = useRef(pluginInputs);
    pluginInputsRef.current = pluginInputs;
    var freshRef = useRef(false);
    var pluginsRef = useRef(void 0);
    var destroy = useCallback(function() {
        var _observerRef_current, _chartRef_current;
        (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.disconnect();
        observerRef.current = null;
        (_chartRef_current = chartRef.current) === null || _chartRef_current === void 0 ? void 0 : _chartRef_current.destroy();
        chartRef.current = null;
    }, []);
    var create = useCallback(function(canvas) {
        var fresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        registerCharts();
        applyChartTheme();
        var chart = new Chart3(canvas, configRef.current);
        chart.$tlPluginInputs = pluginInputsRef.current;
        chartRef.current = chart;
        if (pluginInputsRef.current && chart.ctx) chart.draw();
        freshRef.current = fresh;
        pluginsRef.current = configRef.current.plugins;
        var parent = canvas.parentElement;
        if (parent && typeof ResizeObserver !== "undefined") {
            var observer = new ResizeObserver(function() {
                var _chartRef_current;
                return (_chartRef_current = chartRef.current) === null || _chartRef_current === void 0 ? void 0 : _chartRef_current.resize();
            });
            observer.observe(parent);
            observerRef.current = observer;
        }
    }, []);
    var setCanvas = useCallback(function(canvas) {
        destroy();
        canvasElRef.current = canvas;
        if (canvas) create(canvas);
    }, [
        create,
        destroy
    ]);
    useEffect(function() {
        var chart = chartRef.current;
        var canvas = canvasElRef.current;
        if (!chart || !canvas) return;
        if (freshRef.current) {
            freshRef.current = false;
            return;
        }
        var live = chart.canvas;
        if (!live || !live.parentNode) return;
        var liveType = chart.config.type;
        if (liveType !== config.type) {
            destroy();
            create(canvas, false);
            return;
        }
        if (!samePluginSet(pluginsRef.current, config.plugins)) {
            destroy();
            create(canvas, false);
            return;
        }
        chart.$tlPluginInputs = pluginInputs;
        chart.data = config.data;
        var _config_options;
        chart.options = _object_spread_props(_object_spread({}, (_config_options = config.options) !== null && _config_options !== void 0 ? _config_options : chart.options), {
            animation: {
                duration: durationToMs(chartTheme3.base.animation.tweenDuration)
            }
        });
        chart.update();
    }, [
        config,
        pluginInputs,
        create,
        destroy
    ]);
    useEffect(function() {
        return destroy;
    }, [
        destroy
    ]);
    return setCanvas;
}
// src/charts/core/companionTable.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function axisLabels(config, axis) {
    var _config_options_scales, _config_options;
    var scale = (_config_options = config.options) === null || _config_options === void 0 ? void 0 : (_config_options_scales = _config_options.scales) === null || _config_options_scales === void 0 ? void 0 : _config_options_scales[axis];
    var labels = scale === null || scale === void 0 ? void 0 : scale.labels;
    return Array.isArray(labels) ? labels.map(String) : null;
}
function buildMatrixCompanion(config, labels, format) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _config_data_datasets_, _config_data_datasets, _config_data;
    var _config_data_datasets__data;
    var points = ((_config_data_datasets__data = (_config_data = config.data) === null || _config_data === void 0 ? void 0 : (_config_data_datasets = _config_data.datasets) === null || _config_data_datasets === void 0 ? void 0 : (_config_data_datasets_ = _config_data_datasets[0]) === null || _config_data_datasets_ === void 0 ? void 0 : _config_data_datasets_.data) !== null && _config_data_datasets__data !== void 0 ? _config_data_datasets__data : []).filter(function(p) {
        return p !== null && (typeof p === "undefined" ? "undefined" : _type_of(p)) === "object" && "x" in p && "y" in p;
    });
    var seen = function(values) {
        return Array.from(new Set(values.map(String)));
    };
    var _axisLabels;
    var columns = (_axisLabels = axisLabels(config, "x")) !== null && _axisLabels !== void 0 ? _axisLabels : seen(points.map(function(p) {
        return p.x;
    }));
    var _axisLabels1;
    var declaredRows = (_axisLabels1 = axisLabels(config, "y")) !== null && _axisLabels1 !== void 0 ? _axisLabels1 : seen(points.map(function(p) {
        return p.y;
    }));
    var orderKey = function(values) {
        return JSON.stringify(_to_consumable_array(values).sort());
    };
    var declaredKey = orderKey(declaredRows);
    var rowKeys = options.rowOrder && orderKey(options.rowOrder) === declaredKey ? options.rowOrder : declaredRows;
    var byCell = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            byCell.set("".concat(String(p.y), "\0").concat(String(p.x)), p.v);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        caption: labels.caption,
        rowHeader: labels.rowHeader,
        columns: columns,
        rows: rowKeys.map(function(rowKey) {
            return {
                header: rowKey,
                cells: columns.map(function(col) {
                    var v = byCell.get("".concat(rowKey, "\0").concat(col));
                    return typeof v === "number" && Number.isFinite(v) ? format.value(v) : format.empty;
                })
            };
        })
    };
}
function buildTreemapCompanion(config, labels, labelKey, columns) {
    var _config_data_datasets, _config_data;
    var dataset = (_config_data = config.data) === null || _config_data === void 0 ? void 0 : (_config_data_datasets = _config_data.datasets) === null || _config_data_datasets === void 0 ? void 0 : _config_data_datasets[0];
    var tree = Array.isArray(dataset === null || dataset === void 0 ? void 0 : dataset.tree) ? dataset.tree : [];
    return {
        caption: labels.caption,
        rowHeader: labels.rowHeader,
        columns: columns.map(function(c) {
            return c.header;
        }),
        rows: tree.map(function(row) {
            var _row_labelKey, _labels_unnamed;
            return {
                header: String((_row_labelKey = row[labelKey]) !== null && _row_labelKey !== void 0 ? _row_labelKey : "").trim() || ((_labels_unnamed = labels.unnamed) !== null && _labels_unnamed !== void 0 ? _labels_unnamed : "Unnamed"),
                cells: columns.map(function(c) {
                    return c.value(row);
                })
            };
        })
    };
}
var CompanionTable = function(param) {
    var model = param.model, id = param.id;
    return /* @__PURE__ */ jsxs("table", {
        id: id,
        style: visuallyHidden,
        "data-companion-table": "",
        children: [
            /* @__PURE__ */ jsx("caption", {
                children: model.caption
            }),
            /* @__PURE__ */ jsx("thead", {
                children: /* @__PURE__ */ jsxs("tr", {
                    children: [
                        /* @__PURE__ */ jsx("th", {
                            scope: "col",
                            children: model.rowHeader
                        }),
                        model.columns.map(function(col, i) {
                            return /* @__PURE__ */ jsx("th", {
                                scope: "col",
                                children: col
                            }, i);
                        })
                    ]
                })
            }),
            /* @__PURE__ */ jsx("tbody", {
                children: model.rows.map(function(row, r) {
                    return /* @__PURE__ */ jsxs("tr", {
                        children: [
                            /* @__PURE__ */ jsx("th", {
                                scope: "row",
                                children: row.header
                            }),
                            row.cells.map(function(cell, c) {
                                return /* @__PURE__ */ jsx("td", {
                                    children: cell
                                }, c);
                            })
                        ]
                    }, r);
                })
            })
        ]
    });
};
// src/charts/core/DataChangeAnnouncer.tsx
import React from "react";
import { jsxs as jsxs2 } from "react/jsx-runtime";
var DataChangeAnnouncer = function(param) {
    var changeKey = param.changeKey, message = param.message;
    var previous = React.useRef(changeKey);
    var _React_useState = _sliced_to_array(React.useState({
        text: "",
        seq: 0
    }), 2), announced = _React_useState[0], setAnnounced = _React_useState[1];
    React.useEffect(function() {
        if (previous.current === changeKey) return;
        var hydrating = previous.current === null || previous.current === void 0;
        previous.current = changeKey;
        if (hydrating) return;
        var text = typeof message === "string" ? message : "";
        setAnnounced(function(prev) {
            return {
                text: text,
                seq: prev.seq + 1
            };
        });
    }, [
        changeKey,
        message
    ]);
    return(// `aria-atomic="true"` asks assistive tech to read the whole region on any change rather than
    // just the changed part. ⚠️ IT IS NOT WHAT MAKES THE SHARED OPENING CLAUSE SURVIVE — an earlier
    // comment here claimed that and it was wrong: the region's entire content is ONE text node
    // replaced wholesale, so `false` would present the same sentence. It is kept because it matches
    // the house pattern (`Planner/canvas/CanvasControls.tsx`) and because it IS load-bearing the
    // moment a caller renders multi-node content. What actually guarantees a re-announcement is
    // `seq` above.
    //
    // `role="status"` carries an implicit `aria-live="polite"`; both are written out because the
    // pairing is what the house pattern uses (`Planner/canvas/CanvasControls.tsx`) and because a
    // reader should not have to know the implicit mapping to see that this is polite, never
    // assertive. A grid re-reading is not an interruption.
    /* @__PURE__ */ jsxs2("span", {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true",
        style: visuallyHidden,
        children: [
            announced.text,
            announced.seq % 2 === 1 ? "\u200B" : ""
        ]
    }));
};
// src/charts/theme/optionBuilders.ts
import { DateTime } from "luxon";
import { chartTheme as chartTheme4, rgba } from "@repo/design-tokens";
// src/charts/format.ts
var safePrecision = function(precision) {
    return Number.isFinite(precision) ? Math.min(100, Math.max(0, Math.trunc(precision))) : 0;
};
var formatMeasurement = function(value, precision) {
    var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var n = value.toFixed(safePrecision(precision));
    if (!unit) return n;
    return /^[A-Za-z]/.test(unit) ? "".concat(n, " ").concat(unit) : "".concat(n).concat(unit);
};
// src/charts/theme/optionBuilders.ts
function buildSeriesDatasets(count) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var offIndices = options.offIndices;
    return Array.from({
        length: count
    }, function(_unused, i) {
        var _offIndices_has;
        var off = (_offIndices_has = offIndices === null || offIndices === void 0 ? void 0 : offIndices.has(i)) !== null && _offIndices_has !== void 0 ? _offIndices_has : false;
        var color = off ? chartTheme4.series.offColor(i, count) : chartTheme4.chartColour(i);
        return {
            borderColor: color,
            backgroundColor: color,
            pointBackgroundColor: color
        };
    });
}
function buildAreaFill(hex) {
    var topAlpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : chartTheme4.base.line.fillTopAlpha;
    return function(param) {
        var chart = param.chart;
        var area = chart.chartArea;
        var canvasCtx = chart.ctx;
        if (!area || !canvasCtx || area.bottom <= area.top) return rgba(hex, topAlpha);
        var gradient = canvasCtx.createLinearGradient(0, area.top, 0, area.bottom);
        gradient.addColorStop(0, rgba(hex, topAlpha));
        gradient.addColorStop(1, rgba(hex, 0));
        return gradient;
    };
}
function buildBarFill(hex) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_horizontal = options.horizontal, horizontal = _options_horizontal === void 0 ? false : _options_horizontal;
    var _options_tail;
    var tail = (_options_tail = options.tail) !== null && _options_tail !== void 0 ? _options_tail : horizontal ? chartTheme4.base.bar.fadeTailHorizontal : chartTheme4.base.bar.fadeTailVertical;
    return function(ctx) {
        var _chart_scales, _chart_scales1;
        var chart = ctx.chart, parsed = ctx.parsed;
        var area = chart === null || chart === void 0 ? void 0 : chart.chartArea;
        var canvasCtx = chart === null || chart === void 0 ? void 0 : chart.ctx;
        var scale = horizontal ? chart === null || chart === void 0 ? void 0 : (_chart_scales = chart.scales) === null || _chart_scales === void 0 ? void 0 : _chart_scales.x : chart === null || chart === void 0 ? void 0 : (_chart_scales1 = chart.scales) === null || _chart_scales1 === void 0 ? void 0 : _chart_scales1.y;
        var value = horizontal ? parsed === null || parsed === void 0 ? void 0 : parsed.x : parsed === null || parsed === void 0 ? void 0 : parsed.y;
        if (!area || !canvasCtx || !scale || typeof value !== "number" || !Number.isFinite(value)) {
            return hex;
        }
        var baseline = scale.getPixelForValue(0);
        var tip = scale.getPixelForValue(value);
        if (!Number.isFinite(baseline) || !Number.isFinite(tip) || baseline === tip) return hex;
        var gradient = horizontal ? canvasCtx.createLinearGradient(tip, 0, baseline, 0) : canvasCtx.createLinearGradient(0, tip, 0, baseline);
        gradient.addColorStop(0, rgba(hex, 1));
        gradient.addColorStop(1, rgba(hex, tail));
        return gradient;
    };
}
function buildLegend(display) {
    return {
        display: display,
        position: "top",
        // Chart.js has no "top-right"; `align: 'end'` on a top legend IS top-right.
        align: "end",
        labels: {
            usePointStyle: true,
            pointStyle: "circle",
            boxHeight: 9,
            color: chartTheme4.legend.text,
            font: {
                family: chartTheme4.legend.fontFamily,
                size: parseInt(chartTheme4.legend.fontSize, 10)
            }
        }
    };
}
function buildBandColors() {
    var b = chartTheme4.utilisationBands;
    return {
        low: b.low,
        medium: b.medium,
        high: b.high,
        overCapacity: b.overCapacity
    };
}
function formatHourRange(startHour, endHour) {
    var hh = function(h) {
        return "".concat(String(h).padStart(2, "0"), ":00");
    };
    return "".concat(hh(startHour), "–").concat(hh(endHour));
}
var GRAIN_FORMAT = {
    "5m": "HH:mm",
    hourly: "HH:mm",
    daily: "dd LLL",
    weekly: "dd LLL",
    monthly: "LLL yyyy"
};
var COARSE_GRAINS = /* @__PURE__ */ new Set([
    "daily",
    "weekly",
    "monthly"
]);
function makeTimeTickCallback(grain, zone) {
    var fmt = GRAIN_FORMAT[grain];
    var effectiveZone = COARSE_GRAINS.has(grain) ? "utc" : zone;
    return function(value) {
        var dt = typeof value === "number" ? DateTime.fromMillis(value, {
            zone: effectiveZone
        }) : DateTime.fromISO(value, {
            zone: effectiveZone
        });
        return dt.isValid ? dt.toFormat(fmt) : String(value);
    };
}
function buildValueTooltip(options) {
    var formatX = options.formatX, _options_unit = options.unit, unit = _options_unit === void 0 ? "" : _options_unit, precision = options.precision;
    return {
        callbacks: {
            title: function(items) {
                var _items__parsed, _items_;
                var x = (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : (_items__parsed = _items_.parsed) === null || _items__parsed === void 0 ? void 0 : _items__parsed.x;
                return typeof x === "number" && Number.isFinite(x) ? formatX(x) : "";
            },
            label: function(item) {
                var _item_parsed, _item_dataset;
                var y = item === null || item === void 0 ? void 0 : (_item_parsed = item.parsed) === null || _item_parsed === void 0 ? void 0 : _item_parsed.y;
                if (typeof y !== "number" || !Number.isFinite(y)) return "";
                var name = item === null || item === void 0 ? void 0 : (_item_dataset = item.dataset) === null || _item_dataset === void 0 ? void 0 : _item_dataset.label;
                var value = formatMeasurement(y, precision, unit);
                return name ? "".concat(name, ": ").concat(value) : value;
            }
        }
    };
}
// src/charts/data/provider.tsx
import { createContext, useContext } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var ChartsDataProviderContext = createContext(null);
function ChartsDataProviderProvider(param) {
    var provider = param.provider, children = param.children;
    return /* @__PURE__ */ jsx2(ChartsDataProviderContext.Provider, {
        value: provider,
        children: children
    });
}
function useChartsDataProvider() {
    var provider = useContext(ChartsDataProviderContext);
    if (!provider) {
        throw new Error("useChartsDataProvider: no ChartsDataProvider in context. Wrap the tree in <ChartsDataProviderProvider provider={\u2026}>.");
    }
    return provider;
}
function createFixtureProvider(fixtures) {
    return {
        fetch: function fetch(binding, context) {
            return _async_to_generator(function() {
                var entry;
                return _ts_generator(this, function(_state) {
                    entry = fixtures[binding.endpoint];
                    if (entry === void 0) {
                        throw new Error('createFixtureProvider: no fixture for endpoint "'.concat(binding.endpoint, '"'));
                    }
                    return [
                        2,
                        typeof entry === "function" ? entry(binding, context) : entry
                    ];
                });
            })();
        }
    };
}
// src/charts/data/types.ts
var EVENT_RANKING_VALUE_KEYS = [
    "value",
    "instances",
    "slots"
];
var EVENT_INSTANCES_VALUE_KEYS = [
    "value",
    "avg_headcount",
    "max_headcount",
    "tracked_capacity"
];
var EVENT_INSTANCES_LABEL_KEYS = [
    "date",
    "time",
    "room"
];
// src/charts/adapters/adaptTimeseries.ts
import { DateTime as DateTime2 } from "luxon";
function toMs(ts) {
    if (typeof ts === "number") return ts;
    var dt = DateTime2.fromISO(ts, {
        zone: "utc"
    });
    return dt.isValid ? dt.toMillis() : NaN;
}
function toPoints(series) {
    return series.map(function(param) {
        var _param = _sliced_to_array(param, 2), ts = _param[0], value = _param[1];
        return {
            x: toMs(ts),
            y: value
        };
    }).filter(function(p) {
        return Number.isFinite(p.x);
    });
}
function flattenTimeseriesSlice(slice, opts) {
    var series = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(slice)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var metric = _step.value;
            var _slice_metric;
            var byBid = (_slice_metric = slice[metric]) !== null && _slice_metric !== void 0 ? _slice_metric : {};
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys(byBid)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var bid = _step1.value;
                    var _byBid_bid, _byBid_bid_meta, _byBid_bid1;
                    var _byBid_bid_series;
                    var points = toPoints((_byBid_bid_series = (_byBid_bid = byBid[bid]) === null || _byBid_bid === void 0 ? void 0 : _byBid_bid.series) !== null && _byBid_bid_series !== void 0 ? _byBid_bid_series : []);
                    var rawLabel = (_byBid_bid1 = byBid[bid]) === null || _byBid_bid1 === void 0 ? void 0 : (_byBid_bid_meta = _byBid_bid1.meta) === null || _byBid_bid_meta === void 0 ? void 0 : _byBid_bid_meta.label;
                    var groupLabel = typeof rawLabel === "string" ? rawLabel.trim() : void 0;
                    var name = groupLabel || bid;
                    series.push({
                        label: opts.multiMetric ? "".concat(metric, " \xb7 ").concat(name) : name,
                        metric: metric,
                        bid: bid,
                        points: points
                    });
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return series;
}
function adaptTimeseries(envelope) {
    var _envelope_data;
    var data = (_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : {};
    var series = flattenTimeseriesSlice(data, {
        multiMetric: Object.keys(data).length > 1
    });
    var isEmpty = series.length === 0 || series.every(function(s) {
        return s.points.length === 0;
    });
    return {
        series: series,
        isEmpty: isEmpty
    };
}
// src/charts/adapters/adaptTimeseriesByTwin.ts
var TimeseriesShapeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(_TimeseriesShapeError, Error1);
    function _TimeseriesShapeError(message) {
        _class_call_check(this, _TimeseriesShapeError);
        var _this;
        _this = _call_super(this, _TimeseriesShapeError, [
            message
        ]);
        _this.name = "TimeseriesShapeError";
        Object.setPrototypeOf(_this, _TimeseriesShapeError.prototype);
        return _this;
    }
    return _TimeseriesShapeError;
}(_wrap_native_super(Error));
function gymName(bid, options) {
    var _options_twins_find, _options_twins;
    var listed = (_options_twins = options.twins) === null || _options_twins === void 0 ? void 0 : (_options_twins_find = _options_twins.find(function(t) {
        return t.bid === bid;
    })) === null || _options_twins_find === void 0 ? void 0 : _options_twins_find.name;
    if (typeof listed === "string" && listed.trim() !== "") return listed.trim();
    if (bid === options.hostTwinBid) {
        var host = options.hostTwinName;
        if (typeof host === "string" && host.trim() !== "") return host.trim();
    }
    return bid;
}
function looksLikeLeafLevel(value) {
    if (value === null || (typeof value === "undefined" ? "undefined" : _type_of(value)) !== "object") return false;
    return Array.isArray(value.series);
}
function adaptTimeseriesByTwin(envelope) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_requestedTwinBids;
    var _envelope_data;
    var data = (_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : {};
    var twinBids = Object.keys(data);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = twinBids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var twinBid = _step.value;
            var slice = data[twinBid];
            if (slice === null || (typeof slice === "undefined" ? "undefined" : _type_of(slice)) !== "object") {
                throw new TimeseriesShapeError('adaptTimeseriesByTwin: data["'.concat(twinBid, '"] is not an object — expected the query-service 4.0.0 envelope `data[twin_bid][metric][group_bid]`'));
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys(slice)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    var metricLevel = slice[key];
                    if (looksLikeLeafLevel(metricLevel)) {
                        throw new TimeseriesShapeError('adaptTimeseriesByTwin: this is the PRE-4.0.0 timeseries envelope (`data[metric][group_bid]`) — found a series two levels down, at data["'.concat(twinBid, '"]["').concat(key, '"]. The trend chart needs the twin-keyed 4.0.0 shape `data[twin_bid][metric][group_bid]`, which the query service returns for a single twin as well as several. Refusing rather than rendering an empty chart: an empty chart here is indistinguishable from "this gym has no data".'));
                    }
                    if (metricLevel === null || (typeof metricLevel === "undefined" ? "undefined" : _type_of(metricLevel)) !== "object") {
                        throw new TimeseriesShapeError('adaptTimeseriesByTwin: data["'.concat(twinBid, '"]["').concat(key, '"] is not an object — expected a map of group bID to `{meta, series}`'));
                    }
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = Object.keys(metricLevel)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var groupBid = _step2.value;
                            var leaf = metricLevel[groupBid];
                            if (!looksLikeLeafLevel(leaf)) {
                                throw new TimeseriesShapeError('adaptTimeseriesByTwin: data["'.concat(twinBid, '"]["').concat(key, '"]["').concat(groupBid, '"] carries no `series` array. Every leaf of the 4.0.0 envelope must; refusing rather than rendering a legend built from whatever keys happened to be there.'));
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var requested = options.requestedTwinBids;
    if (requested !== void 0 && requested.length > 0) {
        var answered = new Set(twinBids);
        var missing = requested.filter(function(bid) {
            return !answered.has(bid);
        });
        var asked = new Set(requested);
        var extra = twinBids.filter(function(bid) {
            return !asked.has(bid);
        });
        if (missing.length > 0 || extra.length > 0) {
            throw new TimeseriesShapeError("adaptTimeseriesByTwin: the answer does not cover the gyms that were asked for — requested [".concat(requested.join(", "), "], answered [").concat(twinBids.join(", "), "]") + (missing.length > 0 ? ", MISSING [".concat(missing.join(", "), "]") : "") + (extra.length > 0 ? ", UNREQUESTED [".concat(extra.join(", "), "]") : "") + ". The 4.0.0 contract guarantees a key for every twin in scope, so this is the service not honouring it \u2014 refusing rather than drawing a smaller picture that reads as complete.");
        }
    }
    var _options_requestedTwinBids_length;
    var multiTwin = ((_options_requestedTwinBids_length = (_options_requestedTwinBids = options.requestedTwinBids) === null || _options_requestedTwinBids === void 0 ? void 0 : _options_requestedTwinBids.length) !== null && _options_requestedTwinBids_length !== void 0 ? _options_requestedTwinBids_length : twinBids.length) > 1;
    var metrics = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = twinBids[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var twinBid1 = _step3.value;
            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            try {
                for(var _iterator4 = Object.keys(data[twinBid1])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                    var metric = _step4.value;
                    metrics.add(metric);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    var multiMetric = metrics.size > 1;
    var series = [];
    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
    try {
        for(var _iterator5 = twinBids[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
            var twinBid2 = _step5.value;
            var slice1 = data[twinBid2];
            var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
            try {
                for(var _iterator6 = flattenTimeseriesSlice(slice1, {
                    multiMetric: multiMetric
                })[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                    var s = _step6.value;
                    series.push(_object_spread_props(_object_spread({}, s), {
                        twinBid: twinBid2,
                        label: multiTwin ? "".concat(s.label, " \xb7 ").concat(gymName(twinBid2, options)) : s.label
                    }));
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                        _iterator6.return();
                    }
                } finally{
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
            }
        } finally{
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }
    var isEmpty = series.length === 0 || series.every(function(s) {
        return s.points.length === 0;
    });
    return {
        series: series,
        isEmpty: isEmpty
    };
}
// src/charts/adapters/resolvePeakBands.ts
import { DateTime as DateTime3 } from "luxon";
var WEEKDAY_INDEX = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7
};
function resolvePeakBands(windows, opts) {
    var startMs = opts.startMs, endMs = opts.endMs, zone = opts.zone;
    if (windows.length === 0 || !(endMs > startMs)) return [];
    var bands = [];
    var day = DateTime3.fromMillis(startMs, {
        zone: zone
    }).startOf("day");
    var end = DateTime3.fromMillis(endMs, {
        zone: zone
    });
    var guard = 0;
    while(day < end && guard < 400){
        guard += 1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = windows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var w = _step.value;
                var weekdayIndex = WEEKDAY_INDEX[w.weekday];
                if (weekdayIndex === void 0 || day.weekday !== weekdayIndex) continue;
                var xMin = day.set({
                    hour: w.start_hour,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }).toMillis();
                var xMax = w.end_hour >= 24 ? day.plus({
                    days: 1
                }).startOf("day").toMillis() : day.set({
                    hour: w.end_hour,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }).toMillis();
                if (xMax > startMs && xMin < endMs) {
                    bands.push({
                        xMin: xMin,
                        xMax: xMax,
                        label: formatHourRange(w.start_hour, w.end_hour)
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        day = day.plus({
            days: 1
        });
    }
    return bands;
}
// src/charts/adapters/adaptNow.ts
function toVM(row) {
    return {
        bid: row.group_bid,
        label: row.group_label,
        groupType: row.group_type,
        headcount: row.avg_headcount,
        peakHeadcount: row.peak_headcount,
        capacity: row.capacity,
        trackedCapacity: row.tracked_capacity,
        utilisationPct: row.utilisation_pct,
        typicalPeakHeadcount: row.typical_peak_headcount,
        pctOfTypicalPeak: row.pct_of_typical_peak,
        minutesAgo: row.minutes_ago
    };
}
function adaptNow(envelope) {
    var _envelope_data;
    var rows = ((_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : []).map(toVM);
    return {
        rows: rows,
        isEmpty: rows.length === 0
    };
}
function pickNowGroup(vm, bid) {
    return vm.rows.find(function(r) {
        return r.bid === bid;
    });
}
// src/charts/adapters/adaptRanking.ts
function adaptRanking(envelope) {
    var _envelope_data;
    var rows = ((_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : []).map(function(r) {
        return {
            bid: r.group_bid,
            label: r.group_label,
            value: r.value
        };
    });
    return {
        rows: rows,
        isEmpty: rows.length === 0
    };
}
// src/charts/adapters/adaptEquipmentHealth.ts
function toVM2(row) {
    return {
        bid: row.entity_bid,
        equipment: row.equipment,
        zone: row.zone,
        baselinePct: row.baseline_utilisation,
        recentPct: row.recent_utilisation,
        deltaPp: row.utilisation_variation,
        isFlagged: row.is_flagged
    };
}
var NO_EVENT = {
    isEvent: false,
    flaggedTotal: 0,
    assessedTotal: 0,
    flaggedPct: 0
};
function adaptEquipmentHealth(envelope) {
    var _envelope_data;
    var raw = (_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : [];
    var rows = raw.map(toVM2);
    var first = raw[0];
    var siteWide = first ? {
        isEvent: first.is_site_wide_event,
        flaggedTotal: first.flagged_total,
        assessedTotal: first.assessed_total,
        flaggedPct: first.flagged_pct
    } : NO_EVENT;
    return {
        rows: rows,
        siteWide: siteWide,
        isEmpty: rows.length === 0
    };
}
// src/charts/adapters/adaptUsageBands.ts
var BUCKETS = [
    {
        key: "0_20",
        label: "0\u201320%"
    },
    {
        key: "20_40",
        label: "20\u201340%"
    },
    {
        key: "40_60",
        label: "40\u201360%"
    },
    {
        key: "60_80",
        label: "60\u201380%"
    },
    {
        key: "80_90",
        label: "80\u201390%"
    },
    {
        key: "90_plus",
        label: "90%+"
    }
];
var toBandValue = function(v) {
    return Math.round(v * 10) / 10;
};
var warnedHoursFallback = false;
function adaptUsageBands(row) {
    var unitMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "pct";
    if (!row) {
        return {
            groupLabel: "",
            bars: [],
            bandCount: BUCKETS.length,
            isEmpty: true
        };
    }
    if (unitMode === "hoursPerWeek") {
        var bands = row === null || row === void 0 ? void 0 : row.hours_per_week;
        if (bands && bands.length > 0) {
            var _Math;
            var coerce = function(o, i) {
                return Number.isFinite(o) && o >= 1 ? Math.round(o) : i + 1;
            };
            var resolved = bands.map(function(band, i) {
                return {
                    band: band,
                    order: coerce(band.bucket_order, i)
                };
            });
            if (new Set(resolved.map(function(r) {
                return r.order;
            })).size !== resolved.length) {
                resolved = bands.map(function(band, i) {
                    return {
                        band: band,
                        order: i + 1
                    };
                });
            }
            resolved.sort(function(a, b) {
                return a.order - b.order;
            });
            var bandCount = (_Math = Math).max.apply(_Math, _to_consumable_array(resolved.map(function(r) {
                return r.order;
            })).concat([
                BUCKETS.length
            ]));
            var bars2 = resolved.map(function(param) {
                var b = param.band, order = param.order;
                return {
                    label: b.band_label,
                    // Guard against a null/absent hours value on a drifted wire (typed non-nullable,
                    // but the wire is server-controlled) — a NaN bar would render broken.
                    value: typeof b.hours_per_week === "number" ? toBandValue(b.hours_per_week) : 0,
                    // Position by the band's own (coerced) bucket_order, NOT its array slot — robust to
                    // a sparse list; the value/label read off the band itself.
                    bandIndex: order - 1
                };
            });
            var _row_group_label;
            return {
                groupLabel: (_row_group_label = row === null || row === void 0 ? void 0 : row.group_label) !== null && _row_group_label !== void 0 ? _row_group_label : "",
                bars: bars2,
                bandCount: bandCount,
                isEmpty: false
            };
        }
        if (!warnedHoursFallback) {
            warnedHoursFallback = true;
            console.warn("adaptUsageBands: hoursPerWeek requested but the row has no hours_per_week list (non-daily grain?) \u2014 falling back to %-of-open-slots.");
        }
    }
    var _row_total_open_slots;
    var total = (_row_total_open_slots = row === null || row === void 0 ? void 0 : row.total_open_slots) !== null && _row_total_open_slots !== void 0 ? _row_total_open_slots : 0;
    if (!row || total <= 0) {
        var _row_group_label1;
        return {
            groupLabel: (_row_group_label1 = row === null || row === void 0 ? void 0 : row.group_label) !== null && _row_group_label1 !== void 0 ? _row_group_label1 : "",
            bars: [],
            bandCount: BUCKETS.length,
            isEmpty: true
        };
    }
    var bars = BUCKETS.map(function(b, i) {
        var _row_bands_b_key;
        return {
            label: b.label,
            // Coalesce a missing bucket key to 0 (partial envelope) rather than NaN. Percentages
            // keep whole-number display: a band is a share of open slots, and 0.1pp is noise, not
            // the sub-hour signal `toBandValue` exists to protect in hoursPerWeek mode.
            value: Math.round(((_row_bands_b_key = row.bands[b.key]) !== null && _row_bands_b_key !== void 0 ? _row_bands_b_key : 0) / total * 100),
            bandIndex: i
        };
    });
    return {
        groupLabel: row.group_label,
        bars: bars,
        bandCount: BUCKETS.length,
        isEmpty: false
    };
}
// src/charts/hooks/useTimeseries.ts
import { useQuery } from "@tanstack/react-query";
function useTimeseries(binding, context) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var provider = useChartsDataProvider();
    var _options_enabled;
    return useQuery({
        queryKey: [
            "charts",
            "timeseries",
            binding,
            context
        ],
        enabled: (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true,
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal, envelope;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                provider.fetch(binding, context, signal)
                            ];
                        case 1:
                            envelope = _state.sent();
                            return [
                                2,
                                adaptTimeseriesByTwin(envelope)
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
// src/charts/hooks/useCatalogue.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
function useCatalogueQuery(key, binding, context, adapt, enabled) {
    var provider = useChartsDataProvider();
    return useQuery2({
        queryKey: [
            "charts",
            key,
            binding,
            context
        ],
        enabled: enabled,
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal, envelope;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                provider.fetch(binding, context, signal)
                            ];
                        case 1:
                            envelope = _state.sent();
                            return [
                                2,
                                adapt(envelope)
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
function useNow(binding, context) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_enabled;
    return useCatalogueQuery("now", binding, context, adaptNow, (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true);
}
function useRanking(binding, context) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_enabled;
    return useCatalogueQuery("ranking", binding, context, adaptRanking, (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true);
}
function useEquipmentHealth(binding, context) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_enabled;
    return useCatalogueQuery("equipment_health", binding, context, adaptEquipmentHealth, (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true);
}
function useUsageBands(binding, context) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var provider = useChartsDataProvider();
    var _options_enabled;
    return useQuery2({
        queryKey: [
            "charts",
            "usage_bands",
            binding,
            context,
            options.bid
        ],
        enabled: (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true,
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal, envelope, _envelope_data, rows, row;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                provider.fetch(binding, context, signal)
                            ];
                        case 1:
                            envelope = _state.sent();
                            rows = (_envelope_data = envelope === null || envelope === void 0 ? void 0 : envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : [];
                            row = options.bid ? rows.find(function(r) {
                                return r.group_bid === options.bid;
                            }) : rows[0];
                            return [
                                2,
                                adaptUsageBands(row)
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
// src/charts/components/EmptyState/EmptyState.tsx
import { EmptyInline } from "@repo/design-system";
import { jsx as jsx3 } from "react/jsx-runtime";
var EmptyState = function(param) {
    var message = param.message, _param_role = param.role, role = _param_role === void 0 ? "status" : _param_role, className = param.className;
    return /* @__PURE__ */ jsx3(EmptyInline, {
        message: message,
        role: role,
        className: className
    });
};
var EmptyState_default = EmptyState;
// src/charts/components/BusyOverlay/BusyOverlay.tsx
import styled from "styled-components";
import { chartTheme as chartTheme5, space, radius, typeRole } from "@repo/design-tokens";
import { SkeletonPanel } from "@repo/design-system";
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Wrap = styled.div(_templateObject());
var Scrim = styled.div(_templateObject1(), chartTheme5.states.stale.overlay);
var StaleTint = styled.div(_templateObject2(), chartTheme5.states.stale.overlay);
var StaleBadge = styled.span(_templateObject3(), space[2], space[2], space[1], space[2], radius.sm, chartTheme5.states.empty.surface, chartTheme5.states.stale.text, typeRole.caption2.fontFamily, typeRole.caption2.fontSize);
var SkeletonHost = styled.div(_templateObject4(), space[12]);
var BusyOverlay = function(param) {
    var _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_skeleton = param.skeleton, skeleton = _param_skeleton === void 0 ? false : _param_skeleton, _param_staleLabel = param.staleLabel, staleLabel = _param_staleLabel === void 0 ? "Stale" : _param_staleLabel, children = param.children, className = param.className;
    if (skeleton) {
        return(// `aria-busy` belongs on the container that owns the wait, which is why the DS skeleton
        // shapes are `aria-hidden` and carry no text: announcing a placeholder would read as
        // content. Without this, a screen-reader user gets silence rather than "busy".
        /* @__PURE__ */ jsx4(Wrap, {
            className: className,
            "aria-busy": "true",
            children: /* @__PURE__ */ jsx4(SkeletonHost, {
                "data-testid": "chart-skeleton",
                children: /* @__PURE__ */ jsx4(SkeletonPanel, {
                    tall: true
                })
            })
        }));
    }
    return /* @__PURE__ */ jsxs3(Wrap, {
        className: className,
        "aria-busy": loading ? "true" : void 0,
        children: [
            children,
            stale && !loading && /* @__PURE__ */ jsxs3(Fragment, {
                children: [
                    /* @__PURE__ */ jsx4(StaleTint, {
                        "aria-hidden": "true"
                    }),
                    /* @__PURE__ */ jsx4(StaleBadge, {
                        role: "status",
                        children: staleLabel
                    })
                ]
            }),
            loading && /* @__PURE__ */ jsx4(Scrim, {
                "aria-live": "polite",
                children: /* @__PURE__ */ jsx4(TLSpinner_default, {
                    props: {
                        "aria-label": "Loading"
                    }
                })
            })
        ]
    });
};
var BusyOverlay_default = BusyOverlay;
// src/charts/components/KPICard/KPICard.tsx
import styled2 from "styled-components";
import { semantic, semanticColor, typeRole as typeRole2 } from "@repo/design-tokens";
import { KpiLayout, KpiLabel, KpiValue, KpiSub, KpiDeltaArrow, kpiToneClass } from "@repo/design-system";
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var SIZE_OVERRIDE = {
    sm: {
        fontSize: typeRole2.title3.fontSize,
        lineHeight: typeRole2.title3.lineHeight
    },
    md: null,
    lg: {
        fontSize: typeRole2.title1.fontSize,
        lineHeight: typeRole2.title1.lineHeight
    }
};
var Value = styled2(KpiValue)(_templateObject5(), function(param) {
    var $size = param.$size;
    var o = SIZE_OVERRIDE[$size];
    return o ? "font-size: ".concat(o.fontSize, "; line-height: ").concat(o.lineHeight, ";") : "";
}, function(param) {
    var $highlight = param.$highlight;
    return $highlight ? "color: ".concat(semantic.interactive.accent, ";") : "";
});
var Subtext = styled2(KpiSub)(_templateObject6());
var ErrorText = styled2.div(_templateObject7(), typeRole2.caption1.fontFamily, typeRole2.caption1.fontSize, semanticColor.error);
function deltaDirection(delta) {
    if (delta > 0) return "up";
    if (delta < 0) return "down";
    return "none";
}
function deltaTone(delta, invert) {
    if (delta === 0) return "neutral";
    var good = delta > 0 ? !invert : invert;
    return good ? "positive" : "negative";
}
function deltaAriaLabel(delta, direction, suffix) {
    var word = direction === "up" ? "up " : direction === "down" ? "down " : "";
    return "".concat(word).concat(Math.abs(delta)).concat(suffix);
}
var KPICard = function(param) {
    var label = param.label, value = param.value, unit = param.unit, delta = param.delta, _param_deltaSuffix = param.deltaSuffix, deltaSuffix = _param_deltaSuffix === void 0 ? "" : _param_deltaSuffix, _param_invertDelta = param.invertDelta, invertDelta = _param_invertDelta === void 0 ? false : _param_invertDelta, subtext = param.subtext, _param_highlight = param.highlight, highlight = _param_highlight === void 0 ? false : _param_highlight, denominatorValue = param.denominatorValue, _param_size = param.size, size = _param_size === void 0 ? "md" : _param_size, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx5(ErrorText, {
            role: "alert",
            children: error
        });
    } else if (value === null || value === void 0 || value === "") {
        body = /* @__PURE__ */ jsx5(EmptyState_default, {
            message: "No data"
        });
    } else {
        var hasDelta = typeof delta === "number";
        var tone = hasDelta ? deltaTone(delta, invertDelta) : "neutral";
        var direction = hasDelta ? deltaDirection(delta) : "none";
        var denomStr = denominatorValue === void 0 || denominatorValue === null ? "" : String(denominatorValue).trim();
        var isFraction = denomStr !== "" && denomStr !== "0";
        var ariaLabel = isFraction ? "".concat(label, ": ").concat(value, " / ").concat(denomStr) : "".concat(label, ": ").concat(value).concat(unit !== null && unit !== void 0 ? unit : "");
        body = /* @__PURE__ */ jsxs4(Fragment2, {
            children: [
                /* @__PURE__ */ jsx5(KpiLabel, {
                    children: label
                }),
                /* @__PURE__ */ jsx5(Value, {
                    $size: size,
                    $highlight: highlight,
                    "aria-label": ariaLabel,
                    children: isFraction ? "".concat(value, " / ").concat(denomStr) : /* @__PURE__ */ jsxs4(Fragment2, {
                        children: [
                            value,
                            unit ? /* @__PURE__ */ jsx5("small", {
                                children: unit
                            }) : null
                        ]
                    })
                }),
                subtext ? /* @__PURE__ */ jsx5(Subtext, {
                    "data-kpi-slot": "subtext",
                    children: subtext
                }) : null,
                hasDelta && /* @__PURE__ */ jsx5(KpiSub, {
                    "data-kpi-slot": "delta",
                    children: /* @__PURE__ */ jsxs4("span", {
                        className: kpiToneClass(tone),
                        "aria-label": deltaAriaLabel(delta, direction, deltaSuffix),
                        children: [
                            /* @__PURE__ */ jsx5(KpiDeltaArrow, {
                                $direction: direction
                            }),
                            " ".concat(Math.abs(delta)).concat(deltaSuffix)
                        ]
                    })
                })
            ]
        });
    }
    return /* @__PURE__ */ jsx5(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx5(KpiLayout, {
            className: "v-kpi",
            children: body
        })
    });
};
// src/charts/components/TimeSeriesChart/TimeSeriesChart.tsx
import { useMemo } from "react";
import styled3 from "styled-components";
import { space as space2, typeRole as typeRole3, semanticColor as semanticColor2, chartTheme as chartTheme6 } from "@repo/design-tokens";
import { jsx as jsx6 } from "react/jsx-runtime";
var formatHourTick = function(h) {
    return "".concat(String(Math.round(h)).padStart(2, "0"), ":00");
};
var Container = styled3.div(_templateObject8(), space2[12]);
var ErrorText2 = styled3.div(_templateObject9(), space2[4], typeRole3.caption1.fontFamily, typeRole3.caption1.fontSize, semanticColor2.error);
function isEmptySeries(series) {
    return series.length === 0 || series.every(function(s) {
        return s.points.every(function(p) {
            return p.y === null;
        });
    });
}
function ariaSummary(series, fmtX, metricLabel, unit, mode, profile, precision) {
    var count = 0;
    var firstX = Infinity;
    var lastX = -Infinity;
    var min = Infinity;
    var max = -Infinity;
    var latest = null;
    var latestX = -Infinity;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = s.points[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var p = _step1.value;
                    if (p.x < firstX) firstX = p.x;
                    if (p.x > lastX) lastX = p.x;
                    if (p.y !== null) {
                        count += 1;
                        if (p.y < min) min = p.y;
                        if (p.y > max) max = p.y;
                        if (p.x >= latestX) {
                            latestX = p.x;
                            latest = p.y;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (count === 0) return "".concat(metricLabel, ": no data");
    var seriesCount = series.length > 1 ? "".concat(series.length, " series, ") : "";
    var kind = profile ? "hour-of-day profile" : "".concat(mode, " chart");
    var say = function(v) {
        return formatMeasurement(v, precision, unit);
    };
    var latestText = latest === null ? "no data" : say(latest);
    return "".concat(metricLabel, " ").concat(kind, ". ").concat(seriesCount).concat(fmtX(firstX), " to ").concat(fmtX(lastX), ". Min ").concat(say(min), ", max ").concat(say(max), ", latest ").concat(latestText, ".").concat(perSeries(series, precision, unit));
}
var ARIA_SERIES_CAP = 12;
function perSeries(series, precision, unit) {
    if (series.length < 2) return "";
    var withValues = series.map(function(s) {
        var latest = null;
        var latestX = -Infinity;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = s.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var p = _step.value;
                if (p.y !== null && p.x >= latestX) {
                    latestX = p.x;
                    latest = p.y;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            label: s.label,
            latest: latest
        };
    }).filter(function(s) {
        return s.latest !== null;
    });
    if (withValues.length === 0) return "";
    var shown = withValues.slice(0, ARIA_SERIES_CAP);
    var parts = shown.map(function(s) {
        return "".concat(s.label, " ").concat(formatMeasurement(s.latest, precision, unit));
    });
    var rest = withValues.length - shown.length;
    var tail = rest > 0 ? ", and ".concat(rest, " more") : "";
    return " Latest by series: ".concat(parts.join("; ")).concat(tail, ".");
}
var TimeSeriesChart = function(param) {
    var series = param.series, grain = param.grain, zone = param.zone, _param_mode = param.mode, mode = _param_mode === void 0 ? "line" : _param_mode, _param_profile = param.profile, profile = _param_profile === void 0 ? false : _param_profile, _param_metricLabel = param.metricLabel, metricLabel = _param_metricLabel === void 0 ? "Value" : _param_metricLabel, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, _param_precision = param.precision, precision = _param_precision === void 0 ? 1 : _param_precision, xAxisLabel = param.xAxisLabel, _param_showPeakBands = param.showPeakBands, showPeakBands = _param_showPeakBands === void 0 ? false : _param_showPeakBands, peakWindows = param.peakWindows, offIndices = param.offIndices, legend = param.legend, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var empty = isEmptySeries(series);
    var config = useMemo(function() {
        var fmtTick = profile ? formatHourTick : makeTimeTickCallback(grain, zone);
        var styles = buildSeriesDatasets(series.length, {
            offIndices: offIndices ? new Set(offIndices) : void 0
        });
        var multi = series.length > 1;
        var topAlpha = multi ? chartTheme6.base.line.fillTopAlphaMulti : chartTheme6.base.line.fillTopAlpha;
        var datasets = series.map(function(s, i) {
            return {
                label: s.label,
                data: s.points,
                borderColor: styles[i].borderColor,
                // Line mode carries the soft area gradient; the flat hue stays for bars.
                backgroundColor: mode === "line" ? buildAreaFill(styles[i].backgroundColor, topAlpha) : styles[i].backgroundColor,
                fill: mode === "line",
                pointBackgroundColor: styles[i].pointBackgroundColor,
                // Bead-bulge points (brief 17 §2): the shared geometry lives in `Chart.defaults`
                // (`applyChartTheme`), so only the white hover ring's colour is restated here — it is
                // the one point property Chart.js will not inherit onto a per-dataset point.
                pointHoverBorderColor: chartTheme6.base.point.hoverRingColor,
                // Overnight/closed gaps are real and must stay holes, not interpolated lines.
                spanGaps: false
            };
        });
        var peakBands = [];
        if (!profile && showPeakBands && peakWindows && peakWindows.length > 0) {
            var startMs = Infinity;
            var endMs = -Infinity;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var s = _step.value;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = s.points[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var p = _step1.value;
                            if (p.x < startMs) startMs = p.x;
                            if (p.x > endMs) endMs = p.x;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (Number.isFinite(startMs) && Number.isFinite(endMs)) {
                peakBands = resolvePeakBands(peakWindows, {
                    startMs: startMs,
                    endMs: endMs,
                    zone: zone
                });
            }
        }
        var axisTitleFont = {
            family: chartTheme6.axis.label.fontFamily,
            size: parseInt(chartTheme6.axis.label.fontSize, 10)
        };
        var yTitleText = unit === "%" ? "".concat(metricLabel, " ").concat(unit) : metricLabel;
        var yTitle = {
            display: Boolean(metricLabel) && metricLabel !== "Value",
            text: yTitleText,
            color: chartTheme6.axis.title,
            font: axisTitleFont
        };
        var xTitle = {
            display: Boolean(xAxisLabel),
            text: xAxisLabel !== null && xAxisLabel !== void 0 ? xAxisLabel : "",
            color: chartTheme6.axis.title,
            font: axisTitleFont
        };
        var xMin;
        var xMax;
        if (profile) {
            var lo = Infinity;
            var hi = -Infinity;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = series[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var s1 = _step2.value;
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = s1.points[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var p1 = _step3.value;
                            if (typeof p1.y === "number" && Number.isFinite(p1.y)) {
                                if (p1.x < lo) lo = p1.x;
                                if (p1.x > hi) hi = p1.x;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (Number.isFinite(lo) && Number.isFinite(hi) && lo !== hi) {
                xMin = lo;
                xMax = hi;
            }
        }
        return {
            type: mode,
            data: {
                datasets: datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                parsing: false,
                // On MULTI-series, one hover reads every series at that x (brief 17 §2) — the point
                // of the bulge-and-hover read-off is comparing series at an instant. Single series
                // keeps `nearest`, where an index mode would highlight a point the cursor is not on.
                interaction: multi ? {
                    mode: "index",
                    intersect: false
                } : {
                    mode: "nearest",
                    intersect: false
                },
                scales: {
                    x: {
                        type: "linear",
                        min: xMin,
                        max: xMax,
                        title: xTitle,
                        // x grid hidden, no axis border (brief 17 §0). Per-axis, so it cannot live in
                        // `Chart.defaults.scale`, which applies to every axis at once.
                        grid: {
                            display: chartTheme6.base.grid.xDisplay
                        },
                        border: {
                            display: chartTheme6.base.grid.borderDisplay
                        },
                        ticks: {
                            callback: function(value) {
                                return fmtTick(value);
                            },
                            maxRotation: 0,
                            autoSkip: true
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: yTitle,
                        border: {
                            display: chartTheme6.base.grid.borderDisplay
                        }
                    }
                },
                plugins: {
                    // Default: on for multi-series, off for one (the axis already says everything).
                    // `legend` overrides either way — one boolean, position/style locked (item T).
                    legend: buildLegend(legend !== null && legend !== void 0 ? legend : multi),
                    // 🚨 WITHOUT THIS THE TOOLTIP TITLED ITSELF WITH A RAW EPOCH INTEGER — see
                    // `buildValueTooltip`. `fmtTick` is the SAME formatter the x ticks use two blocks up,
                    // passed rather than re-derived, so the tooltip cannot disagree with the axis under it.
                    tooltip: buildValueTooltip({
                        formatX: fmtTick,
                        unit: unit,
                        precision: precision
                    }),
                    peakBands: {
                        bands: peakBands
                    }
                }
            }
        };
    }, [
        series,
        grain,
        zone,
        mode,
        profile,
        metricLabel,
        unit,
        precision,
        xAxisLabel,
        showPeakBands,
        peakWindows,
        offIndices,
        legend
    ]);
    var setCanvas = useChartJs(config);
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx6(ErrorText2, {
            role: "alert",
            children: error
        });
    } else if (empty) {
        body = /* @__PURE__ */ jsx6(EmptyState_default, {});
    } else {
        body = /* @__PURE__ */ jsx6("canvas", {
            ref: setCanvas,
            role: "img",
            "aria-label": ariaSummary(series, profile ? formatHourTick : makeTimeTickCallback(grain, zone), metricLabel, unit, mode, profile, precision)
        });
    }
    return /* @__PURE__ */ jsx6(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx6(Container, {
            children: body
        })
    });
};
// src/charts/components/EntitySpotlight/EntitySpotlight.tsx
import styled4 from "styled-components";
import { brand, chartTheme as chartTheme7, ink, INK_RAMP, motion, radius as radius2, rgba as rgba2, semantic as semantic2, space as space3, typeRole as typeRole4 } from "@repo/design-tokens";
// src/charts/components/EntitySpotlight/isSpotlightableBid.ts
function isSpotlightableBid(bid) {
    if (typeof bid !== "string") return false;
    var trimmed = bid.trim();
    if (!trimmed) return false;
    if (trimmed.includes(":")) return false;
    return true;
}
// src/charts/components/EntitySpotlight/EntitySpotlight.tsx
import { Fragment as Fragment3, jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var Chip = styled4.button(_templateObject10(), space3[2], radius2.pill, semantic2.border.default, semantic2.surface.base, chartTheme7.segmented.onPillShadow, ink[1], typeRole4.caption1.fontFamily, typeRole4.caption1.fontSize, motion.durFast, motion.easeUi, motion.durFast, motion.easeUi, motion.durFast, motion.easeUi, ink[4], motion.durFast, motion.easeUi, rgba2(brand.cyan, 0.14), rgba2(brand.cyan, 0.25), INK_RAMP[0], INK_RAMP[0], semantic2.interactive.focusRing);
var Plain = styled4.button(_templateObject11(), ink[1], typeRole4.caption1.fontFamily, typeRole4.caption1.fontSize, motion.durFast, motion.easeUi, ink[5], motion.durFast, motion.easeUi, INK_RAMP[0], INK_RAMP[0], semantic2.interactive.focusRing, radius2.sm);
var ArrowsToDotGlyph = function() {
    return /* @__PURE__ */ jsxs5("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        "aria-hidden": "true",
        children: [
            /* @__PURE__ */ jsx7("circle", {
                cx: "8",
                cy: "8",
                r: "1.5",
                fill: "currentColor",
                stroke: "none"
            }),
            /* @__PURE__ */ jsx7("path", {
                d: "M8 1v3.2M6.6 2.8 8 4.2l1.4-1.4M8 15v-3.2M6.6 13.2 8 11.8l1.4 1.4M1 8h3.2M2.8 6.6 4.2 8l-1.4 1.4M15 8h-3.2M13.2 6.6 11.8 8l1.4 1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var LocateGlyph = function() {
    return /* @__PURE__ */ jsxs5("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.4",
        "aria-hidden": "true",
        children: [
            /* @__PURE__ */ jsx7("circle", {
                cx: "8",
                cy: "8",
                r: "3.2"
            }),
            /* @__PURE__ */ jsx7("path", {
                d: "M8 1v2.4M8 12.6V15M1 8h2.4M12.6 8H15",
                strokeLinecap: "round"
            })
        ]
    });
};
var EntitySpotlight = function(param) {
    var bid = param.bid, _param_variant = param.variant, variant = _param_variant === void 0 ? "A" : _param_variant, children = param.children, onActivate = param.onActivate, onHover = param.onHover, className = param.className;
    if (!isSpotlightableBid(bid)) {
        return /* @__PURE__ */ jsx7(Fragment3, {
            children: children
        });
    }
    var handlers = {
        type: "button",
        className: className,
        /**
     * ⛔ NO bID IN THE TOOLTIP. Repo invariant row 35: a bID is an opaque catalogue key and is
     * never displayed — every wrapper here falls back to an em dash rather than print one, which
     * is what made `title={`Show ${bid} in the twin`}` the single place the rule leaked. It put
     * `eqt:137` under the cursor on every ranked and suggestion row (backlogged 2026-09-02 by the
     * U17 review; closed here because it is the same string Peter saw, in the same component, in
     * the same pass).
     *
     * ⚠️ THE ACCESSIBLE NAME IS UNCHANGED, and was never the problem — it comes from `children`,
     * i.e. the visible (and, since U17, qualified) label. This attribute only ever added a
     * sighted-hover affordance hint, and it still does; it simply no longer names an internal key.
     * U17's qualifiers are now what tells two same-named machines apart, which is the one job the
     * bid was incidentally doing here.
     */ title: "Show in the twin",
        onClick: function() {
            return onActivate(bid);
        },
        onMouseEnter: onHover ? function() {
            return onHover(bid);
        } : void 0,
        onMouseLeave: onHover ? function() {
            return onHover(null);
        } : void 0,
        onFocus: onHover ? function() {
            return onHover(bid);
        } : void 0,
        onBlur: onHover ? function() {
            return onHover(null);
        } : void 0
    };
    return variant === "B" ? /* @__PURE__ */ jsxs5(Plain, _object_spread_props(_object_spread({}, handlers), {
        "data-spotlight-variant": "B",
        children: [
            /* @__PURE__ */ jsx7("span", {
                children: children
            }),
            /* @__PURE__ */ jsx7(ArrowsToDotGlyph, {})
        ]
    })) : /* @__PURE__ */ jsxs5(Chip, _object_spread_props(_object_spread({}, handlers), {
        "data-spotlight-variant": "A",
        children: [
            /* @__PURE__ */ jsx7(LocateGlyph, {}),
            /* @__PURE__ */ jsx7("span", {
                children: children
            })
        ]
    }));
};
// src/charts/components/RankedRows/RankedRows.tsx
import { useMemo as useMemo2 } from "react";
import styled5 from "styled-components";
import { Inline, InlineStack } from "@repo/design-system";
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var List = styled5.ul(_templateObject12());
var Item = styled5.li(_templateObject13());
var UNMEASURABLE_DISPLAY = /* @__PURE__ */ jsxs6(Fragment4, {
    children: [
        /* @__PURE__ */ jsx8("span", {
            "aria-hidden": "true",
            children: "\u2014"
        }),
        /* @__PURE__ */ jsx8("span", {
            style: visuallyHidden,
            children: "Not measurable"
        })
    ]
});
var isMeasurable = function(value) {
    return typeof value === "number" && Number.isFinite(value);
};
function resolveScale(rows, maxValue, unit) {
    if (typeof maxValue === "number" && Number.isFinite(maxValue) && maxValue > 0) {
        return maxValue;
    }
    if (unit === "%") return 100;
    var max = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            if (isMeasurable(row.value) && row.value > max) max = row.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return max > 0 ? max : 100;
}
var RankedRows = function(param) {
    var rows = param.rows, _param_unit = param.unit, unit = _param_unit === void 0 ? "%" : _param_unit, maxValue = param.maxValue, _param_precision = param.precision, precision = _param_precision === void 0 ? 0 : _param_precision, onActivate = param.onActivate, onHover = param.onHover, _param_inScope = param.inScope, inScope = _param_inScope === void 0 ? true : _param_inScope, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var scale = useMemo2(function() {
        return resolveScale(rows, maxValue, unit);
    }, [
        rows,
        maxValue,
        unit
    ]);
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx8(EmptyState_default, {
            message: error,
            role: "alert"
        });
    } else if (rows.length === 0) {
        body = /* @__PURE__ */ jsx8(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsx8(InlineStack, {
            inScope: inScope,
            children: /* @__PURE__ */ jsx8(List, {
                role: "list",
                children: rows.map(function(row) {
                    var label = onActivate ? /* @__PURE__ */ jsx8(EntitySpotlight, {
                        bid: row.bid,
                        onActivate: onActivate,
                        onHover: onHover,
                        children: row.label
                    }) : row.label;
                    if (!isMeasurable(row.value)) {
                        return /* @__PURE__ */ jsx8(Item, {
                            role: "listitem",
                            children: /* @__PURE__ */ jsx8(Inline, {
                                label: label,
                                display: UNMEASURABLE_DISPLAY,
                                untracked: true,
                                extent: 0
                            })
                        }, row.bid);
                    }
                    var pct3 = Math.min(100, Math.max(0, row.value / scale * 100));
                    var busy = row.colorValue;
                    var colorPct = typeof busy === "number" && Number.isFinite(busy) ? Math.min(100, Math.max(0, busy)) : pct3;
                    return /* @__PURE__ */ jsx8(Item, {
                        role: "listitem",
                        children: /* @__PURE__ */ jsx8(Inline, {
                            label: label,
                            display: "".concat(row.value.toFixed(safePrecision(precision))).concat(unit),
                            percent: colorPct,
                            extent: pct3
                        })
                    }, row.bid);
                })
            })
        });
    }
    return /* @__PURE__ */ jsx8(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: body
    });
};
// src/charts/components/KPICardLive/KPICardLive.tsx
import styled6 from "styled-components";
import { KpiLayout as KpiLayout2, KpiLabel as KpiLabel2, KpiValue as KpiValue2, KpiSub as KpiSub2, KpiSpark, Sparkline } from "@repo/design-system";
import { Fragment as Fragment5, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var SubLine = styled6(KpiSub2)(_templateObject14());
var KPICardLive = function(param) {
    var label = param.label, value = param.value, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, subline = param.subline, minutesAgo = param.minutesAgo, sparklinePoints = param.sparklinePoints, _param_onGlass = param.onGlass, onGlass = _param_onGlass === void 0 ? false : _param_onGlass, _param_renderLabel = param.renderLabel, renderLabel = _param_renderLabel === void 0 ? true : _param_renderLabel, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var hasSparkline = Boolean(sparklinePoints && sparklinePoints.length > 1);
    var heading = renderLabel && label ? /* @__PURE__ */ jsx9(KpiLabel2, {
        children: label
    }) : null;
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx9(EmptyState_default, {
            message: error,
            role: "alert"
        });
    } else if (value === null || value === void 0) {
        body = /* @__PURE__ */ jsx9(EmptyState_default, {
            message: "No recent data \u2014 gym may be closed"
        });
    } else {
        body = /* @__PURE__ */ jsxs7(Fragment5, {
            children: [
                /* @__PURE__ */ jsxs7(KpiValue2, {
                    "aria-label": "".concat(label, ": ").concat(Math.round(value)).concat(unit),
                    children: [
                        Math.round(value),
                        unit ? /* @__PURE__ */ jsx9("small", {
                            children: unit
                        }) : null
                    ]
                }),
                subline ? /* @__PURE__ */ jsx9(SubLine, {
                    "data-kpi-slot": "subline",
                    children: subline
                }) : null,
                minutesAgo !== void 0 ? /* @__PURE__ */ jsxs7(SubLine, {
                    "data-kpi-slot": "refreshed",
                    children: [
                        "Refreshed ",
                        minutesAgo,
                        "m ago"
                    ]
                }) : null,
                hasSparkline ? /* @__PURE__ */ jsx9(KpiSpark, {
                    children: /* @__PURE__ */ jsx9(Sparkline, {
                        values: sparklinePoints,
                        size: "small",
                        fluid: true,
                        fill: true,
                        onGlass: onGlass,
                        ariaLabel: "".concat(label, " trend so far today")
                    })
                }) : null
            ]
        });
    }
    return /* @__PURE__ */ jsx9(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsxs7(KpiLayout2, {
            className: "v-kpi",
            $hasSparkline: hasSparkline,
            children: [
                heading,
                body
            ]
        })
    });
};
// src/charts/components/EquipmentCheckTable/EquipmentCheckTable.tsx
import styled7 from "styled-components";
import { inkOn, semantic as semantic3, typeRole as typeRole5 } from "@repo/design-tokens";
import { Table, ValueCell } from "@repo/design-system";
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var Delta = styled7.span(_templateObject15(), typeRole5.body1Strong.fontWeight, function(param) {
    var $tone = param.$tone;
    return $tone === "drop" ? inkOn.butter : semantic3.text.body;
});
var DeltaArrow = function(param) {
    var $dir = param.$dir;
    return /* @__PURE__ */ jsx10("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 12 12",
        "aria-hidden": "true",
        focusable: "false",
        children: /* @__PURE__ */ jsx10("path", {
            d: $dir === "up" ? "M6 10V2.6M2.6 6L6 2.6L9.4 6" : "M6 2v7.4M9.4 6L6 9.4L2.6 6",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var pct = function(v) {
    return v === null ? "\u2014" : "".concat(Math.round(v), "%");
};
function equipmentCheckColumns(onActivate, onHover) {
    var spotlightVariant = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "A";
    return [
        {
            key: "equipment",
            header: "Equipment",
            // The subject of the row: the DS floor, and the lion's share of any surplus.
            width: "minmax(40px, 2.4fr)",
            render: function(row) {
                return onActivate ? /* @__PURE__ */ jsx10(EntitySpotlight, {
                    bid: row.bid,
                    variant: spotlightVariant,
                    onActivate: onActivate,
                    onHover: onHover,
                    children: row.equipment
                }) : row.equipment;
            }
        },
        {
            key: "zone",
            header: "Zone",
            width: "minmax(30px, 1.6fr)",
            render: function(row) {
                return row.zone;
            }
        },
        {
            key: "baseline",
            // `Normal`, not `Normal %` — the values carry their own `%`. See the width note above.
            header: "Normal",
            align: "right",
            // Floor = the measured value width; growth stops at the measured header width.
            width: "minmax(28px, 44px)",
            render: function(row) {
                return pct(row.baselinePct);
            }
        },
        {
            // The ramped column, so it carries the `.vcell` end-dot (brief 18 §3).
            key: "recent",
            header: "Recent",
            align: "right",
            // A shade wider than Normal: this column also carries the `.vcell` end-dot.
            width: "minmax(30px, 50px)",
            render: function(row) {
                return /* @__PURE__ */ jsx10(ValueCell, {
                    children: pct(row.recentPct)
                });
            }
        },
        {
            key: "delta",
            header: "\u0394pp",
            align: "right",
            // ⚠️ NEVER LET THIS ONE SHRINK INTO ITS CONTENT. Its painted width measured 22px (arrow +
            // up to two digits); the 26px floor keeps four pixels of clearance at the narrowest walked
            // width, and the 28px limit is its header. W1 is the standing guard on exactly this.
            width: "minmax(26px, 28px)",
            render: function(row) {
                var d = row.deltaPp;
                if (d === null) return "\u2014";
                var rounded = Math.round(d);
                var tone = rounded < 0 ? "drop" : rounded > 0 ? "rise" : "flat";
                var direction = rounded < 0 ? "down" : rounded > 0 ? "up" : null;
                var magnitude = Math.abs(rounded);
                var ariaLabel = direction ? "".concat(direction, " ").concat(magnitude, " percentage points") : "".concat(magnitude, " percentage points");
                return /* @__PURE__ */ jsxs8(Delta, {
                    $tone: tone,
                    "aria-label": ariaLabel,
                    children: [
                        direction ? /* @__PURE__ */ jsx10(DeltaArrow, {
                            $dir: direction
                        }) : null,
                        magnitude
                    ]
                });
            }
        }
    ];
}
var EquipmentCheckTable = function(param) {
    var rows = param.rows, onActivate = param.onActivate, onHover = param.onHover, _param_spotlightVariant = param.spotlightVariant, spotlightVariant = _param_spotlightVariant === void 0 ? "A" : _param_spotlightVariant, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No equipment to check" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    return /* @__PURE__ */ jsx10(Table, {
        className: className,
        columns: equipmentCheckColumns(onActivate, onHover, spotlightVariant),
        data: rows,
        keyExtractor: function(row) {
            return row.bid;
        },
        colourMode: "ramp",
        valueFor: function(row) {
            var _row_recentPct;
            return (_row_recentPct = row.recentPct) !== null && _row_recentPct !== void 0 ? _row_recentPct : 0;
        },
        resizable: false,
        loading: loading,
        error: error,
        emptyMessage: emptyMessage
    });
};
// src/charts/components/ComparisonTable/ComparisonTable.tsx
import styled8 from "styled-components";
import { chartTheme as chartTheme8, semantic as semantic4, space as space4, typeRole as typeRole6 } from "@repo/design-tokens";
import { Table as Table2 } from "@repo/design-system";
import { Fragment as Fragment6, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var ChipWrap = styled8.span(_templateObject16(), space4[2]);
var ChipValue = styled8.span(_templateObject17());
var Swatch = styled8.span(_templateObject18());
var SeriesColorChip = function(param) {
    var color = param.color, children = param.children;
    return /* @__PURE__ */ jsxs9(ChipWrap, {
        children: [
            /* @__PURE__ */ jsx11(Swatch, {
                "aria-hidden": "true",
                "data-color": color,
                style: {
                    background: color
                }
            }),
            /* @__PURE__ */ jsx11(ChipValue, {
                children: children
            })
        ]
    });
};
var Delta2 = styled8.span(_templateObject19(), typeRole6.body1Strong.fontWeight, function(param) {
    var $tone = param.$tone;
    return $tone === "positive" ? semantic4.text.success : $tone === "negative" ? semantic4.text.error : semantic4.text.body;
});
function resolveTone(d, mode) {
    if (mode === "none" || d === 0) return "neutral";
    var good = d > 0 ? mode === "up-good" : mode === "down-good";
    return good ? "positive" : "negative";
}
var NAME_FLOOR = "120px";
var nameTrack = "minmax(".concat(NAME_FLOOR, ", 3fr)");
var valueTrack = "1fr";
var MISSING = "\u2014";
var clampPrecision = function(precision) {
    return typeof precision === "number" && Number.isFinite(precision) ? Math.min(20, Math.max(0, Math.trunc(precision))) : 0;
};
var formatValue = function(v) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", precision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (v === null || v === void 0 || !Number.isFinite(v)) return MISSING;
    var p = clampPrecision(precision);
    var text = v.toFixed(p);
    return "".concat(Number(text) === 0 ? 0..toFixed(p) : text).concat(unit);
};
var cellContent = function(text) {
    return text === MISSING ? /* @__PURE__ */ jsxs9(Fragment6, {
        children: [
            /* @__PURE__ */ jsx11("span", {
                "aria-hidden": "true",
                children: MISSING
            }),
            /* @__PURE__ */ jsx11("span", {
                style: visuallyHidden,
                children: "No data"
            })
        ]
    }) : text;
};
var ComparisonTable = function(param) {
    var rows = param.rows, _param_labelHeader = param.labelHeader, labelHeader = _param_labelHeader === void 0 ? "Item" : _param_labelHeader, _param_showLabelHeader = param.showLabelHeader, showLabelHeader = _param_showLabelHeader === void 0 ? false : _param_showLabelHeader, labelWidth = param.labelWidth, ariaLabel = param.ariaLabel, _param_aLabel = param.aLabel, aLabel = _param_aLabel === void 0 ? "A" : _param_aLabel, _param_bLabel = param.bLabel, bLabel = _param_bLabel === void 0 ? "B" : _param_bLabel, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, _param_precision = param.precision, precision = _param_precision === void 0 ? 0 : _param_precision, tmp = param.deltaTone, deltaTone3 = tmp === void 0 ? "none" : tmp, _param_spotlightVariant = param.spotlightVariant, spotlightVariant = _param_spotlightVariant === void 0 ? "A" : _param_spotlightVariant, onActivate = param.onActivate, onHover = param.onHover, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var unitOf = function(row) {
        var _row_unit;
        return (_row_unit = row.unit) !== null && _row_unit !== void 0 ? _row_unit : unit;
    };
    var precisionOf = function(row) {
        var _row_precision;
        return (_row_precision = row.precision) !== null && _row_precision !== void 0 ? _row_precision : precision;
    };
    var columns = [
        {
            key: "label",
            // Visible only on request. A table of ENTITIES needs no column title (the DS's own treatment is
            // an empty head cell); a table of METRICS does, and a blank heading above five metric names
            // reads as an oversight. Either way the header TEXT exists for a screen reader.
            header: showLabelHeader ? labelHeader : /* @__PURE__ */ jsx11("span", {
                style: visuallyHidden,
                children: labelHeader
            }),
            width: labelWidth !== null && labelWidth !== void 0 ? labelWidth : nameTrack,
            render: function(row) {
                return onActivate && row.bid ? /* @__PURE__ */ jsx11(EntitySpotlight, {
                    bid: row.bid,
                    variant: spotlightVariant,
                    onActivate: onActivate,
                    onHover: onHover,
                    children: row.label
                }) : row.label;
            }
        },
        {
            key: "a",
            header: aLabel,
            align: "right",
            width: valueTrack,
            render: function(row) {
                return /* @__PURE__ */ jsx11(SeriesColorChip, {
                    color: chartTheme8.comparison.a,
                    children: cellContent(formatValue(row.a, unitOf(row), precisionOf(row)))
                });
            }
        },
        {
            key: "b",
            header: bLabel,
            align: "right",
            width: valueTrack,
            render: function(row) {
                return /* @__PURE__ */ jsx11(SeriesColorChip, {
                    color: chartTheme8.comparison.b,
                    children: cellContent(formatValue(row.b, unitOf(row), precisionOf(row)))
                });
            }
        },
        {
            key: "delta",
            // ⚠️ THE GLYPH NEEDS A VOICE TOO, for the same reason the em dash below it does — and it is the
            // accessible name every cell in this column is announced against. `Δ` (U+0394) reads
            // inconsistently across screen readers and verbosity settings, and "Δ 2.1%" is not a sentence.
            // Safe to use an element here: the DS overrides a columnheader's `aria-label` only when a resize
            // handle is present, and `resizable` is off.
            header: /* @__PURE__ */ jsxs9(Fragment6, {
                children: [
                    /* @__PURE__ */ jsx11("span", {
                        "aria-hidden": "true",
                        children: "\u0394"
                    }),
                    /* @__PURE__ */ jsx11("span", {
                        style: visuallyHidden,
                        children: "Difference, side A minus side B"
                    })
                ]
            }),
            align: "right",
            width: valueTrack,
            render: function(row) {
                var p = precisionOf(row);
                var _row_delta;
                var d = (_row_delta = row.delta) !== null && _row_delta !== void 0 ? _row_delta : row.a !== null && row.b !== null && Number.isFinite(row.a) && Number.isFinite(row.b) ? Number(row.a.toFixed(clampPrecision(p))) - Number(row.b.toFixed(clampPrecision(p))) : null;
                if (d === null || !Number.isFinite(d)) return cellContent(MISSING);
                var rowUnit = unitOf(row);
                var shown = formatValue(Math.abs(d), rowUnit, p);
                var isZero = Number(Math.abs(d).toFixed(clampPrecision(p))) === 0;
                return /* @__PURE__ */ jsx11(Delta2, {
                    $tone: resolveTone(isZero ? 0 : d, deltaTone3),
                    children: isZero ? shown : "".concat(d > 0 ? "+" : "-").concat(shown)
                });
            }
        }
    ];
    return /* @__PURE__ */ jsx11(Table2, {
        className: className,
        columns: columns,
        data: rows,
        keyExtractor: function(row) {
            var _row_bid;
            return (_row_bid = row.bid) !== null && _row_bid !== void 0 ? _row_bid : row.label;
        },
        colourMode: "none",
        resizable: false,
        loading: loading,
        error: error,
        "aria-label": ariaLabel,
        emptyMessage: emptyMessage
    });
};
// src/charts/components/MetricTable/MetricTable.tsx
import React5 from "react";
import styled9 from "styled-components";
import { SELECTED_RAMP as SELECTED_RAMP2, semantic as semantic5, stopForValue, typeRole as typeRole7 } from "@repo/design-tokens";
// src/charts/core/valueColorDefault.ts
import { greyInkFor, OFF_RAMP, SELECTED_RAMP } from "@repo/design-tokens";
import { getIndicatorColor } from "@repo/front-end-utils";
var DEFAULT_BAND_EDGES = [
    [
        0,
        1
    ],
    [
        1,
        5
    ],
    [
        5,
        10
    ],
    [
        10,
        15
    ],
    [
        15,
        20
    ],
    [
        20,
        25
    ],
    [
        25,
        30
    ],
    [
        30,
        40
    ],
    [
        40,
        50
    ],
    [
        50,
        75
    ],
    [
        75,
        100
    ],
    [
        100,
        125
    ],
    [
        125,
        null
    ]
];
var buildDefaultRules = function(selected) {
    return DEFAULT_BAND_EDGES.map(function(param, i) {
        var _param = _sliced_to_array(param, 2), min = _param[0], max = _param[1];
        return {
            id: -(i + 1),
            bg_color: (selected ? SELECTED_RAMP : OFF_RAMP)[i],
            // ⚠️ BLACK, NOT `INK_RAMP`, AND THAT IS DELIBERATE. `INK_RAMP` is the design system's
            // per-stop ink and would be the tidier-looking choice, but every SELECTED band on both AdminDB
            // environments stores black, and this default exists to reproduce what the database would have
            // said. It is also the more legible of the two on the top stops: black on `#A24489` is ≈3.7:1,
            // where `INK_RAMP[12]` (`#6B1F58`) on the same fill is ≈1.9:1. (The stored-ink vs `INK_RAMP`
            // divergence is real and predates this work — filed to the backlog 2026-08-28.)
            //
            // ⛔ SOURCED FROM THE TOKEN LAYER, NOT FROM `IndicatorColor.BLACK`. That enum is the RETIRED
            // legacy palette — the same one carrying the off-brand `#C50F1F` this file criticises above —
            // and reading a colour out of it would launder a hex past the package's own zero-literal gate
            // while the line beside it correctly used a token. `greyInkFor` is the tokens package's own
            // black/white answer for a ramp band, measured against the stored `text_color` values.
            text_color: selected ? greyInkFor(1) : greyInkFor(i + 1),
            // The first band is closed at the bottom (`0 <= v <= 1`); every later band opens just above
            // its predecessor's top, which is what makes the sequence gapless. `getIndicatorColor` is
            // first-match-wins, so a value on a boundary belongs to the LOWER band — matching production.
            min_value_op: i === 0 ? "GREATER_THAN_OR_EQUAL_TO" : "GREATER_THAN",
            min_value: min,
            max_value_op: max === null ? null : "LESS_THAN_OR_EQUAL_TO",
            max_value: max
        };
    });
};
var domainOf = function(value) {
    return value !== null && Number.isFinite(value) ? Math.max(0, value) : 0;
};
if (DEFAULT_BAND_EDGES.length !== SELECTED_RAMP.length || DEFAULT_BAND_EDGES.length !== OFF_RAMP.length) {
    throw new Error("useValueColor: DEFAULT_BAND_EDGES (".concat(DEFAULT_BAND_EDGES.length, ") must match SELECTED_RAMP (").concat(SELECTED_RAMP.length, ") and OFF_RAMP (").concat(OFF_RAMP.length, ")."));
}
var DEFAULT_CONFIG = {
    selected: buildDefaultRules(true),
    non_selected: buildDefaultRules(false)
};
var fallbackValueColor = Object.freeze({
    colorForValue: function(value) {
        var selected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return getIndicatorColor(domainOf(value), DEFAULT_CONFIG, selected).bgColor;
    },
    inkForValue: function(value) {
        var selected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return getIndicatorColor(domainOf(value), DEFAULT_CONFIG, selected).textColor;
    },
    hasConfig: false
});
// src/charts/components/MetricTable/MetricTable.tsx
import { Table as Table3, ValueCell as ValueCell2 } from "@repo/design-system";
import { Fragment as Fragment7, jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var LABEL_KEY = "label";
var NAME_FLOOR2 = "120px";
var METRIC_FLOOR = "76px";
var nameTrack2 = "minmax(".concat(NAME_FLOOR2, ", 3fr)");
var metricTrack = "minmax(".concat(METRIC_FLOOR, ", 1fr)");
var Indicator = styled9.span(_templateObject20(), semantic5.border.faint);
var IndicatorFill = styled9.span(_templateObject21());
var Dimension = styled9.span(_templateObject22(), semantic5.text.body);
var Name = styled9.span(_templateObject23(), typeRole7.body1Strong.fontWeight, semantic5.text.primary);
var MISSING2 = "\u2014";
var formatMetric = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return value === null || value === void 0 || !Number.isFinite(value) ? MISSING2 : "".concat(value.toFixed(clampPrecision2(precision))).concat(unit);
};
var clampPrecision2 = function(precision) {
    return Number.isFinite(precision) ? Math.min(20, Math.max(0, Math.trunc(precision))) : 0;
};
var cellContent2 = function(text) {
    return text === MISSING2 ? /* @__PURE__ */ jsxs10(Fragment7, {
        children: [
            /* @__PURE__ */ jsx12("span", {
                "aria-hidden": "true",
                children: MISSING2
            }),
            /* @__PURE__ */ jsx12("span", {
                style: visuallyHidden,
                children: "No data"
            })
        ]
    }) : text;
};
var isMeasured = function(value) {
    return value !== null && value !== void 0 && Number.isFinite(value);
};
var railValue = function(value, scaleMax) {
    if (!isMeasured(value)) return null;
    if (scaleMax === void 0 || !Number.isFinite(scaleMax) || scaleMax <= 0) return null;
    return Math.max(0, Math.min(100, value / scaleMax * 100));
};
var indicatorColour = function(value, scaleMax, isPercentage, colorForValue) {
    var rail = railValue(value, scaleMax);
    if (rail === null) return null;
    if (!isPercentage) {
        var _SELECTED_RAMP2_;
        return (_SELECTED_RAMP2_ = SELECTED_RAMP2[stopForValue(rail) - 1]) !== null && _SELECTED_RAMP2_ !== void 0 ? _SELECTED_RAMP2_ : null;
    }
    return colorForValue(value);
};
var MetricTableComponent = function(param) {
    var rows = param.rows, columns = param.columns, _param_colorForValue = param.colorForValue, colorForValue = _param_colorForValue === void 0 ? fallbackValueColor.colorForValue : _param_colorForValue, _param_labelHeader = param.labelHeader, labelHeader = _param_labelHeader === void 0 ? "Name" : _param_labelHeader, labelWidth = param.labelWidth, _param_showLabelColumn = param.showLabelColumn, showLabelColumn = _param_showLabelColumn === void 0 ? true : _param_showLabelColumn, defaultSortKey = param.defaultSortKey, defaultSortDirection = param.defaultSortDirection, railColumn = param.railColumn, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, ariaLabel = param.ariaLabel, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var _React5_useState = _sliced_to_array(React5.useState(function() {
        return defaultSortKey !== null && defaultSortKey !== void 0 ? defaultSortKey : LABEL_KEY;
    }), 2), sortKey = _React5_useState[0], setSortKey = _React5_useState[1];
    var _React5_useState1 = _sliced_to_array(React5.useState(function() {
        return defaultSortDirection !== null && defaultSortDirection !== void 0 ? defaultSortDirection : defaultSortKey && defaultSortKey !== LABEL_KEY ? "desc" : "asc";
    }), 2), sortDirection = _React5_useState1[0], setSortDirection = _React5_useState1[1];
    var columnByKey = React5.useMemo(function() {
        var map = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var column = _step.value;
                map.set(column.key, column);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return map;
    }, [
        columns
    ]);
    var sorted = React5.useMemo(function() {
        var out = _to_consumable_array(rows);
        var direction = sortDirection === "asc" ? 1 : -1;
        out.sort(function(a, b) {
            var _columnByKey_get;
            if (sortKey === LABEL_KEY) return direction * a.label.localeCompare(b.label);
            if (((_columnByKey_get = columnByKey.get(sortKey)) === null || _columnByKey_get === void 0 ? void 0 : _columnByKey_get.kind) === "text") {
                var _a_labels, _b_labels;
                var aRaw = (_a_labels = a.labels) === null || _a_labels === void 0 ? void 0 : _a_labels[sortKey];
                var bRaw = (_b_labels = b.labels) === null || _b_labels === void 0 ? void 0 : _b_labels[sortKey];
                var al = typeof aRaw === "string" ? aRaw : null;
                var bl = typeof bRaw === "string" ? bRaw : null;
                if (al === null && bl === null) return a.label.localeCompare(b.label);
                if (al === null) return 1;
                if (bl === null) return -1;
                return direction * al.localeCompare(bl);
            }
            var av = a.values[sortKey];
            var bv = b.values[sortKey];
            var aMeasured = isMeasured(av);
            var bMeasured = isMeasured(bv);
            if (!aMeasured && !bMeasured) return a.label.localeCompare(b.label);
            if (!aMeasured) return 1;
            if (!bMeasured) return -1;
            return direction * (av - bv);
        });
        return out;
    }, [
        rows,
        sortKey,
        sortDirection,
        columnByKey
    ]);
    var railKey = railColumn !== null && railColumn !== void 0 ? railColumn : sortKey === LABEL_KEY ? void 0 : sortKey;
    var railColumnDef = railKey ? columnByKey.get(railKey) : void 0;
    var railScaleMax = React5.useMemo(function() {
        if (!railColumnDef) return void 0;
        if (railColumnDef.scaleMax !== void 0 && railColumnDef.scaleMax > 0) {
            return railColumnDef.scaleMax;
        }
        if (railColumnDef.unit === "%") return 100;
        var max = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                var value = row.values[railColumnDef.key];
                if (isMeasured(value) && value > max) max = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return max > 0 ? max : void 0;
    }, [
        railColumnDef,
        rows
    ]);
    var visibleColumns = React5.useMemo(function() {
        return columns.filter(function(column) {
            var _column_kind;
            if (((_column_kind = column.kind) !== null && _column_kind !== void 0 ? _column_kind : "metric") !== "text") return true;
            return rows.some(function(row) {
                return row.labels !== void 0 && column.key in row.labels;
            });
        });
    }, [
        columns,
        rows
    ]);
    var visibleKeys = React5.useMemo(function() {
        return new Set(visibleColumns.map(function(c) {
            return c.key;
        }));
    }, [
        visibleColumns
    ]);
    var resolvable = sortKey === LABEL_KEY || visibleKeys.has(sortKey);
    React5.useEffect(function() {
        if (resolvable) return;
        if (rows.length === 0) return;
        var fallback = defaultSortKey && visibleKeys.has(defaultSortKey) ? defaultSortKey : LABEL_KEY;
        setSortKey(fallback);
        setSortDirection(fallback === LABEL_KEY ? "asc" : defaultSortDirection !== null && defaultSortDirection !== void 0 ? defaultSortDirection : "desc");
    }, [
        resolvable,
        defaultSortKey,
        defaultSortDirection,
        visibleKeys,
        rows.length
    ]);
    var railed = railColumnDef !== void 0 && railScaleMax !== void 0 && railScaleMax > 0;
    var onSort = function(key) {
        if (key === sortKey) {
            setSortDirection(function(current) {
                return current === "asc" ? "desc" : "asc";
            });
            return;
        }
        setSortKey(key);
        setSortDirection(key === LABEL_KEY ? "asc" : "desc");
    };
    var indicatorScales = React5.useMemo(function() {
        var out = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var column = _step.value;
                if (!column.indicator) continue;
                if (column.scaleMax !== void 0 && column.scaleMax > 0) {
                    out.set(column.key, column.scaleMax);
                    continue;
                }
                if (column.unit === "%") {
                    out.set(column.key, 100);
                    continue;
                }
                var max = 0;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = rows[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var row = _step1.value;
                        var value = row.values[column.key];
                        if (isMeasured(value) && value > max) max = value;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                out.set(column.key, max > 0 ? max : void 0);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return out;
    }, [
        columns,
        rows
    ]);
    var labelColumnShown = showLabelColumn || !visibleColumns.some(function(c) {
        return c.kind === "text";
    });
    var tableColumns = _to_consumable_array(labelColumnShown ? [
        {
            key: LABEL_KEY,
            header: labelHeader,
            width: labelWidth !== null && labelWidth !== void 0 ? labelWidth : nameTrack2,
            align: "left",
            sortable: true,
            render: function(row) {
                return /* @__PURE__ */ jsx12(Name, {
                    children: row.label
                });
            }
        }
    ] : []).concat(_to_consumable_array(visibleColumns.map(function(column) {
        var _column_kind, _column_width, _column_align, _column_sortable, _column_width1, _column_align1, _column_sortable1;
        return ((_column_kind = column.kind) !== null && _column_kind !== void 0 ? _column_kind : "metric") === "text" ? {
            key: column.key,
            header: column.header,
            width: (_column_width = column.width) !== null && _column_width !== void 0 ? _column_width : nameTrack2,
            align: (_column_align = column.align) !== null && _column_align !== void 0 ? _column_align : "left",
            // Sorting a dimension column is a name sort, and it is useful (group a brand together).
            sortable: (_column_sortable = column.sortable) !== null && _column_sortable !== void 0 ? _column_sortable : true,
            render: function(row) {
                var _row_labels;
                var supplied = row.labels !== void 0 && column.key in row.labels;
                if (!supplied) return null;
                var _row_labels_column_key;
                var text = (_row_labels_column_key = (_row_labels = row.labels) === null || _row_labels === void 0 ? void 0 : _row_labels[column.key]) !== null && _row_labels_column_key !== void 0 ? _row_labels_column_key : null;
                return /* @__PURE__ */ jsx12(Dimension, {
                    children: cellContent2(text !== null && text !== void 0 ? text : MISSING2)
                });
            }
        } : {
            key: column.key,
            header: column.header,
            width: (_column_width1 = column.width) !== null && _column_width1 !== void 0 ? _column_width1 : metricTrack,
            align: (_column_align1 = column.align) !== null && _column_align1 !== void 0 ? _column_align1 : "right",
            sortable: (_column_sortable1 = column.sortable) !== null && _column_sortable1 !== void 0 ? _column_sortable1 : true,
            render: function(row) {
                var dot = column.indicator === true ? indicatorColour(row.values[column.key], indicatorScales.get(column.key), column.unit === "%", colorForValue) : null;
                var extent = dot === null ? null : railValue(row.values[column.key], indicatorScales.get(column.key));
                return(// ⚠️ THE RAIL'S END-DOT IS SUPPRESSED ON A COLUMN THAT HAS ITS OWN INDICATOR, or the
                // two channels stack. Observed on the real surface: the sorted column drew the rail
                // end-dot AND its indicator — two dots in near-identical hues, reading as a rendering
                // artefact — while the peak column drew one. Peter's ruling is that the two util
                // columns carry **the same** indicator, so they must LOOK the same; the per-cell
                // indicator supersedes the row echo on any column that has one.
                /* @__PURE__ */ jsxs10(ValueCell2, {
                    showDot: railed && column.key === (railColumnDef === null || railColumnDef === void 0 ? void 0 : railColumnDef.key) && column.indicator !== true,
                    children: [
                        cellContent2(formatMetric(row.values[column.key], column.precision, column.unit)),
                        dot !== null && extent !== null ? // ⚠️ `data-indicator` STAYS ON THE COLOURED ELEMENT, which is now the fill
                        // rather than the box. Every existing pin on this mark reads the indicator's
                        // BACKGROUND through that hook, and moving the attribute to the track would
                        // have left them all reading the track's neutral — four tests turning from
                        // "this cell is stop 12" into "this cell is #EEF1F6", green in one case and
                        // meaningless in the rest.
                        /* @__PURE__ */ jsx12(Indicator, {
                            "aria-hidden": "true",
                            "data-indicator-track": column.key,
                            children: /* @__PURE__ */ jsx12(IndicatorFill, {
                                "data-indicator": column.key,
                                "data-indicator-extent": extent,
                                style: {
                                    width: "".concat(extent, "%"),
                                    background: dot
                                }
                            })
                        }) : null
                    ]
                }));
            }
        };
    })));
    return /* @__PURE__ */ jsx12(Table3, {
        className: className,
        columns: tableColumns,
        data: sorted,
        keyExtractor: function(row) {
            return row.id;
        },
        colourMode: railed ? "ramp" : "none",
        valueFor: function(row) {
            return railed ? railValue(row.values[railColumnDef.key], railScaleMax) : null;
        },
        sortField: sortKey,
        sortDirection: sortDirection,
        onSort: onSort,
        resizable: false,
        loading: loading,
        error: error,
        emptyMessage: emptyMessage,
        "aria-label": ariaLabel
    });
};
var MetricTable = React5.memo(MetricTableComponent);
// src/charts/components/BarChart/BarChart.tsx
import { useMemo as useMemo3 } from "react";
import styled10 from "styled-components";
import { chartTheme as chartTheme10, space as space5, typeRole as typeRole8, semanticColor as semanticColor3 } from "@repo/design-tokens";
// src/charts/theme/valueLabels.ts
import { chartTheme as chartTheme9, inkOn as inkOn2, semantic as semantic6 } from "@repo/design-tokens";
var VALUE_LABEL_PAD = 4;
var DEFAULT_BAR_INK = inkOn2.aqua;
var OUTSIDE_INK = semantic6.text.body;
function valueLabelFont() {
    return {
        family: chartTheme9.base.tick.fontFamily,
        size: parseInt(chartTheme9.base.tick.fontSize, 10)
    };
}
function fitsOneLine(box, textWidth) {
    return box.h >= minLineHeight() && box.w >= textWidth;
}
function minLineHeight() {
    return valueLabelFont().size + 2;
}
function measureValue(ctx, text) {
    var _valueLabelFont = valueLabelFont(), family = _valueLabelFont.family, size = _valueLabelFont.size;
    ctx.font = "".concat(size, "px ").concat(family);
    return ctx.measureText(text).width;
}
var warnedHalfPairs = /* @__PURE__ */ new Set();
function warnUnpairedValueColor(component, hasColor, hasInk) {
    if (hasColor === hasInk) return;
    if (warnedHalfPairs.has(component)) return;
    warnedHalfPairs.add(component);
    var supplied = hasColor ? "colorForValue" : "inkForValue";
    var missing = hasColor ? "inkForValue" : "colorForValue";
    console.warn("[".concat(component, "] ").concat(supplied, " was supplied without ").concat(missing, ", so the fill and the label ink come from DIFFERENT mappings. Pass both halves of one useValueColor(metric) result, or neither."));
}
// src/charts/components/BarChart/BarChart.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var Container2 = styled10.div(_templateObject24(), space5[12]);
var ErrorText3 = styled10.div(_templateObject25(), space5[4], typeRole8.caption1.fontFamily, typeRole8.caption1.fontSize, semanticColor3.error);
var AXIS_CHROME_PX = 14;
var categoryTickFont = function() {
    return "".concat(parseInt(chartTheme10.base.tick.categoryFontSize, 10), "px ").concat(chartTheme10.base.tick.categoryFontFamily);
};
var trimFromRight = function(bars) {
    return function trimFromRight(value, i) {
        var _this, _this1;
        var bar = bars[typeof value === "number" ? value : i];
        var _bar_label;
        var text = (_bar_label = bar === null || bar === void 0 ? void 0 : bar.label) !== null && _bar_label !== void 0 ? _bar_label : "";
        if (!(bar === null || bar === void 0 ? void 0 : bar.qualified)) return text;
        var ctx = (_this = this) === null || _this === void 0 ? void 0 : _this.ctx;
        var _this_maxWidth;
        var budget = ((_this_maxWidth = (_this1 = this) === null || _this1 === void 0 ? void 0 : _this1.maxWidth) !== null && _this_maxWidth !== void 0 ? _this_maxWidth : 0) - AXIS_CHROME_PX;
        if (!ctx || !(budget > 0) || !text) return text;
        var previousFont = ctx.font;
        ctx.font = categoryTickFont();
        try {
            if (ctx.measureText(text).width <= budget) return text;
            var lo = 0;
            var hi = text.length - 1;
            while(lo < hi){
                var mid = Math.ceil((lo + hi) / 2);
                if (ctx.measureText("".concat(text.slice(0, mid), "…")).width <= budget) lo = mid;
                else hi = mid - 1;
            }
            return "".concat(text.slice(0, lo).trimEnd(), "…");
        } finally{
            ctx.font = previousFont;
        }
    };
};
var VALUE_LABEL_PLUGIN_ID = "tl-value-labels";
var valueLabelPlugin = {
    id: VALUE_LABEL_PLUGIN_ID,
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
        var _c_$tlPluginInputs, _c_getDatasetMeta;
        var c = chart;
        var opts = (_c_$tlPluginInputs = c.$tlPluginInputs) === null || _c_$tlPluginInputs === void 0 ? void 0 : _c_$tlPluginInputs[VALUE_LABEL_PLUGIN_ID];
        var _opts_bars;
        var bars = (_opts_bars = opts === null || opts === void 0 ? void 0 : opts.bars) !== null && _opts_bars !== void 0 ? _opts_bars : [];
        var _opts_unit;
        var unit = (_opts_unit = opts === null || opts === void 0 ? void 0 : opts.unit) !== null && _opts_unit !== void 0 ? _opts_unit : "";
        var horizontal = (opts === null || opts === void 0 ? void 0 : opts.horizontal) === true;
        var area = c.chartArea;
        var _c_getDatasetMeta_data;
        var elements = (_c_getDatasetMeta_data = (_c_getDatasetMeta = c.getDatasetMeta(0)) === null || _c_getDatasetMeta === void 0 ? void 0 : _c_getDatasetMeta.data) !== null && _c_getDatasetMeta_data !== void 0 ? _c_getDatasetMeta_data : [];
        if (!area || elements.length === 0 || bars.length === 0) return;
        var ctx = c.ctx;
        var _valueLabelFont = valueLabelFont(), family = _valueLabelFont.family, size = _valueLabelFont.size;
        ctx.save();
        ctx.font = "".concat(size, "px ").concat(family);
        ctx.textBaseline = "middle";
        elements.forEach(function(element, i) {
            var bar = bars[i];
            if (!bar || typeof bar.value !== "number" || !Number.isFinite(bar.value)) return;
            var text = "".concat(bar.value).concat(unit);
            var width = measureValue(ctx, text);
            var p = element.getProps([
                "x",
                "y",
                "base",
                "width",
                "height"
            ], true);
            var thickness = horizontal ? p.height : p.width;
            if (thickness < size + 2) return;
            var length = Math.abs(horizontal ? p.x - p.base : p.base - p.y);
            var inside = length >= width + VALUE_LABEL_PAD * 2;
            var _bar_ink;
            var insideInk = (_bar_ink = bar.ink) !== null && _bar_ink !== void 0 ? _bar_ink : bar.color === void 0 ? DEFAULT_BAR_INK : void 0;
            if (inside && insideInk !== void 0) {
                ctx.fillStyle = insideInk;
                if (horizontal) {
                    ctx.textAlign = "right";
                    ctx.fillText(text, p.x - VALUE_LABEL_PAD, p.y);
                } else {
                    ctx.textAlign = "center";
                    ctx.fillText(text, p.x, p.y + size / 2 + VALUE_LABEL_PAD);
                }
                return;
            }
            ctx.fillStyle = OUTSIDE_INK;
            if (horizontal) {
                if (area.right - p.x < width + VALUE_LABEL_PAD) return;
                ctx.textAlign = "left";
                ctx.fillText(text, p.x + VALUE_LABEL_PAD, p.y);
            } else {
                if (p.y - area.top < size + VALUE_LABEL_PAD) return;
                ctx.textAlign = "center";
                ctx.fillText(text, p.x, p.y - size / 2 - VALUE_LABEL_PAD);
            }
        });
        ctx.restore();
    }
};
function ariaSummary2(bars, metricLabel, unit) {
    var _Math, _Math1;
    if (bars.length === 0) return "".concat(metricLabel, ": no data");
    var values = bars.map(function(b) {
        return b.value;
    }).filter(function(v) {
        return typeof v === "number";
    });
    var unmeasurable = bars.length - values.length;
    var suffix = unmeasurable > 0 ? " ".concat(unmeasurable, " not measurable.") : "";
    if (values.length === 0) {
        return "".concat(metricLabel, " bar chart. ").concat(bars.length, " bars, none measurable.");
    }
    var max = (_Math = Math).max.apply(_Math, _to_consumable_array(values));
    var min = (_Math1 = Math).min.apply(_Math1, _to_consumable_array(values));
    return "".concat(metricLabel, " bar chart. ").concat(bars.length, " bars, min ").concat(min).concat(unit, ", max ").concat(max).concat(unit, ".").concat(suffix);
}
var BarChart = function(param) {
    var bars = param.bars, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, _param_metricLabel = param.metricLabel, metricLabel = _param_metricLabel === void 0 ? "Value" : _param_metricLabel, _param_valueAxisTitle = param.valueAxisTitle, valueAxisTitle = _param_valueAxisTitle === void 0 ? false : _param_valueAxisTitle, maxValue = param.maxValue, _param_orientation = param.orientation, orientation = _param_orientation === void 0 ? "vertical" : _param_orientation, _param_legend = param.legend, legend = _param_legend === void 0 ? false : _param_legend, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var horizontal = orientation === "horizontal";
    var config = useMemo3(function() {
        var fills = bars.map(function(b) {
            var _b_color;
            return buildBarFill((_b_color = b.color) !== null && _b_color !== void 0 ? _b_color : chartTheme10.chartColour(0), {
                horizontal: horizontal
            });
        });
        var hoverColors = bars.map(function(b) {
            var _b_color;
            return (_b_color = b.color) !== null && _b_color !== void 0 ? _b_color : chartTheme10.chartColour(0);
        });
        var categoryTicks = _object_spread({
            font: {
                family: chartTheme10.base.tick.categoryFontFamily,
                size: parseInt(chartTheme10.base.tick.categoryFontSize, 10)
            },
            color: chartTheme10.base.tick.categoryColor
        }, horizontal && bars.some(function(b) {
            return b.qualified;
        }) ? {
            callback: trimFromRight(bars)
        } : {});
        var axisTitleFont = {
            family: chartTheme10.axis.label.fontFamily,
            size: parseInt(chartTheme10.axis.label.fontSize, 10)
        };
        var valueTitleText = unit === "%" ? "".concat(metricLabel, " ").concat(unit) : metricLabel;
        var valueAxis = {
            beginAtZero: true,
            max: maxValue,
            border: {
                display: chartTheme10.base.grid.borderDisplay
            },
            title: {
                display: valueAxisTitle && Boolean(metricLabel) && metricLabel !== "Value",
                text: valueTitleText,
                color: chartTheme10.axis.title,
                font: axisTitleFont
            }
        };
        var categoryAxis = {
            grid: {
                display: false
            },
            ticks: categoryTicks,
            border: {
                display: chartTheme10.base.grid.borderDisplay
            }
        };
        return {
            type: "bar",
            // Inline, on THIS config only — never `Chart.register`, which would put the labels on
            // every canvas in the app including the ones the ruling did not name.
            //
            // ⭐ THE CONSTANT, NOT A CALL. A factory here produced a NEW plugin object on every config
            // change, and `useChartJs` never replaces a top-level plugin array — so the first one
            // outlived every later paint and drew from its captured data. The singleton also makes this
            // array referentially stable, which is what lets `useChartJs`'s plugin-identity guard sit
            // quiet in normal operation and fire only when someone reintroduces a per-render plugin.
            plugins: [
                valueLabelPlugin
            ],
            data: {
                labels: bars.map(function(b) {
                    return b.label;
                }),
                datasets: [
                    {
                        data: bars.map(function(b) {
                            return b.value;
                        }),
                        // The param is typed to only what we read. `ChartConfiguration` here is the
                        // untyped union, so Chart.js requires this scriptable to accept EVERY chart
                        // type's context (including radar's incompatible `parsed`); asking for just
                        // `dataIndex` keeps it assignable, and the fill builder narrows the rest.
                        backgroundColor: function(ctx) {
                            var _fills_;
                            var _ctx_dataIndex, _fills_1;
                            return (_fills_1 = (_fills_ = fills[(_ctx_dataIndex = ctx.dataIndex) !== null && _ctx_dataIndex !== void 0 ? _ctx_dataIndex : 0]) === null || _fills_ === void 0 ? void 0 : _fills_.call(fills, ctx)) !== null && _fills_1 !== void 0 ? _fills_1 : chartTheme10.chartColour(0);
                        },
                        hoverBackgroundColor: hoverColors,
                        borderWidth: 0
                    }
                ]
            },
            options: {
                indexAxis: horizontal ? "y" : "x",
                responsive: true,
                maintainAspectRatio: false,
                scales: horizontal ? {
                    x: valueAxis,
                    y: categoryAxis
                } : {
                    x: categoryAxis,
                    y: valueAxis
                },
                plugins: {
                    legend: buildLegend(legend)
                }
            }
        };
    }, [
        bars,
        maxValue,
        orientation,
        legend,
        unit,
        metricLabel,
        valueAxisTitle
    ]);
    var pluginInputs = useMemo3(function() {
        return _define_property({}, VALUE_LABEL_PLUGIN_ID, {
            bars: bars,
            unit: unit,
            horizontal: horizontal
        });
    }, [
        bars,
        unit,
        horizontal
    ]);
    var setCanvas = useChartJs(config, pluginInputs);
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx13(ErrorText3, {
            role: "alert",
            children: error
        });
    } else if (bars.length === 0) {
        body = /* @__PURE__ */ jsx13(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsx13("canvas", {
            ref: setCanvas,
            role: "img",
            "aria-label": ariaSummary2(bars, metricLabel, unit)
        });
    }
    return /* @__PURE__ */ jsx13(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx13(Container2, {
            children: body
        })
    });
};
var BarChart_default = BarChart;
// src/charts/components/BandHistogram/BandHistogram.tsx
import { useMemo as useMemo4 } from "react";
import { chartTheme as chartTheme11 } from "@repo/design-tokens";
import { jsx as jsx14 } from "react/jsx-runtime";
var BandHistogram = function(param) {
    var row = param.row, _param_unitMode = param.unitMode, unitMode = _param_unitMode === void 0 ? "pct" : _param_unitMode, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No usage data" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var vm = useMemo4(function() {
        return adaptUsageBands(row, unitMode);
    }, [
        row,
        unitMode
    ]);
    var bars = useMemo4(function() {
        return vm.bars.map(function(bar) {
            return bar.bandIndex === void 0 ? bar : _object_spread_props(_object_spread({}, bar), {
                color: chartTheme11.utilisationBandColour(bar.bandIndex, vm.bandCount),
                // PAIRED WITH THE FILL, from the same band lookup (Q1). `BarChart` prints the
                // value on the bar, and a value printed inside a band's bar sits on that band's
                // own colour — so the ink has to come from the same row of the table the fill
                // did. Without it `BarChart` cannot know what is legible on a caller-supplied
                // colour and puts the number outside the bar instead, which on a six-band
                // histogram wastes the one channel the band already has.
                ink: chartTheme11.utilisationBandInk(bar.bandIndex, vm.bandCount)
            });
        });
    }, [
        vm.bars,
        vm.bandCount
    ]);
    var isHours = unitMode === "hoursPerWeek";
    return /* @__PURE__ */ jsx14(BarChart_default, {
        className: className,
        bars: bars,
        orientation: "horizontal",
        unit: isHours ? "h/wk" : "%",
        metricLabel: isHours ? "Hours / week" : "Time in utilisation band",
        valueAxisTitle: isHours,
        maxValue: isHours ? void 0 : 100,
        emptyMessage: emptyMessage,
        loading: loading,
        stale: stale,
        error: error
    });
};
// src/charts/components/ComparisonChart/ComparisonChart.tsx
import { useMemo as useMemo5 } from "react";
import styled11 from "styled-components";
import { chartTheme as chartTheme12, space as space6, typeRole as typeRole9, semanticColor as semanticColor4 } from "@repo/design-tokens";
import { Fragment as Fragment8, jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var formatHourTick2 = function(h) {
    return "".concat(String(Math.round(h)).padStart(2, "0"), ":00");
};
var Container3 = styled11.div(_templateObject26(), space6[12]);
var ErrorText4 = styled11.div(_templateObject27(), space6[4], typeRole9.caption1.fontFamily, typeRole9.caption1.fontSize, semanticColor4.error);
var ErrorDetailText = styled11.div(_templateObject28(), space6[4], space6[4], typeRole9.caption1.fontFamily, typeRole9.caption1.fontSize, chartTheme12.axis.title);
var bothEmpty = function(a, b) {
    return !a.points.some(function(p) {
        return measured(p.y);
    }) && !b.points.some(function(p) {
        return measured(p.y);
    });
};
var measured = function(y) {
    return typeof y === "number" && Number.isFinite(y);
};
function summarise(series) {
    var count = 0;
    var min = Infinity;
    var max = -Infinity;
    var peakX = NaN;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = series.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            if (!measured(p.y)) continue;
            count += 1;
            if (p.y < min) min = p.y;
            if (p.y > max) {
                max = p.y;
                peakX = p.x;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        count: count,
        min: min,
        max: max,
        peakX: peakX
    };
}
var clampPrecision3 = function(precision) {
    return Number.isFinite(precision) ? Math.min(20, Math.max(0, Math.trunc(precision))) : 0;
};
var spoken = function(v, precision) {
    return Number(v.toFixed(clampPrecision3(precision)));
};
var speak = function(v, unit, precision) {
    return "".concat(spoken(v, precision)).concat(unit);
};
function ariaSummary3(a, b, fmtX, metricLabel, unit, profile, precision) {
    var kind = profile ? "hour-of-day profile" : "comparison chart";
    var sa = summarise(a);
    var sb = summarise(b);
    var side = function(label, s) {
        return s.count === 0 ? "".concat(label, ": no data") : "".concat(label, ": min ").concat(speak(s.min, unit, precision), ", max ").concat(speak(s.max, unit, precision), ", peaking at ").concat(fmtX(s.peakX));
    };
    var verdict = "";
    if (sa.count > 0 && sb.count > 0) {
        var ma = spoken(sa.max, precision);
        var mb = spoken(sb.max, precision);
        verdict = ma === mb ? // "Both peak at 21%" collided with the side clauses' "peaking at 18:00" — one verb phrase for
        // two different quantities in one sentence. And equal maxima at DIFFERENT hours is the more
        // informative case, so it is said rather than flattened.
        " Both reach the same maximum, ".concat(speak(sa.max, unit, precision)) + (sa.peakX === sb.peakX ? ", at ".concat(fmtX(sa.peakX), ".") : ", ".concat(a.label, " at ").concat(fmtX(sa.peakX), " and ").concat(b.label, " at ").concat(fmtX(sb.peakX), ".")) : " ".concat(ma > mb ? a.label : b.label, " peaks higher.");
    }
    return "".concat(metricLabel, " ").concat(kind, ", ").concat(a.label, " versus ").concat(b.label, ". ").concat(side(a.label, sa), ". ").concat(side(b.label, sb), ".").concat(verdict);
}
var ComparisonChart = function(param) {
    var a = param.a, b = param.b, grain = param.grain, zone = param.zone, _param_profile = param.profile, profile = _param_profile === void 0 ? false : _param_profile, xAxisLabel = param.xAxisLabel, _param_metricLabel = param.metricLabel, metricLabel = _param_metricLabel === void 0 ? "Value" : _param_metricLabel, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, _param_precision = param.precision, precision = _param_precision === void 0 ? 1 : _param_precision, spokenPrecision = param.spokenPrecision, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, _param_errorDetail = param.errorDetail, errorDetail = _param_errorDetail === void 0 ? null : _param_errorDetail, className = param.className;
    var spokenDp = spokenPrecision !== null && spokenPrecision !== void 0 ? spokenPrecision : precision;
    var empty = bothEmpty(a, b);
    var config = useMemo5(function() {
        var fmtTick = profile ? formatHourTick2 : makeTimeTickCallback(grain, zone);
        var axisTitleFont = {
            family: chartTheme12.axis.label.fontFamily,
            size: parseInt(chartTheme12.axis.label.fontSize, 10)
        };
        var yTitle = {
            display: Boolean(metricLabel) && metricLabel !== "Value",
            text: unit === "%" ? "".concat(metricLabel, " ").concat(unit) : metricLabel,
            color: chartTheme12.axis.title,
            font: axisTitleFont
        };
        var xTitle = {
            display: Boolean(xAxisLabel),
            text: xAxisLabel !== null && xAxisLabel !== void 0 ? xAxisLabel : "",
            color: chartTheme12.axis.title,
            font: axisTitleFont
        };
        var xMin;
        var xMax;
        if (profile) {
            var lo = Infinity;
            var hi = -Infinity;
            for(var _i = 0, _iter = [
                a,
                b
            ]; _i < _iter.length; _i++){
                var series = _iter[_i];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = series.points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var p = _step.value;
                        if (!measured(p.y)) continue;
                        if (p.x < lo) lo = p.x;
                        if (p.x > hi) hi = p.x;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (Number.isFinite(lo) && Number.isFinite(hi) && lo !== hi) {
                xMin = lo;
                xMax = hi;
            }
        }
        return {
            type: "line",
            data: {
                datasets: [
                    {
                        label: a.label,
                        data: a.points,
                        borderColor: chartTheme12.comparison.a,
                        backgroundColor: buildAreaFill(chartTheme12.comparison.a, chartTheme12.comparison.fillTopAlphaA),
                        fill: true,
                        pointBackgroundColor: chartTheme12.comparison.a,
                        pointHoverBorderColor: chartTheme12.base.point.hoverRingColor,
                        spanGaps: false
                    },
                    {
                        label: b.label,
                        data: b.points,
                        borderColor: chartTheme12.comparison.b,
                        backgroundColor: buildAreaFill(chartTheme12.comparison.b, chartTheme12.comparison.fillTopAlphaB),
                        fill: true,
                        pointBackgroundColor: chartTheme12.comparison.b,
                        pointHoverBorderColor: chartTheme12.base.point.hoverRingColor,
                        // B takes a DASHED stroke as a second, redundant cue (brief 17 §3) — so the pair
                        // still reads as "this one / the other one" without relying on colour alone.
                        borderDash: _to_consumable_array(chartTheme12.comparison.dash),
                        spanGaps: false
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                parsing: false,
                // Always two series, and the whole question is "A vs B at this x" — so one hover
                // reads both (brief 17 §2/§3).
                interaction: {
                    mode: "index",
                    intersect: false
                },
                scales: {
                    x: {
                        type: "linear",
                        min: xMin,
                        max: xMax,
                        title: xTitle,
                        grid: {
                            display: chartTheme12.base.grid.xDisplay
                        },
                        border: {
                            display: chartTheme12.base.grid.borderDisplay
                        },
                        ticks: {
                            callback: function(v) {
                                return fmtTick(v);
                            },
                            maxRotation: 0,
                            // On a 24-hour axis Chart.js would otherwise draw a tick per point; autoSkip thins them
                            // to what fits. ⚠️ It thins them SILENTLY, which is fine for an axis (the reader loses
                            // gridline density, not information) and is NOT fine for a category label — see UT §15.21
                            // and do not reach for this on a ranked bar chart.
                            autoSkip: true
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: yTitle,
                        border: {
                            display: chartTheme12.base.grid.borderDisplay
                        }
                    }
                },
                // The legend is ALWAYS shown here — a fixed A/B pair is meaningless without knowing
                // which is which (brief 17 §3). Position is locked top-right for every mark.
                plugins: {
                    legend: buildLegend(true),
                    // 🚨 Chart.js' default title is `LinearScale.getLabelForValue`, i.e. `Intl.NumberFormat`
                    // — a bare `14` under a `14:00` tick on this profile axis, and a raw epoch integer on a
                    // time axis. `fmtTick` is the axis's OWN formatter, passed rather than re-derived.
                    tooltip: buildValueTooltip({
                        formatX: fmtTick,
                        unit: unit,
                        precision: precision
                    })
                }
            }
        };
    }, [
        a,
        b,
        grain,
        zone,
        profile,
        xAxisLabel,
        metricLabel,
        unit,
        precision
    ]);
    var setCanvas = useChartJs(config);
    var body;
    if (error) {
        body = errorDetail ? /* @__PURE__ */ jsxs11(Fragment8, {
            children: [
                /* @__PURE__ */ jsx15(ErrorText4, {
                    role: "alert",
                    children: error
                }),
                /* @__PURE__ */ jsx15(ErrorDetailText, {
                    children: errorDetail
                })
            ]
        }) : /* @__PURE__ */ jsx15(ErrorText4, {
            role: "alert",
            children: error
        });
    } else if (empty) {
        body = /* @__PURE__ */ jsx15(EmptyState_default, {});
    } else {
        body = /* @__PURE__ */ jsx15("canvas", {
            ref: setCanvas,
            role: "img",
            "aria-label": ariaSummary3(a, b, profile ? formatHourTick2 : makeTimeTickCallback(grain, zone), metricLabel, unit, profile, spokenDp)
        });
    }
    return /* @__PURE__ */ jsx15(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx15(Container3, {
            children: body
        })
    });
};
// src/charts/components/ComparisonKPI/ComparisonKPI.tsx
import React9 from "react";
import styled12 from "styled-components";
import { chartTheme as chartTheme13, semantic as semantic7, space as space7, typeRole as typeRole10 } from "@repo/design-tokens";
import { KpiLayout as KpiLayout3, KpiValue as KpiValue3, KpiSub as KpiSub3, KpiDeltaArrow as KpiDeltaArrow2, kpiToneClass as kpiToneClass2 } from "@repo/design-system";
import { Fragment as Fragment9, jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var Pair = styled12.div(_templateObject29(), space7[6]);
var Side = styled12.div(_templateObject30(), space7[3], function(param) {
    var $color = param.$color;
    return $color;
}, space7[2]);
var SideHeader = styled12.span(_templateObject31(), typeRole10.caption1Strong.fontFamily, typeRole10.caption1Strong.fontSize, typeRole10.caption1Strong.fontWeight, typeRole10.caption1Strong.lineHeight, semantic7.text.primary);
var Measure = styled12.div(_templateObject32(), space7[1]);
var MeasureLabel = styled12.span(_templateObject33(), typeRole10.caption2.fontFamily, typeRole10.caption2.fontSize, typeRole10.caption2.lineHeight, semantic7.text.muted);
var SideValue = styled12(KpiValue3)(_templateObject34(), typeRole10.title3.fontSize, typeRole10.title3.lineHeight);
var SummaryLine = styled12(KpiSub3)(_templateObject35(), typeRole10.subtitle2.fontFamily, typeRole10.subtitle2.fontSize, typeRole10.subtitle2.fontWeight, typeRole10.subtitle2.lineHeight, semantic7.text.primary);
var deltaDirection2 = function(d) {
    return d > 0 ? "up" : d < 0 ? "down" : "none";
};
var deltaTone2 = function(d) {
    return d === 0 ? "neutral" : d > 0 ? "positive" : "negative";
};
var NOT_MEASURABLE = "not measurable";
var clampPrecision4 = function(precision) {
    return typeof precision === "number" && Number.isFinite(precision) ? Math.min(20, Math.max(0, Math.trunc(precision))) : 0;
};
function formatValue2(value) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (value === null || value === void 0 || !Number.isFinite(value)) return null;
    var text = value.toFixed(clampPrecision4(precision));
    return Number(text) === 0 ? 0..toFixed(clampPrecision4(precision)) : text;
}
function summaryLine(measures, a, b, summaryMeasure, noun, roughlyEqualBelow) {
    var _a_values, _b_values;
    var measure = summaryMeasure === void 0 ? measures[0] : measures.find(function(m) {
        return m.key === summaryMeasure;
    });
    if (!measure) return null;
    var av = (_a_values = a.values) === null || _a_values === void 0 ? void 0 : _a_values[measure.key];
    var bv = (_b_values = b.values) === null || _b_values === void 0 ? void 0 : _b_values[measure.key];
    if (typeof av !== "number" || typeof bv !== "number") return null;
    if (!Number.isFinite(av) || !Number.isFinite(bv) || av <= 0 || bv <= 0) return null;
    var ratio = Math.max(av, bv) / Math.min(av, bv);
    if (!Number.isFinite(ratio)) return null;
    if (av === bv) return "Roughly equal ".concat(noun);
    if (ratio < roughlyEqualBelow) return "Roughly equal ".concat(noun);
    var winner = av > bv ? a.label : b.label;
    return "".concat(ratio.toFixed(1), "\xd7 more ").concat(noun, " for ").concat(winner);
}
var ComparisonKPI = function(param) {
    var measures = param.measures, a = param.a, b = param.b, _param_deltaMode = param.deltaMode, deltaMode = _param_deltaMode === void 0 ? "difference" : _param_deltaMode, summaryMeasure = param.summaryMeasure, _param_summaryNoun = param.summaryNoun, summaryNoun = _param_summaryNoun === void 0 ? "usage" : _param_summaryNoun, _param_summarySuppressed = param.summarySuppressed, summarySuppressed = _param_summarySuppressed === void 0 ? false : _param_summarySuppressed, _param_roughlyEqualBelow = param.roughlyEqualBelow, roughlyEqualBelow = _param_roughlyEqualBelow === void 0 ? 1.05 : _param_roughlyEqualBelow, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "Nothing to compare" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx16(EmptyState_default, {
            message: error,
            role: "alert"
        });
    } else if (measures.length === 0 || a.values === null && b.values === null) {
        body = /* @__PURE__ */ jsx16(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        var _a_values, _b_values;
        var sides = [
            [
                a,
                chartTheme13.comparison.a
            ],
            [
                b,
                chartTheme13.comparison.b
            ]
        ];
        var summary2 = deltaMode === "ratio" && !summarySuppressed ? summaryLine(measures, a, b, summaryMeasure, summaryNoun, roughlyEqualBelow) : null;
        var first = measures[0];
        var av = first ? (_a_values = a.values) === null || _a_values === void 0 ? void 0 : _a_values[first.key] : void 0;
        var bv = first ? (_b_values = b.values) === null || _b_values === void 0 ? void 0 : _b_values[first.key] : void 0;
        var difference = deltaMode === "difference" && Number.isFinite(av) && Number.isFinite(bv) ? av - bv : null;
        var _first_unit, _first_unit1;
        body = /* @__PURE__ */ jsxs12(Fragment9, {
            children: [
                /* @__PURE__ */ jsx16(Pair, {
                    children: sides.map(function(param, i) {
                        var _param = _sliced_to_array(param, 2), side = _param[0], colour = _param[1];
                        return /* @__PURE__ */ jsxs12(Side, {
                            $color: colour,
                            "data-side": i === 0 ? "a" : "b",
                            children: [
                                /* @__PURE__ */ jsx16(SideHeader, {
                                    children: side.label
                                }),
                                measures.map(function(m) {
                                    var _side_values;
                                    var _m_precision;
                                    var text = formatValue2((_side_values = side.values) === null || _side_values === void 0 ? void 0 : _side_values[m.key], (_m_precision = m.precision) !== null && _m_precision !== void 0 ? _m_precision : 0);
                                    var _m_unit;
                                    return /* @__PURE__ */ jsxs12(Measure, {
                                        children: [
                                            /* @__PURE__ */ jsx16(MeasureLabel, {
                                                children: m.label
                                            }),
                                            text === null ? // 🚨 `aria-label` AS WELL AS the hidden text, and the label is what actually
                                            // fixes it. `SideValue` wraps `KpiValue`, a styled `div` — `role=generic`,
                                            // which does NOT permit name-from-content — so the hidden span alone computed
                                            // an EMPTY accessible name while the sibling non-null cell got one from its
                                            // `aria-label`. Verified with `computeAccessibleName`. That is precisely the
                                            // "announces as an empty cell" outcome FR4 exists to prevent, reintroduced by
                                            // naming the two branches two different ways. The hidden text stays because
                                            // `aria-label` on `role=generic` is unreliable in browse mode.
                                            /* @__PURE__ */ jsxs12(SideValue, {
                                                "aria-label": "".concat(side.label, ", ").concat(m.label, ": ").concat(NOT_MEASURABLE),
                                                children: [
                                                    /* @__PURE__ */ jsx16("span", {
                                                        "aria-hidden": "true",
                                                        children: "\u2014"
                                                    }),
                                                    /* @__PURE__ */ jsx16("span", {
                                                        style: visuallyHidden,
                                                        children: NOT_MEASURABLE
                                                    })
                                                ]
                                            }) : // ⚠️ THE SIDE IS IN THE NAME. Both columns render the same measure label, so
                                            // without it the two cells of a row compute IDENTICAL names and nothing ties
                                            // either to its column — on the one card whose whole job is comparing them.
                                            /* @__PURE__ */ jsxs12(SideValue, {
                                                "aria-label": "".concat(side.label, ", ").concat(m.label, ": ").concat(text).concat((_m_unit = m.unit) !== null && _m_unit !== void 0 ? _m_unit : ""),
                                                children: [
                                                    text,
                                                    m.unit ? /* @__PURE__ */ jsx16("small", {
                                                        children: m.unit
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }, m.key);
                                })
                            ]
                        }, i === 0 ? "a" : "b");
                    })
                }),
                summary2 !== null ? // ⚠️ NO ARROW AND NO TONE. A ratio is always ≥ 1, so an arrow would always point up and a
                // tone would always read positive — decoration asserting something false.
                // 🚨 "×" IS A GLYPH THAT CARRIES MEANING, SO IT GETS SPOKEN TEXT — the same rule the em
                // dash two blocks up already follows. U+00D7 is announced inconsistently: at default
                // punctuation levels several screen readers skip it entirely, others say "multiplication
                // sign". So "1.3× more usage for Strength" is heard as "1.3 more usage for Strength" — a
                // number with no unit — or with "multiplication sign" in the middle of it.
                // ⚠️ THIS IS THE CARD'S ONLY SENTENCE THAT STATES A CONCLUSION rather than a number, and
                // it was the one glyph on the card with no spoken fallback.
                /* @__PURE__ */ jsx16(SummaryLine, {
                    "data-kpi-slot": "summary",
                    children: summary2.split("\xD7").map(function(part, i) {
                        return i === 0 ? part : /* @__PURE__ */ jsxs12(React9.Fragment, {
                            children: [
                                /* @__PURE__ */ jsx16("span", {
                                    "aria-hidden": "true",
                                    children: "\xD7"
                                }),
                                /* @__PURE__ */ jsx16("span", {
                                    style: visuallyHidden,
                                    children: " times"
                                }),
                                part
                            ]
                        }, i);
                    })
                }) : difference !== null && first ? /* @__PURE__ */ jsx16(KpiSub3, {
                    "data-kpi-slot": "delta",
                    children: /* @__PURE__ */ jsxs12("span", {
                        className: kpiToneClass2(deltaTone2(difference)),
                        "aria-label": "".concat(deltaDirection2(difference) === "up" ? "up " : deltaDirection2(difference) === "down" ? "down " : "").concat(Math.abs(difference).toFixed(clampPrecision4(first.precision))).concat((_first_unit = first.unit) !== null && _first_unit !== void 0 ? _first_unit : "", " vs ").concat(b.label),
                        children: [
                            /* @__PURE__ */ jsx16(KpiDeltaArrow2, {
                                $direction: deltaDirection2(difference)
                            }),
                            " ".concat(Math.abs(difference).toFixed(clampPrecision4(first.precision))).concat((_first_unit1 = first.unit) !== null && _first_unit1 !== void 0 ? _first_unit1 : "", " vs ").concat(b.label)
                        ]
                    })
                }) : null
            ]
        });
    }
    return /* @__PURE__ */ jsx16(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx16(KpiLayout3, {
            className: "v-kpi",
            children: body
        })
    });
};
// src/charts/components/Heatmap/Heatmap.tsx
import { useId, useMemo as useMemo6 } from "react";
import styled14 from "styled-components";
import { chartTheme as chartTheme14, semantic as semantic9, semanticColor as semanticColor5, space as space9, typeRole as typeRole12 } from "@repo/design-tokens";
// src/charts/components/RampLegend/RampLegend.tsx
import React10 from "react";
import styled13 from "styled-components";
import { radius as radius3, semantic as semantic8, space as space8, typeRole as typeRole11 } from "@repo/design-tokens";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var SCAN_MAX = 100;
var SCAN_STEPS = 1e3;
var OVER_CAPACITY_SCAN_MAX = 250;
var OVER_CAPACITY_WIDTH = 0.18;
function buildRampSegments(colorForValue) {
    var segments = [];
    var cut = function(value) {
        var color = colorForValue(value);
        var last = segments[segments.length - 1];
        if (last && last.color === color) {
            last.to = value;
            last.weight += 1;
        } else {
            segments.push({
                from: value,
                to: value,
                color: color,
                weight: 1
            });
        }
    };
    for(var i = 0; i <= SCAN_STEPS; i += 1){
        cut(Math.round(i / SCAN_STEPS * SCAN_MAX * 10) / 10);
    }
    var overSteps = 400;
    for(var i1 = 1; i1 <= overSteps; i1 += 1){
        var span = OVER_CAPACITY_SCAN_MAX - SCAN_MAX;
        cut(Math.round((SCAN_MAX + i1 / overSteps * span) * 10) / 10);
    }
    return segments;
}
function positionOf(value) {
    var head = 1 - OVER_CAPACITY_WIDTH;
    var p = value <= SCAN_MAX ? value / SCAN_MAX * head : head + Math.min(1, (value - SCAN_MAX) / (OVER_CAPACITY_SCAN_MAX - SCAN_MAX)) * OVER_CAPACITY_WIDTH;
    return p * 100;
}
function pct2(value) {
    return "".concat(positionOf(value).toFixed(2), "%");
}
function rampGradient(segments) {
    var stops = segments.map(function(seg) {
        return "".concat(seg.color, " ").concat(pct2((seg.from + seg.to) / 2));
    });
    var first = segments[0];
    var last = segments[segments.length - 1];
    return [
        "to right"
    ].concat(_to_consumable_array(first ? [
        "".concat(first.color, " 0%")
    ] : []), _to_consumable_array(stops), _to_consumable_array(last ? [
        "".concat(last.color, " 100%")
    ] : [])).join(", ");
}
var Wrapper = styled13.div(_templateObject36(), space8[1]);
var Strip = styled13.div(_templateObject37(), space8[2], radius3.sm, semantic8.border.default, function(p) {
    return p.$gradient;
});
var Scale = styled13.div(_templateObject38(), typeRole11.caption2.fontFamily, typeRole11.caption2.fontSize, semantic8.text.secondary);
var WordScale = styled13.div(_templateObject39(), typeRole11.caption2.lineHeight, typeRole11.caption2.fontFamily, typeRole11.caption2.fontSize, semantic8.text.secondary);
var WordTick = styled13.span(_templateObject40(), function(p) {
    return p.$right !== void 0 ? "right: ".concat(p.$right, ";") : "left: ".concat(p.$left, ";");
}, function(p) {
    return p.$shift ? "transform: translateX(-50%);" : "";
}, function(p) {
    return p.$shown ? "visible" : "hidden";
});
var FULL_LABEL = "Full";
var OVER_CAPACITY_LABEL = "Over capacity";
var BUSY_VALUE = 33;
var VERY_BUSY_VALUE = 67;
var TICK_MIN_GAP = Number.parseFloat(space8[2]);
function buildWordTicks(labels) {
    return [
        {
            key: "quiet",
            text: labels[0],
            position: null,
            anchor: "left"
        },
        {
            key: "busy",
            text: labels[1],
            position: positionOf(BUSY_VALUE),
            anchor: "centre"
        },
        {
            key: "veryBusy",
            text: labels[2],
            position: positionOf(VERY_BUSY_VALUE),
            anchor: "centre"
        },
        {
            key: "full",
            text: FULL_LABEL,
            position: positionOf(SCAN_MAX),
            anchor: "centre"
        },
        // ⭐ RIGHT-ALIGNED, NOT CENTRED IN THE TAIL, and this is what makes the label survivable at all.
        // Centred it would sit at ~91% — 9% from the strip's right edge with 13 characters to fit — so
        // it would OVERFLOW the strip rather than merely crowd `Full`. Pinned to the right edge it fits
        // by construction, and only the collision with `Full` remains to be decided. `quiet` has been
        // pinned to the left edge since the component was built, for the same reason.
        {
            key: "overCapacity",
            text: OVER_CAPACITY_LABEL,
            position: null,
            anchor: "right"
        }
    ];
}
function extentOf(tick, stripWidth) {
    if (tick.anchor === "left") return {
        left: 0,
        right: tick.width
    };
    if (tick.anchor === "right") return {
        left: stripWidth - tick.width,
        right: stripWidth
    };
    var _tick_position;
    var centre = ((_tick_position = tick.position) !== null && _tick_position !== void 0 ? _tick_position : 0) / 100 * stripWidth;
    return {
        left: centre - tick.width / 2,
        right: centre + tick.width / 2
    };
}
function dropCollidingTicks(stripWidth, ticks) {
    if (!(stripWidth > 0)) return [];
    var by = function(key) {
        return ticks.find(function(t) {
            return t.key === key;
        });
    };
    var collides = function(a, b) {
        if (!a || !b) return false;
        var left = extentOf(a, stripWidth);
        var right = extentOf(b, stripWidth);
        return right.left - left.right < TICK_MIN_GAP;
    };
    var dropped = [];
    if (collides(by("full"), by("overCapacity"))) dropped.push("overCapacity");
    if (collides(by("busy"), by("veryBusy")) || collides(by("veryBusy"), by("full"))) {
        dropped.push("veryBusy");
    }
    return dropped;
}
var RampLegend = function(param) {
    var _param_unit = param.unit, unit = _param_unit === void 0 ? "%" : _param_unit, labels = param.labels, _param_colorForValue = param.colorForValue, colorForValue = _param_colorForValue === void 0 ? fallbackValueColor.colorForValue : _param_colorForValue;
    var segments = React10.useMemo(function() {
        return buildRampSegments(colorForValue);
    }, [
        colorForValue
    ]);
    var gradient = React10.useMemo(function() {
        return rampGradient(segments);
    }, [
        segments
    ]);
    var top = labels ? labels[2] : "".concat(SCAN_MAX).concat(unit, "+");
    var mid = labels ? labels[1] : "".concat(SCAN_MAX / 2).concat(unit);
    var bottom = labels ? labels[0] : "0".concat(unit);
    var labelKey = labels ? labels.join("\0") : null;
    var wordTicks = React10.useMemo(function() {
        return labels ? buildWordTicks(labels) : null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- `labelKey` IS `labels`, by content.
    [
        labelKey
    ]);
    var rowRef = React10.useRef(null);
    var tickRefs = React10.useRef(/* @__PURE__ */ new Map());
    var _React10_useState = _sliced_to_array(React10.useState([]), 2), hidden = _React10_useState[0], setHidden = _React10_useState[1];
    React10.useLayoutEffect(function() {
        var row = rowRef.current;
        if (!row || !wordTicks) return void 0;
        var measure = function() {
            var measured2 = wordTicks.map(function(t) {
                var _tickRefs_current_get;
                var _tickRefs_current_get_offsetWidth;
                return _object_spread_props(_object_spread({}, t), {
                    width: (_tickRefs_current_get_offsetWidth = (_tickRefs_current_get = tickRefs.current.get(t.key)) === null || _tickRefs_current_get === void 0 ? void 0 : _tickRefs_current_get.offsetWidth) !== null && _tickRefs_current_get_offsetWidth !== void 0 ? _tickRefs_current_get_offsetWidth : 0
                });
            });
            var next = dropCollidingTicks(row.offsetWidth, measured2);
            setHidden(function(prev) {
                return prev.length === next.length && prev.every(function(k, i) {
                    return k === next[i];
                }) ? prev : next;
            });
        };
        measure();
        var alive = true;
        var fonts = typeof document !== "undefined" ? document.fonts : void 0;
        fonts === null || fonts === void 0 ? void 0 : fonts.ready.then(function() {
            if (alive) measure();
        });
        if (typeof ResizeObserver === "undefined") {
            return function() {
                alive = false;
            };
        }
        var observer = new ResizeObserver(measure);
        observer.observe(row);
        return function() {
            alive = false;
            observer.disconnect();
        };
    }, [
        wordTicks
    ]);
    return /* @__PURE__ */ jsxs13(Wrapper, {
        "data-ramp-legend": "",
        children: [
            /* @__PURE__ */ jsx17(Strip, {
                role: "img",
                "aria-label": wordTicks ? // ⭐ THE WHOLE SCALE, IN ORDER, AND ALWAYS ALL FIVE. A tick dropped for want of room
                // is dropped VISUALLY; a screen-reader user is not the one running out of width, so
                // nothing is withheld from them because a panel is narrow. This also replaces a name
                // that had gone wrong in word mode — "Quiet to Very busy, midpoint Busy" describes a
                // three-point scale, and the whole point of the change is that the scale has five.
                "Colour scale: ".concat(wordTicks.map(function(t) {
                    return t.text;
                }).join(", "), ".") : "Colour scale, ".concat(bottom, " to ").concat(top, ", midpoint ").concat(mid),
                $gradient: gradient
            }),
            wordTicks ? /* @__PURE__ */ jsx17(WordScale, {
                "aria-hidden": "true",
                ref: rowRef,
                "data-ramp-ticks": "",
                children: wordTicks.map(function(t) {
                    var _t_position;
                    return /* @__PURE__ */ jsx17(WordTick, {
                        "data-tick": t.key,
                        ref: function(el) {
                            tickRefs.current.set(t.key, el);
                        },
                        $left: t.anchor === "left" ? "0" : "".concat(((_t_position = t.position) !== null && _t_position !== void 0 ? _t_position : 0).toFixed(2), "%"),
                        $right: t.anchor === "right" ? "0" : void 0,
                        $shift: t.anchor === "centre",
                        $shown: !hidden.includes(t.key),
                        children: t.text
                    }, t.key);
                })
            }) : /* ⚠️ NUMERIC MODE IS UNTOUCHED, and that is a decision rather than an oversight. Its top
         tick reads `100%+` and the `+` already carries the open-ended top of the scale — which
         is precisely what word mode lost. There is no defect here to fix, so changing it would
         be an unforced behaviour change to the mode every non-row-17 consumer uses. */ /* @__PURE__ */ jsxs13(Scale, {
                "aria-hidden": "true",
                children: [
                    /* @__PURE__ */ jsx17("span", {
                        children: bottom
                    }),
                    /* @__PURE__ */ jsx17("span", {
                        children: mid
                    }),
                    /* @__PURE__ */ jsx17("span", {
                        children: top
                    })
                ]
            })
        ]
    });
};
var RampLegend_default = RampLegend;
// src/charts/components/Heatmap/Heatmap.tsx
import { Fragment as Fragment10, jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var asRow = function(r) {
    return typeof r === "string" ? {
        id: r,
        label: r
    } : r;
};
var DEFAULT_ROWS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var DEFAULT_HOURS = Array.from({
    length: 24
}, function(_u, h) {
    return h;
});
var DEFAULT_ROW_HEADER = "Weekday";
var GRID_GAP = 1.5;
var MIN_CELL = 1;
var Container4 = styled14.div(_templateObject41(), space9[2], space9[12]);
var Plot = styled14.div(_templateObject42());
var ErrorText5 = styled14.div(_templateObject43(), space9[4], typeRole12.caption1.fontFamily, typeRole12.caption1.fontSize, semanticColor5.error);
var hourLabel = function(h) {
    return "".concat(String(h).padStart(2, "0"), ":00");
};
function cellSize(ctx, axis, count) {
    var _ctx_chart_chartArea, _ctx_chart;
    var extent = (_ctx_chart = ctx.chart) === null || _ctx_chart === void 0 ? void 0 : (_ctx_chart_chartArea = _ctx_chart.chartArea) === null || _ctx_chart_chartArea === void 0 ? void 0 : _ctx_chart_chartArea[axis];
    if (typeof extent !== "number" || !Number.isFinite(extent) || count <= 0) return MIN_CELL;
    return Math.max(MIN_CELL, extent / count - GRID_GAP);
}
var CELL_VALUE_PLUGIN_ID = "tl-cell-values";
var cellValuePlugin = {
    id: CELL_VALUE_PLUGIN_ID,
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
        var _c_$tlPluginInputs, _c_getDatasetMeta, _c_data_datasets_, _c_data_datasets, _c_data;
        var c = chart;
        var opts = (_c_$tlPluginInputs = c.$tlPluginInputs) === null || _c_$tlPluginInputs === void 0 ? void 0 : _c_$tlPluginInputs[CELL_VALUE_PLUGIN_ID];
        var _opts_unit;
        var unit = (_opts_unit = opts === null || opts === void 0 ? void 0 : opts.unit) !== null && _opts_unit !== void 0 ? _opts_unit : "";
        var _opts_precision;
        var precision = (_opts_precision = opts === null || opts === void 0 ? void 0 : opts.precision) !== null && _opts_precision !== void 0 ? _opts_precision : 0;
        var inkFor = opts === null || opts === void 0 ? void 0 : opts.inkFor;
        var _c_getDatasetMeta_data;
        var elements = (_c_getDatasetMeta_data = (_c_getDatasetMeta = c.getDatasetMeta(0)) === null || _c_getDatasetMeta === void 0 ? void 0 : _c_getDatasetMeta.data) !== null && _c_getDatasetMeta_data !== void 0 ? _c_getDatasetMeta_data : [];
        var _c_data_datasets__data;
        var points = (_c_data_datasets__data = (_c_data = c.data) === null || _c_data === void 0 ? void 0 : (_c_data_datasets = _c_data.datasets) === null || _c_data_datasets === void 0 ? void 0 : (_c_data_datasets_ = _c_data_datasets[0]) === null || _c_data_datasets_ === void 0 ? void 0 : _c_data_datasets_.data) !== null && _c_data_datasets__data !== void 0 ? _c_data_datasets__data : [];
        if (elements.length === 0 || !inkFor) return;
        var ctx = c.ctx;
        var _valueLabelFont = valueLabelFont(), family = _valueLabelFont.family, size = _valueLabelFont.size;
        var dp = safePrecision(precision);
        ctx.save();
        ctx.font = "".concat(size, "px ").concat(family);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        elements.forEach(function(element, i) {
            var raw = points[i];
            var v = raw === null || raw === void 0 ? void 0 : raw.v;
            if (typeof v !== "number" || !Number.isFinite(v)) return;
            var p = element.getProps([
                "width",
                "height"
            ], true);
            if (p.height < minLineHeight()) return;
            var text = "".concat(v.toFixed(dp)).concat(unit);
            var width = measureValue(ctx, text);
            if (!fitsOneLine({
                w: p.width - VALUE_LABEL_PAD * 2,
                h: p.height
            }, width)) return;
            var _raw_c;
            var colourValue2 = raw !== void 0 && "c" in raw ? (_raw_c = raw.c) !== null && _raw_c !== void 0 ? _raw_c : null : v;
            ctx.fillStyle = inkFor(colourValue2);
            var centre = element.getCenterPoint(true);
            ctx.fillText(text, centre.x, centre.y);
        });
        ctx.restore();
    }
};
var Heatmap = function(param) {
    var cells = param.cells, _param_rows = param.rows, rows = _param_rows === void 0 ? DEFAULT_ROWS : _param_rows, _param_rowHeader = param.rowHeader, rowHeader = _param_rowHeader === void 0 ? DEFAULT_ROW_HEADER : _param_rowHeader, _param_hours = param.hours, hours = _param_hours === void 0 ? DEFAULT_HOURS : _param_hours, _param_unit = param.unit, unit = _param_unit === void 0 ? "%" : _param_unit, _param_metricLabel = param.metricLabel, metricLabel = _param_metricLabel === void 0 ? "Utilisation" : _param_metricLabel, _param_precision = param.precision, precision = _param_precision === void 0 ? 0 : _param_precision, colorForValue = param.colorForValue, inkForValue = param.inkForValue, _param_showRampLegend = param.showRampLegend, showRampLegend = _param_showRampLegend === void 0 ? false : _param_showRampLegend, rampLabels = param.rampLabels, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    warnUnpairedValueColor("Heatmap", colorForValue !== void 0, inkForValue !== void 0);
    var colourFor = colorForValue !== null && colorForValue !== void 0 ? colorForValue : fallbackValueColor.colorForValue;
    var inkFor = inkForValue !== null && inkForValue !== void 0 ? inkForValue : fallbackValueColor.inkForValue;
    var tableId = useId();
    var normalisedRows = useMemo6(function() {
        return rows.map(asRow);
    }, [
        rows
    ]);
    var byKey = useMemo6(function() {
        var map = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                map.set("".concat(c.row, "|").concat(c.hour), c);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return map;
    }, [
        cells
    ]);
    var config = useMemo6(function() {
        var columns = hours.map(hourLabel);
        var tickKeys = normalisedRows.map(function(r) {
            return r.id;
        });
        var labelByKey = new Map(normalisedRows.map(function(r) {
            return [
                r.id,
                r.label
            ];
        }));
        var rowsBottomUp = _to_consumable_array(tickKeys).reverse();
        var points = normalisedRows.flatMap(function(row) {
            return hours.map(function(hour) {
                var cell = byKey.get("".concat(row.id, "|").concat(hour));
                var _cell_value;
                return _object_spread_props(_object_spread({
                    x: hourLabel(hour),
                    y: row.id,
                    v: (_cell_value = cell === null || cell === void 0 ? void 0 : cell.value) !== null && _cell_value !== void 0 ? _cell_value : null
                }, cell && "colorValue" in cell ? {
                    c: cell.colorValue
                } : {}), {
                    present: byKey.has("".concat(row.id, "|").concat(hour))
                });
            });
        });
        var categoryTicks = {
            font: {
                family: chartTheme14.base.tick.categoryFontFamily,
                size: parseInt(chartTheme14.base.tick.categoryFontSize, 10)
            },
            color: chartTheme14.base.tick.categoryColor
        };
        var categoryAxis = {
            type: "category",
            // `offset` puts each category in a BAND rather than on a tick line — without it the
            // first and last columns hang half off the plot.
            offset: true,
            grid: {
                display: false
            },
            border: {
                display: chartTheme14.base.grid.borderDisplay
            },
            ticks: categoryTicks
        };
        return {
            type: "matrix",
            // Inline, on THIS config only — never `Chart.register`.
            // ⭐ THE CONSTANT, NOT A CALL — see the plugin's own note for what a per-render instance
            // costs here. Its inputs ride on `chart.$tlPluginInputs`, which the lifecycle replaces.
            plugins: [
                cellValuePlugin
            ],
            data: {
                datasets: [
                    {
                        label: metricLabel,
                        data: points,
                        backgroundColor: function(ctx) {
                            var _ctx_raw;
                            var raw = (_ctx_raw = ctx.raw) !== null && _ctx_raw !== void 0 ? _ctx_raw : {};
                            var v = "c" in raw ? raw.c : raw.v;
                            if (typeof v !== "number" || !Number.isFinite(v)) return semantic9.surface.app;
                            return colourFor(v);
                        },
                        borderWidth: 0,
                        width: function(ctx) {
                            return cellSize(ctx, "width", hours.length);
                        },
                        height: function(ctx) {
                            return cellSize(ctx, "height", normalisedRows.length);
                        }
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: _object_spread_props(_object_spread({}, categoryAxis), {
                        labels: columns
                    }),
                    // ROW ONE MUST PRINT AT THE TOP — Monday for a week, the busiest group for a space axis
                    // (the adapter orders `rows`; this axis only has to honour that order).
                    // Getting there takes two declarations that only make sense together:
                    //
                    //   `reverse: true`  — this axis runs BOTTOM-UP, so index 0 is the bottom row.
                    //   `labels` reversed — so index 0 is the LAST row and row one lands at the top.
                    //
                    // `reverse` is stated here even though it is already the effective value, because it
                    // is NOT ours: `MatrixController.overrides.scales.y` sets it, and Chart.js merges it
                    // in. A plain vertical category scale is the other way up (index 0 at the top). So
                    // the whole ordering hung on a third-party default that a plugin bump could drop —
                    // and if it did, the reversed labels would silently print the rows upside down while
                    // every label assertion stayed green. Declaring it makes the dependency ours. ⚠️ Pinned by
                    // RENDERED ORDER, never by the option: Chart.js merges its controller overrides into the
                    // config object IN PLACE, so a pin holding a reference to it cannot tell a declaration
                    // from a plugin default — deleting this line once left all 603 tests green.
                    //
                    // The companion table keeps the AUTHORED order via `rowOrder` below: "which row is drawn
                    // where" is a drawing concern, "row one first" is still what to announce.
                    y: _object_spread_props(_object_spread({}, categoryAxis), {
                        labels: rowsBottomUp,
                        reverse: true,
                        // The axis is keyed by identity; the reader is shown the label.
                        ticks: _object_spread_props(_object_spread({}, categoryTicks), {
                            callback: function(_v, i) {
                                var _labelByKey_get;
                                return (_labelByKey_get = labelByKey.get(rowsBottomUp[i])) !== null && _labelByKey_get !== void 0 ? _labelByKey_get : "";
                            }
                        })
                    })
                },
                plugins: {
                    // A single-dataset magnitude grid has nothing to enumerate — the RAMP is the
                    // legend, and it is `showRampLegend`'s job.
                    legend: buildLegend(false),
                    tooltip: {
                        callbacks: {
                            title: function() {
                                return "";
                            },
                            label: function(item) {
                                var _item_raw;
                                var raw = (_item_raw = item.raw) !== null && _item_raw !== void 0 ? _item_raw : {};
                                var v = raw.v;
                                var _labelByKey_get;
                                var name = (_labelByKey_get = labelByKey.get(String(raw.y))) !== null && _labelByKey_get !== void 0 ? _labelByKey_get : String(raw.y);
                                if (typeof v === "number" && Number.isFinite(v)) {
                                    return "".concat(name, " ").concat(raw.x, " — ").concat(metricLabel, " ").concat(v.toFixed(safePrecision(precision))).concat(unit);
                                }
                                return "".concat(name, " ").concat(raw.x, " — ").concat(raw.present ? "closed" : "no data");
                            }
                        }
                    }
                }
            }
        };
    }, [
        byKey,
        hours,
        normalisedRows,
        metricLabel,
        unit,
        precision,
        colourFor,
        inkFor
    ]);
    var pluginInputs = useMemo6(function() {
        return _define_property({}, CELL_VALUE_PLUGIN_ID, {
            unit: unit,
            precision: precision,
            inkFor: inkFor
        });
    }, [
        unit,
        precision,
        inkFor
    ]);
    var setCanvas = useChartJs(config, pluginInputs);
    var companion = useMemo6(function() {
        return buildMatrixCompanion(config, // ⚠️ The caption's noun comes from `rowHeader`, not from a literal. This is the string that
        // was wrong for every non-weekday row set, and it is the reason PD-4 is an a11y deliverable.
        {
            caption: "".concat(metricLabel, " by ").concat(rowHeader.toLowerCase(), " and hour"),
            rowHeader: rowHeader
        }, // "no data" is the honest default for a slot with no number. The ones we KNOW are
        // shut get upgraded to "closed" below, where cell presence is still in scope.
        {
            value: function(v) {
                return "".concat(v.toFixed(safePrecision(precision))).concat(unit);
            },
            empty: "no data"
        }, {
            rowOrder: normalisedRows.map(function(r) {
                return r.id;
            })
        });
    }, [
        config,
        metricLabel,
        unit,
        normalisedRows,
        rowHeader,
        precision
    ]);
    var labelById = useMemo6(function() {
        return new Map(normalisedRows.map(function(r) {
            return [
                r.id,
                r.label
            ];
        }));
    }, [
        normalisedRows
    ]);
    var annotated = useMemo6(function() {
        return _object_spread_props(_object_spread({}, companion), {
            rows: companion.rows.map(function(row) {
                var _labelById_get;
                return _object_spread_props(_object_spread({}, row), {
                    // The model carries the identity (that is what `rowOrder` gave it); the reader gets the
                    // label. Swapped here rather than upstream so the join below stays keyed on the identity.
                    header: (_labelById_get = labelById.get(row.header)) !== null && _labelById_get !== void 0 ? _labelById_get : row.header,
                    cells: row.cells.map(function(cell, c) {
                        var cellData = byKey.get("".concat(row.header, "|").concat(hours[c]));
                        if (!cellData) return cell;
                        if (typeof cellData.value !== "number" || !Number.isFinite(cellData.value)) {
                            return "closed";
                        }
                        return cellData.overCapacity ? "".concat(cell, " (over capacity)") : cell;
                    })
                });
            })
        });
    }, [
        companion,
        byKey,
        hours,
        labelById
    ]);
    var spans = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = hours[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hour = _step.value;
            var last = spans[spans.length - 1];
            if (last && hour === last[1] + 1) last[1] = hour;
            else spans.push([
                hour,
                hour
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var window = spans.length > 0 ? " covering ".concat(spans.map(function(param) {
        var _param = _sliced_to_array(param, 2), a = _param[0], b = _param[1];
        return a === b ? hourLabel(a) : "".concat(hourLabel(a), " to ").concat(hourLabel(b));
    }).join(", ")) : "";
    var summary2 = "".concat(metricLabel, " heatmap, ").concat(normalisedRows.length, " rows (").concat(rowHeader.toLowerCase(), ") by ").concat(hours.length, " hours").concat(window, ". Values are read from the table that follows.");
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx18(ErrorText5, {
            role: "alert",
            children: error
        });
    } else if (cells.length === 0) {
        body = /* @__PURE__ */ jsx18(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsxs14(Fragment10, {
            children: [
                /* @__PURE__ */ jsx18(Plot, {
                    children: /* @__PURE__ */ jsx18("canvas", {
                        ref: setCanvas,
                        role: "img",
                        "aria-label": summary2
                    })
                }),
                /* @__PURE__ */ jsx18(CompanionTable, {
                    model: annotated,
                    id: tableId
                }),
                showRampLegend ? /* @__PURE__ */ jsx18(RampLegend_default, {
                    unit: unit,
                    labels: rampLabels,
                    colorForValue: colourFor
                }) : null
            ]
        });
    }
    return /* @__PURE__ */ jsx18(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx18(Container4, {
            children: body
        })
    });
};
// src/charts/components/CapacityTreemap/CapacityTreemap.tsx
import { useId as useId2, useMemo as useMemo7 } from "react";
import styled15 from "styled-components";
import { chartTheme as chartTheme15, semantic as semantic10, semanticColor as semanticColor6, space as space10, typeRole as typeRole13 } from "@repo/design-tokens";
import { Fragment as Fragment11, jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var TILE_SPACING = 2.5;
var TILE_RADIUS = 6;
var Container5 = styled15.div(_templateObject44(), space10[2], space10[12]);
var Plot2 = styled15.div(_templateObject45());
var ErrorText6 = styled15.div(_templateObject46(), space10[4], typeRole13.caption1.fontFamily, typeRole13.caption1.fontSize, semanticColor6.error);
var NO_DATA = "no data";
var colourValue = function(item) {
    var v = item.colorValue === void 0 ? item.value : item.colorValue;
    return typeof v === "number" && Number.isFinite(v) ? v : null;
};
var colourText = function(item, unit, precision) {
    var v = colourValue(item);
    return v === null ? NO_DATA : "".concat(v.toFixed(safePrecision(precision))).concat(unit);
};
var itemOf = function(ctx) {
    var _ctx_raw;
    return (_ctx_raw = ctx.raw) === null || _ctx_raw === void 0 ? void 0 : _ctx_raw._data;
};
var CapacityTreemap = function(param) {
    var items = param.items, colorForValue = param.colorForValue, inkForValue = param.inkForValue, _param_unit = param.unit, unit = _param_unit === void 0 ? "" : _param_unit, _param_sizeLabel = param.sizeLabel, sizeLabel = _param_sizeLabel === void 0 ? "Capacity" : _param_sizeLabel, _param_metricLabel = param.metricLabel, metricLabel = _param_metricLabel === void 0 ? "Utilisation" : _param_metricLabel, _param_rowHeader = param.rowHeader, rowHeader = _param_rowHeader === void 0 ? "Area" : _param_rowHeader, _param_precision = param.precision, precision = _param_precision === void 0 ? 0 : _param_precision, _param_showRampLegend = param.showRampLegend, showRampLegend = _param_showRampLegend === void 0 ? false : _param_showRampLegend, rampLabels = param.rampLabels, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No data available" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    warnUnpairedValueColor("CapacityTreemap", colorForValue !== void 0, inkForValue !== void 0);
    var colourFor = colorForValue !== null && colorForValue !== void 0 ? colorForValue : fallbackValueColor.colorForValue;
    var inkFor = inkForValue !== null && inkForValue !== void 0 ? inkForValue : fallbackValueColor.inkForValue;
    var tableId = useId2();
    var tiles = useMemo7(function() {
        return items.filter(function(i) {
            return typeof i.value === "number" && Number.isFinite(i.value) && i.value > 0;
        });
    }, [
        items
    ]);
    var untiled = useMemo7(function() {
        return items.filter(function(i) {
            return i.value === null;
        });
    }, [
        items
    ]);
    var config = useMemo7(function() {
        return {
            type: "treemap",
            data: {
                datasets: [
                    {
                        label: metricLabel,
                        tree: tiles,
                        // AREA is capacity. The colour measure is deliberately NOT the key.
                        key: "value",
                        spacing: TILE_SPACING,
                        borderRadius: TILE_RADIUS,
                        borderWidth: 0,
                        backgroundColor: function(ctx) {
                            var item = itemOf(ctx);
                            if (!item) return colourFor(0);
                            if (item.color) return item.color;
                            var v = colourValue(item);
                            return v === null ? semantic10.surface.app : colourFor(v);
                        },
                        labels: {
                            display: true,
                            /**
               * Name, then the SIZE measure, then the colour measure — the Embeddable
               * original's three lines, restored (U14).
               *
               * 🚨 THE TILE'S AREA IS ITS TRACKED CAPACITY AND NO TILE SAID SO. Size is one of
               * this mark's two channels and it is the one that cannot be read precisely: a
               * reader can see that one box is bigger, not that it holds 82 and its neighbour
               * 30. The matrix directly above prints "(cap 82)" on its rows
               * (`adaptBaselineMatrix.defaultRowLabel`), so the two panels on one dashboard
               * disagreed about whether capacity is shown at all.
               *
               * ⭐ THE THIRD LINE COSTS NO TILE ITS LABEL — measured, not assumed. Harness
               * `docs/specs/harnesses/lane6-value-legibility`, real definition, 1568px,
               * 2026-09-01: tiles able to hold THREE lines vs TWO are 6/6 vs 6/6 at zone,
               * 12/14 vs 12/14 at section, and 12/33 vs 12/33 at area. Identical at every
               * level, because what stops a small tile is its WIDTH against the group NAME
               * (83.3px for "Recumbent Bikes" against a 25px smallest tile at 33 tiles), and a
               * tile that cannot hold the name was already printing nothing. `overflow:
               * 'hidden'` below is what makes that automatic.
               *
               * ⚠️ OMITTED, NEVER GUESSED, WHEN THERE IS NO CAPACITY. `null` means BI has no
               * tracked capacity for this group; `cap 0` would state a fact that is false, and
               * it is the exact mutant `adaptBaselineMatrix`'s own row-label test kills.
               */ formatter: function(ctx) {
                                var item = itemOf(ctx);
                                if (!item) return "";
                                var cap = typeof item.value === "number" && Number.isFinite(item.value) ? [
                                    "cap ".concat(item.value)
                                ] : [];
                                return [
                                    item.label
                                ].concat(_to_consumable_array(cap), [
                                    colourText(item, unit, precision)
                                ]);
                            },
                            // Ink is PAIRED with the fill by the SAME band lookup, so a label stays
                            // legible on whatever its own tile is painted — the whole reason `inkForValue`
                            // exists, now resolved from the twin's ramp rather than from a token index.
                            color: function(ctx) {
                                var item = itemOf(ctx);
                                var _ref;
                                return inkFor((_ref = item && colourValue(item)) !== null && _ref !== void 0 ? _ref : 0);
                            },
                            font: {
                                family: chartTheme15.base.tick.categoryFontFamily,
                                size: parseInt(typeRole13.caption2.fontSize, 10)
                            },
                            overflow: "hidden",
                            position: "middle"
                        }
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    // The tiles are labelled in place; a legend would restate them.
                    legend: buildLegend(false),
                    tooltip: {
                        callbacks: {
                            title: function() {
                                return "";
                            },
                            label: function(ctx) {
                                var item = itemOf(ctx);
                                if (!item) return "";
                                return "".concat(item.label, " — ").concat(sizeLabel, " ").concat(item.value, ", ").concat(metricLabel, " ").concat(colourText(item, unit, precision));
                            }
                        }
                    }
                }
            }
        };
    }, [
        tiles,
        unit,
        sizeLabel,
        metricLabel,
        precision,
        colourFor,
        inkFor
    ]);
    var setCanvas = useChartJs(config);
    var companion = useMemo7(function() {
        return buildTreemapCompanion(config, {
            // ⚠️ The caption's noun and the header come from `rowHeader`, not from the literal 'area'
            // this mark shipped with — the tiles are zones or sections just as often now.
            caption: "".concat(sizeLabel, " and ").concat(metricLabel, " by ").concat(rowHeader.toLowerCase()),
            rowHeader: rowHeader,
            // A tile's name comes from the data, so it can arrive blank. An empty `<th>` is an
            // axe violation and announces two numbers with nothing to attach them to.
            unnamed: "Unnamed ".concat(rowHeader.toLowerCase())
        }, "label", [
            {
                header: sizeLabel,
                value: function(row) {
                    var _row_value;
                    return row.value === null ? "\u2014" : String((_row_value = row.value) !== null && _row_value !== void 0 ? _row_value : "");
                }
            },
            {
                header: metricLabel,
                value: function(row) {
                    return colourText(row, unit, precision);
                }
            }
        ]);
    }, [
        config,
        sizeLabel,
        metricLabel,
        unit,
        rowHeader,
        precision
    ]);
    var summary2 = untiled.length > 0 ? "".concat(sizeLabel, " treemap, ").concat(tiles.length, " of ").concat(items.length, " ").concat(rowHeader.toLowerCase(), " tiles sized by ").concat(sizeLabel.toLowerCase(), " and coloured by ").concat(metricLabel.toLowerCase(), "; ").concat(untiled.length, " have no ").concat(sizeLabel.toLowerCase(), " and are listed in the table only. Values are read from the table that follows.") : "".concat(sizeLabel, " treemap, ").concat(tiles.length, " ").concat(rowHeader.toLowerCase(), " tiles sized by ").concat(sizeLabel.toLowerCase(), " and coloured by ").concat(metricLabel.toLowerCase(), ". Values are read from the table that follows.");
    var withUntiled = useMemo7(function() {
        return _object_spread_props(_object_spread({}, companion), {
            rows: _to_consumable_array(companion.rows).concat(_to_consumable_array(untiled.map(function(item) {
                return {
                    header: item.label || "Unnamed ".concat(rowHeader.toLowerCase()),
                    cells: [
                        "\u2014",
                        colourText(item, unit, precision)
                    ]
                };
            })))
        });
    }, [
        companion,
        untiled,
        rowHeader,
        unit,
        precision
    ]);
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx19(ErrorText6, {
            role: "alert",
            children: error
        });
    } else if (tiles.length === 0 && untiled.length === 0) {
        body = /* @__PURE__ */ jsx19(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsxs15(Fragment11, {
            children: [
                /* @__PURE__ */ jsx19(Plot2, {
                    children: /* @__PURE__ */ jsx19("canvas", {
                        ref: setCanvas,
                        role: "img",
                        "aria-label": summary2
                    })
                }),
                /* @__PURE__ */ jsx19(CompanionTable, {
                    model: withUntiled,
                    id: tableId
                }),
                showRampLegend ? /* @__PURE__ */ jsx19(RampLegend_default, {
                    unit: unit,
                    labels: rampLabels,
                    colorForValue: colourFor
                }) : null
            ]
        });
    }
    return /* @__PURE__ */ jsx19(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: /* @__PURE__ */ jsx19(Container5, {
            children: body
        })
    });
};
// src/charts/components/Suggestions/Suggestions.tsx
import styled16 from "styled-components";
import { semantic as semantic11, semanticColor as semanticColor7, space as space11, typeRole as typeRole14 } from "@repo/design-tokens";
import { Inline as Inline2 } from "@repo/design-system";
import { jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var KIND_ACCENT = {
    add: semanticColor7.success,
    reduce: semanticColor7.warn,
    remove: semanticColor7.error
};
var KIND_HUE = {
    add: "mint",
    reduce: "peach",
    remove: "error"
};
var Wrap2 = styled16.div(_templateObject47(), space11[4]);
var Bucket = styled16.section(_templateObject48(), function(param) {
    var $accent = param.$accent;
    return $accent;
}, space11[3]);
var Title = styled16.h3(_templateObject49(), space11[2], typeRole14.caption1Strong.fontFamily, typeRole14.caption1Strong.fontSize, typeRole14.caption1Strong.fontWeight, semantic11.text.secondary);
var Items = styled16.ul(_templateObject50());
var Item2 = styled16.li(_templateObject51());
var Criterion = styled16.p(_templateObject52(), space11[2], typeRole14.caption1.fontFamily, typeRole14.caption1.fontSize, typeRole14.caption1.lineHeight, semantic11.text.secondary);
var BUCKET_EMPTY_TEXT = "Nothing flagged.";
var BucketEmpty = styled16.p(_templateObject53(), typeRole14.caption1.fontFamily, typeRole14.caption1.fontSize, semantic11.text.secondary);
var Suggestions = function(param) {
    var buckets = param.buckets, onActivate = param.onActivate, onHover = param.onHover, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No recommendations" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx20(EmptyState_default, {
            message: error,
            role: "alert"
        });
    } else if (buckets.length === 0) {
        body = /* @__PURE__ */ jsx20(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsx20(Wrap2, {
            children: buckets.map(function(bucket) {
                return /* @__PURE__ */ jsxs16(Bucket, {
                    $accent: KIND_ACCENT[bucket.kind],
                    "aria-label": bucket.title,
                    children: [
                        /* @__PURE__ */ jsx20(Title, {
                            children: bucket.title
                        }),
                        bucket.description ? /* @__PURE__ */ jsx20(Criterion, {
                            children: bucket.description
                        }) : null,
                        bucket.items.length === 0 ? // Every SERVED bucket keeps its title and its accent, so the three headings are
                        // a stable frame rather than a list that changes shape with the data. An empty
                        // one says so in its own words.
                        //
                        // A component CONSTANT rather than an authored prop, deliberately: nothing yet
                        // needs the copy to differ per bucket, and an authored string would be a props
                        // widening on a schema that is `additionalProperties: false`. If a caller ever
                        // does need it, `emptyItemsMessage` is the obvious addition and it is subsumed
                        // by this component's own availability floor.
                        /* @__PURE__ */ jsx20(BucketEmpty, {
                            children: BUCKET_EMPTY_TEXT
                        }) : /* @__PURE__ */ jsx20(Items, {
                            role: "list",
                            children: bucket.items.map(function(item) {
                                return /* @__PURE__ */ jsx20(Item2, {
                                    role: "listitem",
                                    children: /* @__PURE__ */ jsx20(Inline2, {
                                        hue: KIND_HUE[bucket.kind],
                                        label: onActivate ? /* @__PURE__ */ jsx20(EntitySpotlight, {
                                            bid: item.bid,
                                            onActivate: onActivate,
                                            onHover: onHover,
                                            children: item.label
                                        }) : item.label,
                                        display: item.utilisation !== void 0 ? "".concat(Math.round(item.utilisation), "%") : void 0,
                                        percent: item.utilisation,
                                        meta: item.detail
                                    })
                                }, item.bid);
                            })
                        })
                    ]
                }, bucket.kind);
            })
        });
    }
    return /* @__PURE__ */ jsx20(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        className: className,
        children: body
    });
};
var Suggestions_default = Suggestions;
// src/charts/components/HierarchicalFilter/HierarchicalFilter.tsx
import { useEffect as useEffect2, useLayoutEffect, useMemo as useMemo8, useRef as useRef2, useState } from "react";
import styled17 from "styled-components";
import { semantic as semantic12, space as space12, radius as radius4, typeRole as typeRole15, motion as motion2, focus, brand as brand2, ink as ink2, line, surface, fontMono, weight, rgba as rgba3, rgbTriple, SELECTED_RAMP as SELECTED_RAMP3 } from "@repo/design-tokens";
import { Checkbox } from "@repo/design-system";
// src/charts/components/HierarchicalFilter/hierarchy.ts
function pruneHierarchyRoots(rows, matchRootName) {
    var drop = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var _r_name;
            if ((r.parent_bid === null || r.parent_bid === void 0) && matchRootName((_r_name = r.name) !== null && _r_name !== void 0 ? _r_name : "")) {
                drop.add(r.bid);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (drop.size === 0) return rows.slice();
    var changed = true;
    while(changed){
        changed = false;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = rows[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var r1 = _step1.value;
                if (!drop.has(r1.bid) && r1.parent_bid != null && drop.has(r1.parent_bid)) {
                    drop.add(r1.bid);
                    changed = true;
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return rows.filter(function(r) {
        return !drop.has(r.bid);
    });
}
function buildHierarchyTree(rows) {
    var byBid = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            byBid.set(r.bid, {
                bid: r.bid,
                name: r.name,
                parentBid: r.parent_bid,
                children: []
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var roots = [];
    Array.from(byBid.values()).forEach(function(node) {
        var parent = node.parentBid ? byBid.get(node.parentBid) : void 0;
        if (parent) parent.children.push(node);
        else roots.push(node);
    });
    return {
        roots: roots,
        byBid: byBid
    };
}
function pathTo(bid, index) {
    var out = [];
    var cur = index.byBid.get(bid);
    while(cur){
        out.unshift(cur.bid);
        cur = cur.parentBid ? index.byBid.get(cur.parentBid) : void 0;
    }
    return out;
}
var ancestorsOf = function(bid, index) {
    var path = pathTo(bid, index);
    return path.slice(0, -1);
};
var descendantsOf = function(bid, index) {
    var node = index.byBid.get(bid);
    if (!node) return [];
    var out = [];
    var stack = _to_consumable_array(node.children);
    while(stack.length){
        var _stack;
        var n = stack.pop();
        out.push(n.bid);
        (_stack = stack).push.apply(_stack, _to_consumable_array(n.children));
    }
    return out;
};
var isManual = function(state, bid) {
    var _state_get;
    return ((_state_get = state.get(bid)) === null || _state_get === void 0 ? void 0 : _state_get.manual) === true;
};
var isSilent = function(state, bid) {
    var _state_get;
    var _state_get_silentRefs;
    return ((_state_get_silentRefs = (_state_get = state.get(bid)) === null || _state_get === void 0 ? void 0 : _state_get.silentRefs) !== null && _state_get_silentRefs !== void 0 ? _state_get_silentRefs : 0) > 0;
};
function decrementAncestors(next, bid, index) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ancestorsOf(bid, index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            var e = next.get(a);
            if (!e) continue;
            var silentRefs = Math.max(0, e.silentRefs - 1);
            if (!e.manual && silentRefs === 0) next.delete(a);
            else next.set(a, {
                manual: e.manual,
                silentRefs: silentRefs
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function incrementAncestors(next, bid, index) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ancestorsOf(bid, index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            var e = next.get(a);
            var _e_manual, _e_silentRefs;
            next.set(a, {
                manual: (_e_manual = e === null || e === void 0 ? void 0 : e.manual) !== null && _e_manual !== void 0 ? _e_manual : false,
                silentRefs: ((_e_silentRefs = e === null || e === void 0 ? void 0 : e.silentRefs) !== null && _e_silentRefs !== void 0 ? _e_silentRefs : 0) + 1
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function deselect(next, bid, index) {
    var e = next.get(bid);
    if (!(e === null || e === void 0 ? void 0 : e.manual)) return;
    if (e.silentRefs > 0) next.set(bid, {
        manual: false,
        silentRefs: e.silentRefs
    });
    else next.delete(bid);
    decrementAncestors(next, bid, index);
}
function select(next, bid, index) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = descendantsOf(bid, index)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var d = _step.value;
            var _next_get;
            if ((_next_get = next.get(d)) === null || _next_get === void 0 ? void 0 : _next_get.manual) deselect(next, d, index);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var e = next.get(bid);
    var _e_silentRefs;
    next.set(bid, {
        manual: true,
        silentRefs: (_e_silentRefs = e === null || e === void 0 ? void 0 : e.silentRefs) !== null && _e_silentRefs !== void 0 ? _e_silentRefs : 0
    });
    incrementAncestors(next, bid, index);
}
function toggleSelection(state, bid, index) {
    var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        mode: "multi"
    };
    var next = new Map(Array.from(state.entries()));
    var currentlyManual = isManual(state, bid);
    if (opts.mode === "single") {
        if (currentlyManual) {
            if (opts.clearable) return /* @__PURE__ */ new Map();
            return state;
        }
        var fresh = /* @__PURE__ */ new Map();
        fresh.set(bid, {
            manual: true,
            silentRefs: 0
        });
        incrementAncestors(fresh, bid, index);
        return fresh;
    }
    if (currentlyManual) deselect(next, bid, index);
    else select(next, bid, index);
    return next;
}
function selectionPathKeys(state, index) {
    var keys = [];
    Array.from(state.entries()).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), bid = _param[0], entry = _param[1];
        if (entry.manual) keys.push(pathTo(bid, index).join("/"));
    });
    return keys.sort();
}
function selectedBids(state) {
    return Array.from(state.entries()).filter(function(param) {
        var _param = _sliced_to_array(param, 2), e = _param[1];
        return e.manual;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 1), bid = _param[0];
        return bid;
    }).sort();
}
function rootBids(index) {
    return index.roots.map(function(r) {
        return r.bid;
    }).sort();
}
function distinctDepths(bids, index) {
    var ceiling = index.byBid.size + 1;
    var ancestorsOf2 = function(bid) {
        var out = [];
        var node = index.byBid.get(bid);
        if (!node) return out;
        while(node.parentBid !== null && out.length < ceiling){
            var parent = index.byBid.get(node.parentBid);
            if (!parent) break;
            out.push(parent.bid);
            node = parent;
        }
        return out;
    };
    var known = bids.filter(function(b) {
        return index.byBid.has(b);
    });
    var selected = new Set(known);
    var depths = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = known[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bid = _step.value;
            var ancestors = ancestorsOf2(bid);
            if (ancestors.some(function(a) {
                return selected.has(a);
            })) continue;
            depths.add(ancestors.length);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return depths.size === 0 ? 1 : depths.size;
}
function leafBidsUnder(bids, index) {
    var out = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = bids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bid = _step.value;
            var node = index.byBid.get(bid);
            if (!node) continue;
            if (node.children.length === 0) {
                out.add(node.bid);
                continue;
            }
            var stack = _to_consumable_array(node.children);
            while(stack.length){
                var _stack;
                var n = stack.pop();
                if (n.children.length === 0) out.add(n.bid);
                else (_stack = stack).push.apply(_stack, _to_consumable_array(n.children));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Array.from(out).sort();
}
// src/charts/components/HierarchicalFilter/HierarchicalFilter.tsx
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var INDENT_STEP = 24;
var ROW_INSET = 4;
var RAIL_OFFSET = 13;
var TRAIL_SLOT = 20;
var Wrap3 = styled17.div(_templateObject54(), typeRole15.body1.fontFamily, typeRole15.body1.fontSize, semantic12.text.primary);
var Title2 = styled17.div(_templateObject55(), typeRole15.caption1Strong.fontFamily, typeRole15.caption1Strong.fontSize, typeRole15.caption1Strong.fontWeight, semantic12.text.secondary, space12[2]);
var Row = styled17.div(_templateObject56(), space12[1], ROW_INSET, motion2.durFast, motion2.easeUi, motion2.durFast, motion2.easeUi, rgba3(brand2.cyan, 0.05), function(param) {
    var $selected = param.$selected;
    return $selected ? "background: ".concat(rgba3(brand2.cyan, 0.08), "; border-color: ").concat(rgba3(brand2.cyan, 0.35), ";") : "";
});
var Rails = styled17.span(_templateObject57(), line[4]);
var Selectable = styled17.button(_templateObject58(), typeRole15.body1.fontFamily, weight.medium, ink2[1], focus.tight, radius4.sm);
var LabelStack = styled17.span(_templateObject59());
var ShrinkableCheckbox = styled17(Checkbox)(_templateObject60());
var Label = styled17.span(_templateObject61());
var Ancestry = styled17.span(_templateObject62(), typeRole15.caption2.fontFamily, typeRole15.caption2.fontSize, typeRole15.caption2.lineHeight, typeRole15.caption2.fontWeight, ink2[2]);
var Value2 = styled17.span(_templateObject63(), fontMono, weight.regular, function(param) {
    var $selected = param.$selected;
    return $selected ? ink2[1] : ink2[2];
});
var Dot = styled17.span(_templateObject64(), radius4.pill, function(param) {
    var $color = param.$color;
    return $color;
});
var Toggle = styled17.button(_templateObject65(), TRAIL_SLOT, TRAIL_SLOT, ink2[4], radius4.sm, rgba3(brand2.cyan, 0.12), brand2.cyanPress, focus.tight);
var TrailGutter = styled17.span(_templateObject66(), TRAIL_SLOT);
var RADIO_ON = rgbTriple(SELECTED_RAMP3[6]);
var RADIO_OFF = rgbTriple(SELECTED_RAMP3[1]);
var RadioBox = styled17.span(_templateObject67(), radius4.pill, RADIO_ON, RADIO_OFF, RADIO_ON, RADIO_ON, RADIO_ON, RADIO_ON, rgba3(surface[0], 0.55), RADIO_ON, RADIO_ON, radius4.pill, surface[0], RADIO_ON, RADIO_ON, RADIO_ON, RADIO_ON, RADIO_ON, RADIO_ON, rgba3(surface[0], 0.45), RADIO_ON, RADIO_ON);
var Chevron = function(param) {
    var $open = param.$open;
    return /* @__PURE__ */ jsx21("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 10 10",
        "aria-hidden": "true",
        focusable: "false",
        style: {
            transform: $open ? "rotate(90deg)" : "none",
            transition: "transform ".concat(motion2.durFast, " ").concat(motion2.easeUi)
        },
        children: /* @__PURE__ */ jsx21("path", {
            d: "M3 1.5 L7 5 L3 8.5",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
function ambiguousLabels(index) {
    var seen = /* @__PURE__ */ new Map();
    index.byBid.forEach(function(node) {
        var _seen_get;
        return seen.set(node.name, ((_seen_get = seen.get(node.name)) !== null && _seen_get !== void 0 ? _seen_get : 0) + 1);
    });
    var dups = /* @__PURE__ */ new Set();
    seen.forEach(function(count, name) {
        if (count > 1) dups.add(name);
    });
    return dups;
}
var TreeItem = function(param) {
    var node = param.node, depth = param.depth, mode = param.mode, state = param.state, expanded = param.expanded, index = param.index, ambiguous = param.ambiguous, nodeMeta = param.nodeMeta, colorForValue = param.colorForValue, onToggleNode = param.onToggleNode, onToggleExpand = param.onToggleExpand;
    var hasChildren = node.children.length > 0;
    var isOpen = expanded.has(node.bid);
    var checkState = isManual(state, node.bid) ? "true" : isSilent(state, node.bid) ? "mixed" : "false";
    var isRadio = mode === "single";
    var selected = checkState === "true";
    var parent = node.parentBid ? index.byBid.get(node.parentBid) : void 0;
    var ancestryOf = ambiguous.has(node.name) && parent ? "in ".concat(parent.name) : null;
    var meta = nodeMeta === null || nodeMeta === void 0 ? void 0 : nodeMeta[node.bid];
    var showValueColumn = nodeMeta != null;
    return /* @__PURE__ */ jsxs17("li", {
        role: "treeitem",
        "aria-selected": selected,
        "aria-expanded": hasChildren ? isOpen : void 0,
        children: [
            /* @__PURE__ */ jsxs17(Row, {
                $selected: selected,
                style: {
                    paddingLeft: "".concat(depth * INDENT_STEP + ROW_INSET, "px")
                },
                children: [
                    depth > 0 && /* @__PURE__ */ jsx21(Rails, {
                        "aria-hidden": "true",
                        children: Array.from({
                            length: depth
                        }, function(_, i) {
                            return /* @__PURE__ */ jsx21("i", {
                                "data-rail": i,
                                style: _object_spread({
                                    left: "".concat(i * INDENT_STEP + RAIL_OFFSET, "px")
                                }, isOpen && i === depth - 1 ? {
                                    background: line[1]
                                } : {})
                            }, i);
                        })
                    }),
                    isRadio ? /* @__PURE__ */ jsxs17(Selectable, {
                        type: "button",
                        role: "radio",
                        "aria-checked": selected,
                        "aria-label": ancestryOf ? "".concat(node.name, ", ").concat(ancestryOf) : void 0,
                        onClick: function() {
                            return onToggleNode(node.bid);
                        },
                        children: [
                            /* @__PURE__ */ jsx21(RadioBox, {
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ jsx21("span", {})
                            }),
                            /* @__PURE__ */ jsxs17(LabelStack, {
                                children: [
                                    /* @__PURE__ */ jsx21(Label, {
                                        children: node.name
                                    }),
                                    ancestryOf ? /* @__PURE__ */ jsx21(Ancestry, {
                                        "data-ancestry": true,
                                        children: ancestryOf
                                    }) : null
                                ]
                            })
                        ]
                    }) : // Item I / brief 19 §3 — the node IS the system Checkbox. `indeterminate` is the
                    // real DOM property, so a silent ancestor announces as `mixed` natively instead of
                    // needing a bespoke "mixed" ring.
                    /* @__PURE__ */ jsx21(ShrinkableCheckbox, {
                        surface: "on-solid",
                        checked: checkState === "true",
                        indeterminate: checkState === "mixed",
                        "aria-label": ancestryOf ? "".concat(node.name, ", ").concat(ancestryOf) : void 0,
                        onChange: function() {
                            return onToggleNode(node.bid);
                        },
                        children: /* @__PURE__ */ jsxs17(LabelStack, {
                            children: [
                                /* @__PURE__ */ jsx21(Label, {
                                    children: node.name
                                }),
                                ancestryOf ? /* @__PURE__ */ jsx21(Ancestry, {
                                    "data-ancestry": true,
                                    children: ancestryOf
                                }) : null
                            ]
                        })
                    }),
                    showValueColumn ? /* @__PURE__ */ jsx21(Value2, {
                        $selected: selected,
                        children: (meta === null || meta === void 0 ? void 0 : meta.value) != null ? String(meta.value) : ""
                    }) : null,
                    (meta === null || meta === void 0 ? void 0 : meta.signal) != null ? /* @__PURE__ */ jsx21(Dot, {
                        $color: colorForValue(meta.signal),
                        title: "".concat(meta.signal, "% average utilisation")
                    }) : null,
                    hasChildren ? /* @__PURE__ */ jsx21(Toggle, {
                        type: "button",
                        "aria-label": "".concat(isOpen ? "Collapse" : "Expand", " ").concat(node.name).concat(ancestryOf ? ", ".concat(ancestryOf) : ""),
                        onClick: function() {
                            return onToggleExpand(node.bid);
                        },
                        children: /* @__PURE__ */ jsx21(Chevron, {
                            $open: isOpen
                        })
                    }) : /* @__PURE__ */ jsx21(TrailGutter, {
                        "aria-hidden": "true"
                    })
                ]
            }),
            hasChildren && isOpen && /* @__PURE__ */ jsx21("ul", {
                role: "group",
                style: {
                    listStyle: "none",
                    margin: 0,
                    padding: 0
                },
                children: node.children.map(function(child) {
                    return /* @__PURE__ */ jsx21(TreeItem, {
                        node: child,
                        depth: depth + 1,
                        mode: mode,
                        state: state,
                        expanded: expanded,
                        index: index,
                        ambiguous: ambiguous,
                        nodeMeta: nodeMeta,
                        colorForValue: colorForValue,
                        onToggleNode: onToggleNode,
                        onToggleExpand: onToggleExpand
                    }, child.bid);
                })
            })
        ]
    });
};
var HierarchicalFilter = function(param) {
    var rows = param.rows, _param_colorForValue = param.colorForValue, colorForValue = _param_colorForValue === void 0 ? fallbackValueColor.colorForValue : _param_colorForValue, _param_mode = param.mode, mode = _param_mode === void 0 ? "multi" : _param_mode, _param_clearable = param.clearable, clearable = _param_clearable === void 0 ? false : _param_clearable, _param_initialExpanded = param.initialExpanded, initialExpanded = _param_initialExpanded === void 0 ? "none" : _param_initialExpanded, defaultRootIndex = param.defaultRootIndex, title = param.title, nodeMeta = param.nodeMeta, onChange = param.onChange, _param_emptyMessage = param.emptyMessage, emptyMessage = _param_emptyMessage === void 0 ? "No filter options" : _param_emptyMessage, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_stale = param.stale, stale = _param_stale === void 0 ? false : _param_stale, _param_error = param.error, error = _param_error === void 0 ? null : _param_error, className = param.className;
    var index = useMemo8(function() {
        return buildHierarchyTree(rows);
    }, [
        rows
    ]);
    var ambiguous = useMemo8(function() {
        return ambiguousLabels(index);
    }, [
        index
    ]);
    var _useState = _sliced_to_array(useState(/* @__PURE__ */ new Map()), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = _sliced_to_array(useState(function() {
        return initialExpanded === "roots" ? new Set(index.roots.map(function(r) {
            return r.bid;
        })) : /* @__PURE__ */ new Set();
    }), 2), expanded = _useState1[0], setExpanded = _useState1[1];
    var rootsSeeded = useRef2(initialExpanded !== "roots" || index.roots.length > 0);
    useEffect2(function() {
        if (initialExpanded === "roots" && !rootsSeeded.current && index.roots.length > 0) {
            rootsSeeded.current = true;
            setExpanded(function(prev) {
                var next = new Set(prev);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = index.roots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        next.add(r.bid);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return next;
            });
        }
    }, [
        initialExpanded,
        index
    ]);
    var rootSeededFor = useRef2(void 0);
    useLayoutEffect(function() {
        var wanted = typeof defaultRootIndex === "number" && Number.isInteger(defaultRootIndex) && defaultRootIndex >= 0 ? defaultRootIndex : void 0;
        if (wanted === void 0 || index.roots.length === 0) return;
        var key = "".concat(wanted, "|").concat(index.roots.map(function(r) {
            return r.bid;
        }).join("|"));
        if (rootSeededFor.current === key) return;
        rootSeededFor.current = key;
        var root = index.roots[wanted];
        if (!root) return;
        var next = toggleSelection(/* @__PURE__ */ new Map(), root.bid, index, {
            mode: mode,
            clearable: clearable
        });
        setState(next);
        onChange({
            pathKeys: selectionPathKeys(next, index),
            bids: selectedBids(next)
        });
    }, [
        defaultRootIndex,
        index,
        mode,
        clearable,
        onChange
    ]);
    var handleToggleNode = function(bid) {
        var next = toggleSelection(state, bid, index, {
            mode: mode,
            clearable: clearable
        });
        setState(next);
        onChange({
            pathKeys: selectionPathKeys(next, index),
            bids: selectedBids(next)
        });
    };
    var handleToggleExpand = function(bid) {
        setExpanded(function(prev) {
            var s = new Set(prev);
            if (s.has(bid)) s.delete(bid);
            else s.add(bid);
            return s;
        });
    };
    var body;
    if (error) {
        body = /* @__PURE__ */ jsx21(EmptyState_default, {
            message: error,
            role: "alert"
        });
    } else if (index.roots.length === 0) {
        body = /* @__PURE__ */ jsx21(EmptyState_default, {
            message: emptyMessage
        });
    } else {
        body = /* @__PURE__ */ jsxs17(Wrap3, {
            className: className,
            children: [
                title ? /* @__PURE__ */ jsx21(Title2, {
                    children: title
                }) : null,
                /* @__PURE__ */ jsx21("ul", {
                    role: "tree",
                    "aria-label": title !== null && title !== void 0 ? title : "Hierarchy filter",
                    style: {
                        listStyle: "none",
                        margin: 0,
                        padding: 0
                    },
                    children: index.roots.map(function(root) {
                        return /* @__PURE__ */ jsx21(TreeItem, {
                            node: root,
                            depth: 0,
                            mode: mode,
                            state: state,
                            expanded: expanded,
                            index: index,
                            ambiguous: ambiguous,
                            nodeMeta: nodeMeta,
                            colorForValue: colorForValue,
                            onToggleNode: handleToggleNode,
                            onToggleExpand: handleToggleExpand
                        }, root.bid);
                    })
                })
            ]
        });
    }
    return /* @__PURE__ */ jsx21(BusyOverlay_default, {
        loading: loading,
        stale: stale,
        children: body
    });
};
// src/charts/components/controls/ControlTitle.tsx
import styled18 from "styled-components";
import { semantic as semantic13, space as space13, typeRole as typeRole16 } from "@repo/design-tokens";
var ControlTitle = styled18.div(_templateObject68(), typeRole16.caption1Strong.fontFamily, typeRole16.caption1Strong.fontSize, typeRole16.caption1Strong.fontWeight, semantic13.text.secondary, space13[2]);
// src/charts/components/controls/GymSelect.tsx
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var Title3 = ControlTitle;
var GymSelect = function(param) {
    var value = param.value, options = param.options, onChange = param.onChange, disabled = param.disabled, _param_title = param.title, title = _param_title === void 0 ? "Gym" : _param_title, className = param.className;
    var _options_find;
    var selectedLabel = (_options_find = options.find(function(o) {
        return o.bid === value;
    })) === null || _options_find === void 0 ? void 0 : _options_find.label;
    return title ? /* @__PURE__ */ jsxs18("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx22(Title3, {
                children: title
            }),
            /* @__PURE__ */ jsx22(BaseDropdown_default, {
                currentValue: value,
                options: options.map(function(o) {
                    return {
                        value: o.bid,
                        label: o.label,
                        icon: null
                    };
                }),
                onOptionChange: onChange,
                disabled: disabled,
                ariaLabel: selectedLabel ? "".concat(title, ": ").concat(selectedLabel) : title
            })
        ]
    }) : /* @__PURE__ */ jsx22(BaseDropdown_default, {
        className: className,
        currentValue: value,
        options: options.map(function(o) {
            return {
                value: o.bid,
                label: o.label,
                icon: null
            };
        }),
        onOptionChange: onChange,
        disabled: disabled
    });
};
// src/charts/components/controls/RoomSelect.tsx
import { jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var ALL_ROOMS = "__all_rooms__";
var RoomSelect = function(param) {
    var value = param.value, options = param.options, onChange = param.onChange, allLabel = param.allLabel, ariaLabel = param.ariaLabel, _param_title = param.title, title = _param_title === void 0 ? "Room" : _param_title, disabled = param.disabled, className = param.className;
    var _options_find;
    var resolved = value !== null && value !== void 0 ? value : ALL_ROOMS;
    var selectedLabel = resolved === ALL_ROOMS ? allLabel !== null && allLabel !== void 0 ? allLabel : "All rooms" : (_options_find = options.find(function(o) {
        return o.bid === resolved;
    })) === null || _options_find === void 0 ? void 0 : _options_find.label;
    var name = ariaLabel || title || "Room";
    var dropdown = /* @__PURE__ */ jsx23(BaseDropdown_default, {
        className: title ? void 0 : className,
        currentValue: resolved,
        ariaLabel: selectedLabel ? "".concat(name, ": ").concat(selectedLabel) : name,
        options: [
            // 🚨 THE CLEARED OPTION IS ALWAYS FIRST AND ALWAYS PRESENT, which is also what guarantees
            // this dropdown is never zero-option. `BaseDropdown` falls back to `options[0]` and
            // dereferences its `.label`/`.icon`, so an empty list THROWS — and for a composite child a
            // throw takes the whole card, because the error boundary is one level up. A twin with no
            // rooms yet therefore still renders a working, honest control rather than a grey card.
            {
                value: ALL_ROOMS,
                label: allLabel !== null && allLabel !== void 0 ? allLabel : "All rooms",
                icon: null
            }
        ].concat(// ⚠️ A ROOM WHOSE BID IS THE SENTINEL IS DROPPED, not rendered. `BaseDropdown` is
        // value-keyed, so such a room would round-trip through `onOptionChange` as `null` — i.e.
        // picking a named room would silently mean "every room". Pathological, and one line to close.
        _to_consumable_array(options.filter(function(o) {
            return o.bid !== ALL_ROOMS;
        }).map(function(o) {
            return {
                value: o.bid,
                label: o.label,
                icon: null
            };
        }))),
        onOptionChange: function(v) {
            return onChange(v === ALL_ROOMS ? null : v);
        },
        disabled: disabled
    });
    return title ? /* @__PURE__ */ jsxs19("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx23(ControlTitle, {
                children: title
            }),
            dropdown
        ]
    }) : dropdown;
};
// src/charts/components/controls/GymMultiSelect.tsx
import { MultiSelect } from "@repo/design-system";
import { jsx as jsx24 } from "react/jsx-runtime";
var capHint = function(max) {
    return "Up to ".concat(max, " gyms can be compared at once. Clear one to add another.");
};
var overCapHint = function(n, max) {
    return "".concat(n, " gyms selected, but only ").concat(max, " can be compared at once. Remove ").concat(n - max, " to see results.");
};
var summary = function(selected, value) {
    var _selected_;
    var _selected__label;
    return value.length === 1 ? (_selected__label = (_selected_ = selected[0]) === null || _selected_ === void 0 ? void 0 : _selected_.label) !== null && _selected__label !== void 0 ? _selected__label : "1 gym" : "".concat(value.length, " gyms");
};
var GymMultiSelect = function(param) {
    var value = param.value, options = param.options, onChange = param.onChange, maxSelected = param.maxSelected, disabled = param.disabled, ariaLabel = param.ariaLabel, className = param.className;
    return /* @__PURE__ */ jsx24(MultiSelect, {
        className: className,
        options: options,
        value: value,
        onChange: function(next) {
            if (next.length > 0) onChange(next);
        },
        maxSelected: maxSelected,
        minSelected: 1,
        capHint: maxSelected !== void 0 ? capHint(maxSelected) : void 0,
        overCapHint: maxSelected !== void 0 && value.length > maxSelected ? overCapHint(value.length, maxSelected) : void 0,
        minHint: "At least one gym must stay selected.",
        summary: summary,
        disabled: disabled,
        ariaLabel: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "Gyms"
    });
};
// src/charts/components/controls/DayTypeSelect.tsx
import styled19 from "styled-components";
import { Checkbox as Checkbox2 } from "@repo/design-system";
import { semantic as semantic14, space as space14, typeRole as typeRole17 } from "@repo/design-tokens";
import { jsx as jsx25, jsxs as jsxs20 } from "react/jsx-runtime";
var Title4 = styled19.div(_templateObject69(), typeRole17.caption1Strong.fontFamily, typeRole17.caption1Strong.fontSize, typeRole17.caption1Strong.fontWeight, semantic14.text.secondary, space14[2]);
var isWeekday = function(v) {
    return v === "all" || v === "weekday";
};
var isWeekend = function(v) {
    return v === "all" || v === "weekend";
};
var combine = function(wd, we) {
    return wd && we ? "all" : wd ? "weekday" : "weekend";
};
var Group = styled19.div(_templateObject70(), space14[4]);
var CheckRow = function(param) {
    var checkboxLabel = param.checkboxLabel, checked = param.checked, disabled = param.disabled, onToggle = param.onToggle;
    return /* @__PURE__ */ jsx25(Checkbox2, {
        surface: "on-solid",
        checked: checked,
        disabled: disabled,
        onChange: onToggle,
        children: checkboxLabel
    });
};
var DayTypeSelect = function(param) {
    var value = param.value, onChange = param.onChange, _param_label = param.label, label = _param_label === void 0 ? "Day type" : _param_label, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = param.className;
    var wd = isWeekday(value);
    var we = isWeekend(value);
    var toggleWeekday = function() {
        if (disabled) return;
        var next = !wd;
        if (!next && !we) return;
        onChange(combine(next, we));
    };
    var toggleWeekend = function() {
        if (disabled) return;
        var next = !we;
        if (!next && !wd) return;
        onChange(combine(wd, next));
    };
    return /* @__PURE__ */ jsxs20("div", {
        className: className,
        children: [
            label ? /* @__PURE__ */ jsx25(Title4, {
                children: label
            }) : null,
            /* @__PURE__ */ jsxs20(Group, {
                role: "group",
                "aria-label": label || void 0,
                children: [
                    /* @__PURE__ */ jsx25(CheckRow, {
                        checkboxLabel: "Weekday",
                        checked: wd,
                        disabled: disabled,
                        onToggle: toggleWeekday
                    }),
                    /* @__PURE__ */ jsx25(CheckRow, {
                        checkboxLabel: "Weekend",
                        checked: we,
                        disabled: disabled,
                        onToggle: toggleWeekend
                    })
                ]
            })
        ]
    });
};
// src/charts/components/controls/DateRangePicker.tsx
import styled20 from "styled-components";
import { semantic as semantic15, space as space15, typeRole as typeRole18 } from "@repo/design-tokens";
import { Input } from "@repo/design-system";
import { jsx as jsx26, jsxs as jsxs21 } from "react/jsx-runtime";
var Wrap4 = styled20.div(_templateObject71(), space15[2], typeRole18.body1.fontFamily, typeRole18.body1.fontSize, semantic15.text.primary);
var Sep = styled20.span(_templateObject72(), semantic15.text.muted);
var Title5 = styled20.div(_templateObject73(), typeRole18.caption1Strong.fontFamily, typeRole18.caption1Strong.fontSize, typeRole18.caption1Strong.fontWeight, semantic15.text.secondary, space15[2]);
var DateRangePicker = function(param) {
    var value = param.value, onChange = param.onChange, min = param.min, max = param.max, _param_title = param.title, title = _param_title === void 0 ? "Date range" : _param_title, className = param.className;
    return(// `role="group"` NAMED BY THE HEADING, so the pair is announced as one control rather than as
    // two loose date fields. The per-field `aria-label`s stay: they say WHICH end each field is,
    // which the group name cannot. An empty title draws no heading and names no group — the one
    // way left to ask for the bare pair.
    /* @__PURE__ */ jsxs21("div", {
        className: className,
        role: title ? "group" : void 0,
        "aria-label": title || void 0,
        children: [
            title ? /* @__PURE__ */ jsx26(Title5, {
                children: title
            }) : null,
            /* @__PURE__ */ jsxs21(Wrap4, {
                children: [
                    /* @__PURE__ */ jsx26(Input, {
                        size: "sm",
                        type: "date",
                        "aria-label": "Start date",
                        value: value.start,
                        min: min,
                        max: value.end || max,
                        onChange: function(e) {
                            return onChange(_object_spread_props(_object_spread({}, value), {
                                start: e.target.value
                            }));
                        }
                    }),
                    /* @__PURE__ */ jsx26(Sep, {
                        "aria-hidden": "true",
                        children: "\u2192"
                    }),
                    /* @__PURE__ */ jsx26(Input, {
                        size: "sm",
                        type: "date",
                        "aria-label": "End date",
                        value: value.end,
                        min: value.start || min,
                        max: max,
                        onChange: function(e) {
                            return onChange(_object_spread_props(_object_spread({}, value), {
                                end: e.target.value
                            }));
                        }
                    })
                ]
            })
        ]
    }));
};
// src/charts/components/PanelCard/PanelCard.tsx
import { Card } from "@repo/design-system";
import { jsx as jsx27 } from "react/jsx-runtime";
var PANEL_SURFACE_TO_CARD = {
    card: "on-solid",
    glassCard: "on-scene",
    overlayCard: "on-glass"
};
var PanelCard = function(param) {
    var tmp = param.surface, surface2 = tmp === void 0 ? "card" : tmp, children = param.children, className = param.className;
    return(// `size="md"` is the geometry PanelCard already had (16px padding, `radius.lg`), so the
    // rebind changes the SURFACE without reflowing any panel that depends on its padding.
    /* @__PURE__ */ jsx27(Card, {
        surface: PANEL_SURFACE_TO_CARD[surface2],
        size: "md",
        className: className,
        "data-surface": surface2,
        children: children
    }));
};
// src/charts/components/ChartHeader/ChartHeader.tsx
import styled22 from "styled-components";
import { semantic as semantic17, space as space17, typeRole as typeRole20 } from "@repo/design-tokens";
// src/charts/components/controls/SegmentedControl.tsx
import { useRef as useRef3 } from "react";
import styled21 from "styled-components";
import { chartTheme as chartTheme16, semantic as semantic16, space as space16, typeRole as typeRole19, motion as motion3 } from "@repo/design-tokens";
import { jsx as jsx28, jsxs as jsxs22 } from "react/jsx-runtime";
var SIZE = {
    small: {
        fontSize: chartTheme16.segmented.fontSize,
        padY: chartTheme16.segmented.padY,
        padX: chartTheme16.segmented.padX
    },
    medium: {
        fontSize: typeRole19.body1.fontSize,
        padY: space16[2],
        padX: space16[3]
    },
    large: {
        fontSize: typeRole19.body1.fontSize,
        padY: space16[2],
        padX: space16[4]
    }
};
var SEG = chartTheme16.segmented;
var Wrap5 = styled21.div(_templateObject74(), space16[1]);
var GroupLabel = styled21.div(_templateObject75(), typeRole19.caption1Strong.fontFamily, typeRole19.caption1Strong.fontSize, typeRole19.caption1Strong.fontWeight, semantic16.text.secondary);
var Track = styled21.div(_templateObject76(), SEG.trackGap, SEG.trackPad, SEG.trackSurface, SEG.trackBorder, SEG.trackRadius);
var Pill = styled21.button(_templateObject77(), typeRole19.caption1.fontFamily, function(param) {
    var $fontSize = param.$fontSize;
    return $fontSize;
}, SEG.fontWeight, function(param) {
    var $padY = param.$padY;
    return $padY;
}, function(param) {
    var $padX = param.$padX;
    return $padX;
}, SEG.pillRadius, function(param) {
    var $selected = param.$selected;
    return $selected ? SEG.onPillInk : SEG.ink;
}, function(param) {
    var $selected = param.$selected;
    return $selected ? SEG.onPillSurface : "transparent";
}, function(param) {
    var $selected = param.$selected;
    return $selected ? SEG.onPillShadow : "none";
}, motion3.durFast, motion3.easeUi, motion3.durFast, motion3.easeUi, SEG.onPillSurface, semantic16.interactive.focusRing, semantic16.interactive.disabled);
var SegmentedControl = function(param) {
    var label = param.label, options = param.options, value = param.value, onChange = param.onChange, _param_size = param.size, size = _param_size === void 0 ? "small" : _param_size, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = param.className, ariaControls = param.ariaControls;
    var _options_selectedIdx;
    var refs = useRef3([]);
    var _SIZE_size = SIZE[size], fontSize = _SIZE_size.fontSize, padY = _SIZE_size.padY, padX = _SIZE_size.padX;
    var foundIdx = options.findIndex(function(o) {
        return o.value === value;
    });
    var selectedIdx = foundIdx >= 0 ? foundIdx : 0;
    var _options_selectedIdx_value;
    var selectedValue = (_options_selectedIdx_value = (_options_selectedIdx = options[selectedIdx]) === null || _options_selectedIdx === void 0 ? void 0 : _options_selectedIdx.value) !== null && _options_selectedIdx_value !== void 0 ? _options_selectedIdx_value : value;
    if (options.length === 0) return null;
    var select2 = function(idx) {
        var _refs_current_i;
        var n = options.length;
        if (n === 0 || disabled) return;
        var i = (idx % n + n) % n;
        onChange(options[i].value);
        (_refs_current_i = refs.current[i]) === null || _refs_current_i === void 0 ? void 0 : _refs_current_i.focus();
    };
    var onKeyDown = function(e, idx) {
        switch(e.key){
            case "ArrowRight":
            case "ArrowDown":
                e.preventDefault();
                select2(idx + 1);
                break;
            case "ArrowLeft":
            case "ArrowUp":
                e.preventDefault();
                select2(idx - 1);
                break;
            case "Home":
                e.preventDefault();
                select2(0);
                break;
            case "End":
                e.preventDefault();
                select2(options.length - 1);
                break;
            default:
                break;
        }
    };
    return /* @__PURE__ */ jsxs22(Wrap5, {
        className: className,
        children: [
            /* @__PURE__ */ jsx28(GroupLabel, {
                children: label
            }),
            /* @__PURE__ */ jsx28(Track, {
                role: "radiogroup",
                "aria-label": label,
                "aria-controls": ariaControls,
                children: options.map(function(o, i) {
                    return /* @__PURE__ */ jsx28(Pill, {
                        ref: function(el) {
                            refs.current[i] = el;
                        },
                        type: "button",
                        role: "radio",
                        "aria-checked": o.value === selectedValue,
                        tabIndex: i === selectedIdx ? 0 : -1,
                        disabled: disabled,
                        $selected: o.value === selectedValue,
                        $fontSize: fontSize,
                        $padY: padY,
                        $padX: padX,
                        onClick: function() {
                            return select2(i);
                        },
                        onKeyDown: function(e) {
                            return onKeyDown(e, i);
                        },
                        children: o.label
                    }, "".concat(_type_of(o.value), ":").concat(String(o.value)));
                })
            })
        ]
    });
};
var SegmentedControl_default = SegmentedControl;
// src/charts/components/ChartHeader/ChartHeader.tsx
import { jsx as jsx29, jsxs as jsxs23 } from "react/jsx-runtime";
var WEEKDAY_ORDER = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var WEEKDAY_ABBR = {
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
    Sunday: "Sun"
};
var Wrap6 = styled22.div(_templateObject78(), space17[2]);
var TopRow = styled22.div(_templateObject79(), space17[3]);
var Titles = styled22.div(_templateObject80(), space17[1]);
var Title6 = styled22.h3(_templateObject81(), typeRole20.subtitle2.fontFamily, typeRole20.subtitle2.fontSize, typeRole20.subtitle2.fontWeight, semantic17.text.primary);
var Subtitle = styled22.p(_templateObject82(), typeRole20.caption1.fontFamily, typeRole20.caption1.fontSize, semantic17.text.secondary);
var Controls = styled22.div(_templateObject83(), space17[3]);
var Note = styled22.p(_templateObject84(), typeRole20.caption1.fontFamily, typeRole20.caption1.fontSize, semantic17.text.muted);
function peakHoursText(windows) {
    var byDay = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = windows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var w = _step.value;
            var _byDay_get;
            var list = (_byDay_get = byDay.get(w.weekday)) !== null && _byDay_get !== void 0 ? _byDay_get : [];
            list.push(formatHourRange(w.start_hour, w.end_hour));
            byDay.set(w.weekday, list);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var parts = WEEKDAY_ORDER.filter(function(d) {
        return byDay.has(d);
    }).map(function(d) {
        return "".concat(WEEKDAY_ABBR[d], " ").concat(byDay.get(d).join(", "));
    });
    return parts.join("; ");
}
var PEAK_OPTIONS = [
    {
        value: "all",
        label: "All hours"
    },
    {
        value: "peak",
        label: "Peak only"
    }
];
var ChartHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, peakWindows = param.peakWindows, note = param.note, metricToggle = param.metricToggle, peakToggle = param.peakToggle, className = param.className;
    var noteText = note !== null && note !== void 0 ? note : peakWindows && peakWindows.length > 0 ? peakHoursText(peakWindows) : null;
    var _metricToggle_label, _peakToggle_label;
    return /* @__PURE__ */ jsxs23(Wrap6, {
        className: className,
        children: [
            /* @__PURE__ */ jsxs23(TopRow, {
                children: [
                    /* @__PURE__ */ jsxs23(Titles, {
                        children: [
                            /* @__PURE__ */ jsx29(Title6, {
                                children: title
                            }),
                            subtitle ? /* @__PURE__ */ jsx29(Subtitle, {
                                children: subtitle
                            }) : null
                        ]
                    }),
                    (metricToggle || peakToggle) && /* @__PURE__ */ jsxs23(Controls, {
                        children: [
                            metricToggle ? /* @__PURE__ */ jsx29(SegmentedControl_default, {
                                label: (_metricToggle_label = metricToggle.label) !== null && _metricToggle_label !== void 0 ? _metricToggle_label : "Metric",
                                value: metricToggle.value,
                                options: metricToggle.options,
                                onChange: function(v) {
                                    return metricToggle.onChange(v);
                                }
                            }) : null,
                            peakToggle ? /* @__PURE__ */ jsx29(SegmentedControl_default, {
                                label: (_peakToggle_label = peakToggle.label) !== null && _peakToggle_label !== void 0 ? _peakToggle_label : "Hours",
                                value: peakToggle.value,
                                options: PEAK_OPTIONS,
                                onChange: function(v) {
                                    return peakToggle.onChange(v);
                                }
                            }) : null
                        ]
                    })
                ]
            }),
            noteText ? /* @__PURE__ */ jsxs23(Note, {
                children: [
                    "Peak hours: ",
                    noteText
                ]
            }) : null
        ]
    });
};
// src/charts/dashboard/chartPanels.tsx
import { useCallback as useCallback2, useEffect as useEffect3, useMemo as useMemo10, useRef as useRef4 } from "react";
// src/charts/core/useValueColor.ts
import { useMemo as useMemo9 } from "react";
import { useTwinConfigStore } from "@repo/front-end-state";
import { findIndicatorConfigForMetric, warnMissingIndicatorConfig } from "@repo/front-end-utils";
import { getIndicatorColor as getIndicatorColor2 } from "@repo/front-end-utils";
var METRIC_NAME_BY_COLOUR_KEY = {
    // Direct matches — the chart key already IS the AdminDB metric name.
    baselineUtilisation: "baselineUtilisation",
    baselineAvgPeakUtilisation: "baselineAvgPeakUtilisation",
    baselineMaxPeakUtilisation: "baselineMaxPeakUtilisation",
    // `manufacturer-comparison`'s by-hour percentage (row 15). BI names the column, AdminDB names
    // the metric, and the two were never reconciled; this is the only by-hour key that is a %.
    utilisation_pct: "baselineUtilisation"
};
var HEX_COLOUR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
var safeColour = function(value, fallback) {
    return HEX_COLOUR.test(value) ? value : fallback();
};
var warnedUnmappedKeys = /* @__PURE__ */ new Set();
var warnUnmappedColourKey = function(key) {
    if (warnedUnmappedKeys.has(key)) return;
    warnedUnmappedKeys.add(key);
    console.warn('[useValueColor] No AdminDB metric mapped for chart colour key "'.concat(key, '"; falling back to the design-token band ramp. Add it to METRIC_NAME_BY_COLOUR_KEY if it is a percentage.'));
};
var useValueColor = function(colourMetricKey) {
    var indicatorConfigs = useTwinConfigStore(function(state) {
        return state.indicatorConfigs;
    });
    return useMemo9(function() {
        var metricName = colourMetricKey && Object.hasOwn(METRIC_NAME_BY_COLOUR_KEY, colourMetricKey) ? METRIC_NAME_BY_COLOUR_KEY[colourMetricKey] : void 0;
        var resolved = metricName ? findIndicatorConfigForMetric(indicatorConfigs, metricName) : void 0;
        if (resolved == null || resolved.selected.length === 0) {
            if (metricName) {
                warnMissingIndicatorConfig(metricName);
            } else if (colourMetricKey) {
                warnUnmappedColourKey(colourMetricKey);
            }
            return fallbackValueColor;
        }
        return {
            colorForValue: function(value) {
                var selected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return safeColour(getIndicatorColor2(domainOf(value), resolved, selected, metricName).bgColor, function() {
                    return fallbackValueColor.colorForValue(value, selected);
                });
            },
            inkForValue: function(value) {
                var selected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return safeColour(getIndicatorColor2(domainOf(value), resolved, selected, metricName).textColor, function() {
                    return fallbackValueColor.inkForValue(value, selected);
                });
            },
            hasConfig: true
        };
    }, [
        indicatorConfigs,
        colourMetricKey
    ]);
};
// src/charts/adapters/adaptEquipmentRecommendations.ts
var SUGGESTION_BUCKET_TITLES = [
    {
        kind: "add",
        title: "Consider adding more of these"
    },
    {
        kind: "reduce",
        title: "Consider fewer of these"
    },
    {
        kind: "remove",
        title: "Consider removing these"
    }
];
var SUGGESTION_BUCKET_CRITERIA = {
    // R1 = 65.
    add: "High utilisation in peak hours (65 % or more)",
    // R2 = 50, R3 = 80, and the rule only ever fires on multi-position kit (units_tracked > 1).
    reduce: "More positions than demand needs \u2014 the rest would stay at or below 50 % busy in peak hours and 80 % at the typical max",
    // R4 = 5, against hours per tracked position per week, on a single-position group.
    remove: "A lone position used under 5 hours a week \u2014 too little to justify its floor space"
};
function positionsDetail(units) {
    var n = Math.round(Math.abs(units));
    var word = n === 1 ? "position" : "positions";
    return "".concat(units < 0 ? "\u2212" : "+").concat(n, " ").concat(word);
}
function currentPositions(row) {
    var tracked = row.units_tracked;
    if (typeof tracked !== "number" || !Number.isFinite(tracked)) return void 0;
    var n = Math.round(tracked);
    if (n <= 0) return void 0;
    return "currently ".concat(n, " ").concat(n === 1 ? "position" : "positions");
}
function detailFor(row) {
    var baseline = currentPositions(row);
    var change = row.suggestion_kind === "remove" ? removeHoursDetail(row) : changePositionsDetail(row);
    return [
        baseline,
        change
    ].filter(Boolean).join(" \xB7 ") || void 0;
}
function removeHoursDetail(row) {
    var hours = row.hours_per_unit_per_week;
    return typeof hours === "number" && Number.isFinite(hours) ? "".concat(hours.toFixed(1), " h/week") : void 0;
}
function changePositionsDetail(row) {
    var units = row.suggestion_units;
    return typeof units === "number" && Number.isFinite(units) ? positionsDetail(units) : void 0;
}
function utilisationFor(row) {
    if (row.suggestion_kind === "remove") return void 0;
    var pct3 = row.peak_utilisation_pct;
    return typeof pct3 === "number" && Number.isFinite(pct3) ? pct3 : void 0;
}
function toItem(row) {
    var _row_group_label;
    return {
        bid: row.group_bid,
        // `group_label` is nullable upstream. An em dash, never the bid: a bID is an opaque
        // catalogue key and is never displayed (row 35).
        label: (_row_group_label = row.group_label) !== null && _row_group_label !== void 0 ? _row_group_label : "\u2014",
        utilisation: utilisationFor(row),
        detail: detailFor(row)
    };
}
function adaptEquipmentRecommendations(rows) {
    return SUGGESTION_BUCKET_TITLES.map(function(param) {
        var kind = param.kind, title = param.title;
        return {
            kind: kind,
            title: title,
            description: SUGGESTION_BUCKET_CRITERIA[kind],
            // Order within the bucket is the SERVICE's and is preserved — no sort, no cap, no slice.
            items: rows.filter(function(r) {
                return r.suggestion_kind === kind;
            }).map(toItem)
        };
    });
}
// src/charts/components/EquipmentCheckTable/SiteWideBanner.tsx
import styled23 from "styled-components";
import { semantic as semantic18, space as space18, radius as radius6, typeRole as typeRole21 } from "@repo/design-tokens";
import { jsx as jsx30, jsxs as jsxs24 } from "react/jsx-runtime";
var Banner = styled23.div(_templateObject85(), space18[3], radius6.md, semantic18.surface.panelTint, semantic18.text.body, typeRole21.body1.fontFamily, typeRole21.body1.fontSize);
var Heading = styled23.strong(_templateObject86(), semantic18.text.primary);
var SiteWideBanner = function(param) {
    var siteWide = param.siteWide, className = param.className;
    return /* @__PURE__ */ jsxs24(Banner, {
        className: className,
        role: "status",
        children: [
            /* @__PURE__ */ jsx30(Heading, {
                children: "Site-wide event"
            }),
            " \u2014 ",
            siteWide.flaggedTotal,
            " of ",
            siteWide.assessedTotal,
            " ",
            "machines affected (",
            siteWide.flaggedPct,
            "%). Likely closure or data gap, not equipment faults."
        ]
    });
};
// src/charts/components/HierarchicalFilter/labelQualifiers.ts
var EM_DASH = "\u2014";
function buildLabelQualifiers(rows) {
    var out = /* @__PURE__ */ Object.create(null);
    if (!Array.isArray(rows) || rows.length === 0) return out;
    var index = buildHierarchyTree(rows);
    var candidates = [];
    Array.from(index.byBid.values()).forEach(function(node) {
        var _index_byBid_get;
        if (node.children.length > 0) return;
        if (!node.name) return;
        var parentBid = node.parentBid;
        var typeName = parentBid === null || parentBid === void 0 ? void 0 : (_index_byBid_get = index.byBid.get(parentBid)) === null || _index_byBid_get === void 0 ? void 0 : _index_byBid_get.name;
        candidates.push({
            bid: node.bid,
            name: node.name,
            typeName: typeName
        });
    });
    var nameCounts = /* @__PURE__ */ new Map();
    candidates.forEach(function(v) {
        var _nameCounts_get;
        return nameCounts.set(v.name, ((_nameCounts_get = nameCounts.get(v.name)) !== null && _nameCounts_get !== void 0 ? _nameCounts_get : 0) + 1);
    });
    candidates.forEach(function(v) {
        if (!v.typeName) return;
        var _nameCounts_get;
        if (((_nameCounts_get = nameCounts.get(v.name)) !== null && _nameCounts_get !== void 0 ? _nameCounts_get : 0) > 1) out[v.bid] = v.typeName;
    });
    return out;
}
function qualifyLabel(bid, label, qualifiers) {
    if (!bid || !qualifiers || !label || label === EM_DASH) return label;
    var typeName = Object.prototype.hasOwnProperty.call(qualifiers, bid) ? qualifiers[bid] : void 0;
    return typeof typeName === "string" && typeName ? "".concat(label, " (").concat(typeName, ")") : label;
}
// src/charts/adapters/adaptBaselineMatrix.ts
var WEEKDAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var WEEKDAY_DAYS = WEEKDAYS.slice(0, 5);
var WEEKEND_DAYS = WEEKDAYS.slice(5);
function daysFor(dayType) {
    if (dayType === "weekday") return WEEKDAY_DAYS;
    if (dayType === "weekend") return WEEKEND_DAYS;
    return WEEKDAYS;
}
function collapseFor(dayCollapse) {
    return dayCollapse !== null && dayCollapse !== void 0 ? dayCollapse : "mean";
}
var numberOrNull = function(v) {
    return typeof v === "number" && Number.isFinite(v) ? v : null;
};
function hourState(grid, days, hour, collapse) {
    if (!grid) return void 0;
    var key = hour.toString().padStart(2, "0");
    var open = [];
    var sawCell = false;
    var sawOpen = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = days[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var day = _step.value;
            var _grid_data_day, _grid_data;
            var cell = (_grid_data = grid.data) === null || _grid_data === void 0 ? void 0 : (_grid_data_day = _grid_data[day]) === null || _grid_data_day === void 0 ? void 0 : _grid_data_day[key];
            if (!Array.isArray(cell)) continue;
            sawCell = true;
            if (cell[1] !== 1) continue;
            sawOpen = true;
            if (Number.isFinite(cell[0])) open.push(cell[0]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!sawCell) return void 0;
    if (open.length > 0) {
        var _Math;
        return collapse === "max" ? (_Math = Math).max.apply(_Math, _to_consumable_array(open)) : open.reduce(function(a, b) {
            return a + b;
        }, 0) / open.length;
    }
    return sawOpen ? void 0 : null;
}
function rowMean(cells) {
    var values = cells.filter(function(v) {
        return typeof v === "number";
    });
    if (values.length === 0) return null;
    return values.reduce(function(a, b) {
        return a + b;
    }, 0) / values.length;
}
var HOURS = Array.from({
    length: 24
}, function(_u, h) {
    return h;
});
function openHourFlags(byBid, groups) {
    var open = /* @__PURE__ */ new Set();
    if (!byBid) return open;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var grid = byBid[group.bid];
            if (!grid) continue;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = WEEKDAYS[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var day = _step1.value;
                    var _grid_data;
                    var row = (_grid_data = grid.data) === null || _grid_data === void 0 ? void 0 : _grid_data[day];
                    if (!row) continue;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = HOURS[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var hour = _step2.value;
                            var cell = row[hour.toString().padStart(2, "0")];
                            if (Array.isArray(cell) && cell[1] === 1) open.add(hour);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return open;
}
var defaultRowLabel = function(g) {
    return g.capacity === null ? g.label : "".concat(g.label, " (cap ").concat(g.capacity, ")");
};
function adaptBaselineMatrix(data, opts) {
    var byBid = data === null || data === void 0 ? void 0 : data[opts.metric];
    var days = daysFor(opts.dayType);
    var collapse = collapseFor(opts.dayCollapse);
    var colorByBid = opts.colorMetric ? data === null || data === void 0 ? void 0 : data[opts.colorMetric] : void 0;
    var built = opts.groups.map(function(group) {
        var grid = byBid === null || byBid === void 0 ? void 0 : byBid[group.bid];
        var states = HOURS.map(function(hour) {
            return hourState(grid, days, hour, collapse);
        });
        var colors = colorByBid ? HOURS.map(function(hour) {
            return hourState(colorByBid[group.bid], days, hour, collapse);
        }) : void 0;
        var order = rowMean(colors !== null && colors !== void 0 ? colors : states);
        return {
            group: group,
            label: defaultRowLabel(group),
            states: states,
            colors: colors,
            order: order
        };
    });
    var sorted = _to_consumable_array(built).sort(function(a, b) {
        if (a.order !== null && b.order !== null && b.order !== a.order) return b.order - a.order;
        if (a.order === null && b.order !== null) return 1;
        if (b.order === null && a.order !== null) return -1;
        return a.label.localeCompare(b.label) || a.group.bid.localeCompare(b.group.bid);
    });
    var over = opts.overCapacityAbove;
    var cells = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var entry = _step.value;
            entry.states.forEach(function(state, hour) {
                if (state === void 0) return;
                var _entry_colors_hour;
                var colour = entry.colors ? (_entry_colors_hour = entry.colors[hour]) !== null && _entry_colors_hour !== void 0 ? _entry_colors_hour : null : void 0;
                var forFlag = colour === void 0 ? state : colour;
                cells.push(_object_spread({
                    row: entry.group.bid,
                    hour: hour,
                    value: state
                }, colour === void 0 ? {} : {
                    colorValue: colour
                }, over !== void 0 && forFlag !== null && forFlag > over ? {
                    overCapacity: true
                } : {}));
            });
        };
        for(var _iterator = sorted[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var axis = openHourFlags(byBid, opts.groups);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = cells[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var cell = _step1.value;
            if (typeof cell.value === "number") axis.add(cell.hour);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var hours = axis.size > 0 ? Array.from(axis).sort(function(a, b) {
        return a - b;
    }) : HOURS.slice();
    return {
        rows: sorted.map(function(e) {
            return {
                id: e.group.bid,
                label: e.label
            };
        }),
        cells: cells,
        hours: hours
    };
}
function groupsFromSummary(summary2, labels) {
    if (!summary2 || (typeof summary2 === "undefined" ? "undefined" : _type_of(summary2)) !== "object" || Array.isArray(summary2)) return [];
    return Object.entries(summary2).filter(function(param) {
        var _param = _sliced_to_array(param, 2), cell = _param[1];
        return cell === null || (typeof cell === "undefined" ? "undefined" : _type_of(cell)) === "object";
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), bid = _param[0], cell = _param[1];
        var _labels_bid;
        return {
            bid: bid,
            label: (_labels_bid = labels === null || labels === void 0 ? void 0 : labels[bid]) !== null && _labels_bid !== void 0 ? _labels_bid : "\u2014",
            capacity: numberOrNull(cell === null || cell === void 0 ? void 0 : cell.capacity),
            trackedCapacity: numberOrNull(cell === null || cell === void 0 ? void 0 : cell.trackedCapacity)
        };
    });
}
function adaptCapacityTiles(grid, opts) {
    var _opts_colorMetric;
    var byBid = grid === null || grid === void 0 ? void 0 : grid[(_opts_colorMetric = opts.colorMetric) !== null && _opts_colorMetric !== void 0 ? _opts_colorMetric : opts.metric];
    var days = daysFor(opts.dayType);
    var collapse = collapseFor(opts.dayCollapse);
    return opts.groups.map(function(group) {
        var states = HOURS.map(function(hour) {
            return hourState(byBid === null || byBid === void 0 ? void 0 : byBid[group.bid], days, hour, collapse);
        });
        return {
            label: group.label,
            // ⚠️ NOT `?? 0`. `CapacityTreemap` filters out non-positive tiles, so coercing an unknown
            // tracked capacity to zero made the group VANISH from the treemap and from its companion
            // table — with the heatmap six inches above still showing it as a row, so the two marks
            // disagreed about how many spaces the gym has. `null` is never `0`; the component keeps the
            // group in its table and says the size is unknown.
            value: group.trackedCapacity,
            colorValue: rowMean(states)
        };
    });
}
// src/charts/adapters/adaptBaseline.ts
var WEEKDAYS2 = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var WEEKDAY_DAYS2 = WEEKDAYS2.slice(0, 5);
var WEEKEND_DAYS2 = WEEKDAYS2.slice(5);
function daysFor2(dayType) {
    if (dayType === "weekday") return WEEKDAY_DAYS2;
    if (dayType === "weekend") return WEEKEND_DAYS2;
    return WEEKDAYS2;
}
function pickBaselineGrid(data, metric) {
    var byBid = data === null || data === void 0 ? void 0 : data[metric];
    if (!byBid) return void 0;
    return Object.values(byBid)[0];
}
function baselineScalar(grid, dayType) {
    if (!(grid === null || grid === void 0 ? void 0 : grid.weekday_aggregation)) return null;
    var values = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = daysFor2(dayType)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var day = _step.value;
            var v = grid.weekday_aggregation[day];
            if (typeof v === "number" && Number.isFinite(v)) values.push(v);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (values.length === 0) return null;
    return values.reduce(function(a, b) {
        return a + b;
    }, 0) / values.length;
}
function baselineSummaryScalar(cell, measure) {
    if (!cell || (typeof cell === "undefined" ? "undefined" : _type_of(cell)) !== "object" || Array.isArray(cell)) return null;
    var v = cell[measure];
    return typeof v === "number" && Number.isFinite(v) ? v : null;
}
function adaptBaselineScalar(data, opts) {
    var grid = pickBaselineGrid(data, opts.metric);
    return baselineScalar(grid, opts.dayType);
}
function hourMean(grid, days, hour) {
    var key = hour.toString().padStart(2, "0");
    var open = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = days[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var day = _step.value;
            var _grid_data_day, _grid_data;
            var cell = (_grid_data = grid.data) === null || _grid_data === void 0 ? void 0 : (_grid_data_day = _grid_data[day]) === null || _grid_data_day === void 0 ? void 0 : _grid_data_day[key];
            if (Array.isArray(cell) && cell[1] === 1 && Number.isFinite(cell[0])) open.push(cell[0]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (open.length === 0) return null;
    return open.reduce(function(a, b) {
        return a + b;
    }, 0) / open.length;
}
function profileSeries(grid, metric, label, days) {
    var points = Array.from({
        length: 24
    }, function(_, hour) {
        return {
            x: hour,
            y: hourMean(grid, days, hour)
        };
    });
    return {
        label: label,
        metric: metric,
        bid: label.toLowerCase(),
        points: points
    };
}
function adaptBaselineProfile(data, opts) {
    var grid = pickBaselineGrid(data, opts.metric);
    if (!grid) return {
        series: [],
        isEmpty: true
    };
    var series = [];
    if (opts.dayType !== "weekend") series.push(profileSeries(grid, opts.metric, "Weekday", WEEKDAY_DAYS2));
    if (opts.dayType !== "weekday") series.push(profileSeries(grid, opts.metric, "Weekend", WEEKEND_DAYS2));
    var isEmpty = series.every(function(s) {
        return s.points.every(function(p) {
            return p.y === null;
        });
    });
    return {
        series: series,
        isEmpty: isEmpty
    };
}
// src/charts/adapters/rowProfileOpenHours.ts
var REFERENCE_MEASURE = "utilisation_pct";
var isFinitePair = function(p) {
    return Array.isArray(p) && typeof p[0] === "number" && Number.isFinite(p[0]) && // ⚠️ `Number.isFinite`, NOT `typeof === 'number'` (Copilot round 2). `typeof NaN` is `'number'`,
    // so the looser spelling let `NaN`/`Infinity` through the ONE filter `narrowRowProfileToHours`
    // applies, and a non-finite `y` reached the chart as a plotted point. `null` is deliberately
    // kept: it is the legitimate GAP this whole family relies on, and dropping it would delete the
    // one state that says "open, and we could not measure it".
    (p[1] === null || Number.isFinite(p[1]));
};
var pairsOf = function(group) {
    var series = group === null || group === void 0 ? void 0 : group.series;
    return Array.isArray(series) ? series.filter(isFinitePair) : [];
};
var measurable = function(v) {
    return typeof v === "number" && Number.isFinite(v);
};
function rowProfileOpenHours(byMetric) {
    if ((typeof byMetric === "undefined" ? "undefined" : _type_of(byMetric)) !== "object" || byMetric === null || Array.isArray(byMetric)) return null;
    var measures = byMetric;
    var reference = measures[REFERENCE_MEASURE];
    if ((typeof reference === "undefined" ? "undefined" : _type_of(reference)) !== "object" || reference === null) return null;
    var keep = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(reference)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = pairsOf(group)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = _sliced_to_array(_step1.value, 2), hod = _step_value[0], value = _step_value[1];
                    if (measurable(value)) keep.add(hod);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = Object.entries(measures)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value1 = _sliced_to_array(_step2.value, 2), name = _step_value1[0], byGroup = _step_value1[1];
            if (name === REFERENCE_MEASURE) continue;
            if ((typeof byGroup === "undefined" ? "undefined" : _type_of(byGroup)) !== "object" || byGroup === null) continue;
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = Object.values(byGroup)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var group1 = _step3.value;
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = pairsOf(group1)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var _step_value2 = _sliced_to_array(_step4.value, 2), hod1 = _step_value2[0], value1 = _step_value2[1];
                            if (measurable(value1) && value1 !== 0) keep.add(hod1);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return keep.size > 0 ? keep : null;
}
function narrowRowProfileToHours(byGroup, hours) {
    if (hours === null) return byGroup;
    if ((typeof byGroup === "undefined" ? "undefined" : _type_of(byGroup)) !== "object" || byGroup === null) return byGroup;
    var out = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(byGroup)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), id = _step_value[0], group = _step_value[1];
            if ((typeof group === "undefined" ? "undefined" : _type_of(group)) !== "object" || group === null) {
                out[id] = group;
                continue;
            }
            var g = group;
            out[id] = Array.isArray(g.series) ? _object_spread_props(_object_spread({}, g), {
                series: g.series.filter(function(p) {
                    return isFinitePair(p) && hours.has(p[0]);
                })
            }) : g;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
// src/charts/adapters/dateWindow.ts
function parseDurationDays(duration) {
    if (typeof duration !== "string") return null;
    var m = /^P(\d+)D$/.exec(duration.trim());
    if (!m) return null;
    var days = Number(m[1]);
    return Number.isFinite(days) && days > 0 ? days : null;
}
function toUtcMs(date) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((date !== null && date !== void 0 ? date : "").trim());
    if (!m) return NaN;
    var ms = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return new Date(ms).toISOString().slice(0, 10) === m[0] ? ms : NaN;
}
var DAY_MS = 864e5;
function toIsoDate(ms) {
    return new Date(ms).toISOString().slice(0, 10);
}
function addDays(date, days) {
    return toIsoDate(toUtcMs(date) + days * DAY_MS);
}
function spanDays(window) {
    return (toUtcMs(window.end) - toUtcMs(window.start)) / DAY_MS;
}
function isValidWindow(window) {
    if (!window) return false;
    var start = window.start, end = window.end;
    if (typeof start !== "string" || typeof end !== "string") return false;
    return Number.isFinite(toUtcMs(start)) && Number.isFinite(toUtcMs(end));
}
function seedWindow(today, defaultWindow) {
    var days = parseDurationDays(defaultWindow);
    if (days === null || !Number.isFinite(toUtcMs(today))) return null;
    var end = addDays(today, 1);
    return {
        start: addDays(end, -days),
        end: end
    };
}
function clampWindow(window, maxSpan) {
    var max = parseDurationDays(maxSpan);
    if (max === null) return window;
    var span = spanDays(window);
    if (!Number.isFinite(span) || span <= 0 || span <= max) return window;
    return {
        start: addDays(window.end, -max),
        end: window.end
    };
}
function boundsFor(today, maxSpan) {
    if (!Number.isFinite(toUtcMs(today))) return {};
    var max = parseDurationDays(maxSpan);
    return {
        min: max === null ? void 0 : addDays(today, -max),
        max: addDays(today, 1)
    };
}
// src/charts/dashboard/chartPanels.tsx
import { Fragment as Fragment12, jsx as jsx31, jsxs as jsxs25 } from "react/jsx-runtime";
function labelQualifiersOf(controlState) {
    var scopeKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "scope";
    var scope = controlState === null || controlState === void 0 ? void 0 : controlState[scopeKey];
    if ((typeof scope === "undefined" ? "undefined" : _type_of(scope)) !== "object" || scope === null) return void 0;
    var q = scope.labelQualifiers;
    return (typeof q === "undefined" ? "undefined" : _type_of(q)) === "object" && q !== null ? q : void 0;
}
var BASELINE_METRICS = /* @__PURE__ */ new Set([
    "baselineUtilisation",
    "baselineAvgHeadcount",
    "baselineAvgPeakHeadcount",
    "baselineMaxPeakHeadcount",
    "baselineAvgPeakUtilisation",
    "baselineMaxPeakUtilisation",
    // equipment-overview-parity (P6 Headcount modes) — the capacity-scaled per-cell est
    // metrics (BI `scaled_baseline_*`). Scale-invariant Utilisation modes stay above.
    "scaledBaselineAvgHeadcount",
    "scaledBaselineAvgPeakHeadcount"
]);
var KNOWN_SUBTEXT_DESCRIPTORS = [
    "capacityTracked",
    "absoluteMax",
    "avgSpareFree"
];
function asString(v) {
    return typeof v === "string" ? v : void 0;
}
function asNumber(v) {
    return typeof v === "number" && Number.isFinite(v) ? v : null;
}
var RANKED_MEASURE_UNITS = {
    peak_utilisation_pct: "%",
    utilisation_pct: "%",
    demand_hours_per_week: " h/wk",
    hours_per_unit_per_week: "h",
    occupancy_hours: "h"
};
function suggestionKindOf(stats) {
    var kind = stats === null || stats === void 0 ? void 0 : stats.suggestion_kind;
    return kind === "add" || kind === "reduce" || kind === "remove" ? kind : null;
}
function orderedMeasureOf(stats) {
    var orderBy = stats === null || stats === void 0 ? void 0 : stats.order_by;
    return typeof orderBy === "string" && Object.prototype.hasOwnProperty.call(RANKED_MEASURE_UNITS, orderBy) ? orderBy : null;
}
var measurable2 = function(pick) {
    return function(row) {
        var v = pick(row);
        return typeof v === "number" && Number.isFinite(v);
    };
};
function dayTypeOf(controlState) {
    var v = controlState === null || controlState === void 0 ? void 0 : controlState.dayType;
    return v === "weekday" || v === "weekend" ? v : "all";
}
function dayCollapseOf(controlState) {
    return (controlState === null || controlState === void 0 ? void 0 : controlState.aggregation) === "typicalMax" ? "max" : "mean";
}
var AGGREGATION_ANNOUNCEMENT = {
    average: "Grid updated. Each space now shows its average across the selected days.",
    typicalMax: "Grid updated. Each space now shows its busiest day."
};
function aggregationAnnouncement(value) {
    var key = asString(value);
    if (!key || !Object.prototype.hasOwnProperty.call(AGGREGATION_ANNOUNCEMENT, key)) {
        return void 0;
    }
    return AGGREGATION_ANNOUNCEMENT[key];
}
var WHOLE_GYM_SCOPE = "Whole gym";
var WEEKEND_DAYS3 = /* @__PURE__ */ new Set([
    "Saturday",
    "Sunday"
]);
var HOURS_IN_DAY = 24;
function hourOrNull(v) {
    if (typeof v === "number") return Number.isFinite(v) ? v : null;
    if (typeof v === "string" && v.trim() !== "") {
        var n = Number(v);
        return Number.isFinite(n) ? n : null;
    }
    return null;
}
function formatPeakRanges(windows) {
    var inPeak = new Array(HOURS_IN_DAY).fill(false);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = windows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var w = _step.value;
            var from = hourOrNull(w.start_hour);
            var to = hourOrNull(w.end_hour);
            if (from === null || to === null) continue;
            if (from < 0 || to > HOURS_IN_DAY || to <= from) continue;
            for(var h = Math.ceil(from); h < to; h++)inPeak[h] = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var parts = [];
    var runStart = null;
    for(var h1 = 0; h1 <= HOURS_IN_DAY; h1++){
        var peak = h1 < HOURS_IN_DAY && inPeak[h1];
        if (peak && runStart === null) {
            runStart = h1;
        } else if (!peak && runStart !== null) {
            parts.push(formatHourRange(runStart, h1));
            runStart = null;
        }
    }
    return parts.join(", ");
}
function peakHoursNote(windows, dayType) {
    var rows = Array.isArray(windows) ? windows.filter(function(w) {
        return w != null && (typeof w === "undefined" ? "undefined" : _type_of(w)) === "object" && typeof w.weekday === "string";
    }) : [];
    var weekday = rows.filter(function(w) {
        return !WEEKEND_DAYS3.has(w.weekday);
    });
    var weekend = rows.filter(function(w) {
        return WEEKEND_DAYS3.has(w.weekday);
    });
    var segments = [];
    var weekdayRanges = dayType !== "weekend" ? formatPeakRanges(weekday) : "";
    var weekendRanges = dayType !== "weekday" ? formatPeakRanges(weekend) : "";
    if (weekdayRanges) segments.push("Weekday ".concat(weekdayRanges));
    if (weekendRanges) segments.push("Weekend ".concat(weekendRanges));
    return segments.length > 0 ? segments.join(" \xB7 ") : void 0;
}
var warnedRows = /* @__PURE__ */ new Set();
function warnRowMismatch(message) {
    if (warnedRows.has(message)) return;
    warnedRows.add(message);
    console.warn(message);
}
var warnedShapes = /* @__PURE__ */ new Set();
function warnShapeError(message) {
    if (warnedShapes.has(message)) return;
    warnedShapes.add(message);
    console.warn("[chartPanels] timeseries envelope unreadable — ".concat(message));
}
function pickScopedRow(rows, wantedBid, panelLabel) {
    if (!Array.isArray(rows) || rows.length === 0) return void 0;
    var match = rows.find(function(r) {
        return r.group_bid === wantedBid;
    });
    if (match) return match;
    if (rows.length === 1) {
        if (wantedBid !== void 0 && rows[0].group_bid !== wantedBid) {
            warnRowMismatch("[chartPanels] ".concat(panelLabel, ': asked for "').concat(wantedBid, '" and got a single row for "').concat(rows[0].group_bid, '" — using it, because one row is an answer, but the scope and the response disagree.'));
        }
        return rows[0];
    }
    var shown = rows.slice(0, 5).map(function(r) {
        var _r_group_bid;
        return (_r_group_bid = r.group_bid) !== null && _r_group_bid !== void 0 ? _r_group_bid : "(none)";
    });
    var more = rows.length > shown.length ? ", +".concat(rows.length - shown.length, " more") : "";
    warnRowMismatch("[chartPanels] ".concat(panelLabel, ': asked for "').concat(wantedBid !== null && wantedBid !== void 0 ? wantedBid : "(no scope)", '" and got ').concat(rows.length, " rows, none of them it — rendering the empty state rather than guessing. Row bids: ").concat(shown.join(", ")).concat(more));
    return void 0;
}
function scopedBidOf(controlState, context) {
    var scope = controlState === null || controlState === void 0 ? void 0 : controlState.scope;
    var bids = Array.isArray(scope === null || scope === void 0 ? void 0 : scope.bids) ? scope.bids : [];
    if (bids.length === 1) return bids[0];
    if (bids.length > 1) return void 0;
    var _asString;
    return (_asString = asString(controlState === null || controlState === void 0 ? void 0 : controlState.twin)) !== null && _asString !== void 0 ? _asString : context === null || context === void 0 ? void 0 : context.twinBid;
}
function pickSpatialRow(rows) {
    var _rows_find;
    return (_rows_find = rows.find(function(r) {
        return r.group_type === "spatial";
    })) !== null && _rows_find !== void 0 ? _rows_find : rows[0];
}
function useScopedRow(rows, wantedBid, state, dataIsCurrent, panelLabel) {
    var settled = state === "ready" && dataIsCurrent === true;
    var picked = useMemo10(function() {
        return settled ? pickScopedRow(rows, wantedBid, panelLabel) : void 0;
    }, [
        settled,
        rows,
        wantedBid,
        panelLabel
    ]);
    var lastGood = useRef4(void 0);
    if (settled) lastGood.current = picked;
    return settled ? picked : lastGood.current;
}
function useUsageBandsRow(param, panelLabel) {
    var data = param.data, state = param.state, dataIsCurrent = param.dataIsCurrent, controlState = param.controlState, context = param.context, applies = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _data_data;
    return useScopedRow(// Narrowed: a hook cannot be called conditionally, so the branch that would have guarded this
    // call guards its INPUT instead — every other metric on the KPI card binds an endpoint whose
    // payload is a keyed object, not a row list.
    applies ? (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : [] : [], scopedBidOf(controlState, context), state, dataIsCurrent, panelLabel);
}
function metricMeta(metric) {
    switch(metric){
        case "baselineUtilisation":
            return {
                label: "Utilisation",
                unit: "%",
                precision: 1
            };
        case "baselineAvgPeakUtilisation":
        case "baselineMaxPeakUtilisation":
            return {
                label: "Typical Max Utilisation",
                unit: "%",
                precision: 1
            };
        case "baselineAvgHeadcount":
        case "scaledBaselineAvgHeadcount":
            return {
                label: "Headcount",
                unit: "people",
                precision: 1
            };
        case "baselineAvgPeakHeadcount":
        case "baselineMaxPeakHeadcount":
        case "scaledBaselineAvgPeakHeadcount":
            return {
                label: "Typical Max Headcount",
                unit: "people",
                precision: 0
            };
        // `manufacturer_comparison`'s two by-hour metrics (row 15). They live here, beside the
        // baseline keys, because the axis label MUST FOLLOW THE TOGGLED METRIC — an authored
        // `metricLabel` is static, so a definition that named one would keep saying "Utilisation %"
        // after the reader switched to demand hours. That is the mislabelled-axis failure the grain
        // comment above describes, one control over.
        //
        // `demand_hours_per_week` is a weekly RATE, not a window total: BI divides each hour's demand
        // by the days the group actually reported and scales to a week, so the 24 points sum to the
        // group's weekly demand and agree with `hours_per_unit_per_week` by construction. The label
        // says "per week" for that reason, and the unit is a WORD unit, so the axis title carries it
        // and the ticks do not (F5's ratified symbol-only rule).
        case "utilisation_pct":
            return {
                label: "Utilisation",
                unit: "%",
                precision: 1
            };
        case "demand_hours_per_week":
            return {
                label: "Demand hours per week",
                unit: "",
                precision: 1
            };
        default:
            return {
                label: "Value",
                unit: "",
                precision: 1
            };
    }
}
function authoredMetricPrecision(props, metric) {
    var blob = props.metricMeta;
    if ((typeof blob === "undefined" ? "undefined" : _type_of(blob)) !== "object" || blob === null || metric === void 0) return void 0;
    var entry = blob[metric];
    if ((typeof entry === "undefined" ? "undefined" : _type_of(entry)) !== "object" || entry === null) return void 0;
    var _asNumber;
    return (_asNumber = asNumber(entry.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0;
}
function pctOver60(row) {
    if (!row || !row.total_open_slots) return null;
    var b = row.bands;
    var _b_60_80, _b_80_90, _b_90_plus;
    var over = ((_b_60_80 = b["60_80"]) !== null && _b_60_80 !== void 0 ? _b_60_80 : 0) + ((_b_80_90 = b["80_90"]) !== null && _b_80_90 !== void 0 ? _b_80_90 : 0) + ((_b_90_plus = b["90_plus"]) !== null && _b_90_plus !== void 0 ? _b_90_plus : 0);
    return 100 * over / row.total_open_slots;
}
var KPICardPanel = function(param) {
    var props = param.props, data = param.data, endpoint = param.endpoint, state = param.state, dataIsCurrent = param.dataIsCurrent, controlState = param.controlState, context = param.context;
    var _asString;
    var label = (_asString = asString(props.label)) !== null && _asString !== void 0 ? _asString : "";
    var size = asString(props.size);
    var metric = asString(props.metric);
    var dayType = dayTypeOf(controlState);
    var _data_capacitySpare;
    var scalars = (_data_capacitySpare = data === null || data === void 0 ? void 0 : data.capacitySpare) !== null && _data_capacitySpare !== void 0 ? _data_capacitySpare : void 0;
    var scopedRow = useUsageBandsRow({
        data: data,
        state: state,
        dataIsCurrent: dataIsCurrent,
        controlState: controlState,
        context: context
    }, "time-over-60", endpoint === "usage_bands");
    var _useMemo10 = useMemo10(function() {
        var authoredUnit = asString(props.unit);
        if (metric && BASELINE_METRICS.has(metric)) {
            var _data_data;
            var scalar = adaptBaselineScalar((_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : void 0, {
                metric: metric,
                dayType: dayType
            });
            return {
                value: scalar == null ? null : Math.round(scalar),
                unit: authoredUnit !== null && authoredUnit !== void 0 ? authoredUnit : metricMeta(metric).unit
            };
        }
        if (metric === "capacity") {
            var _scalars_capacity;
            return {
                value: asNumber((_scalars_capacity = scalars === null || scalars === void 0 ? void 0 : scalars.capacity) !== null && _scalars_capacity !== void 0 ? _scalars_capacity : null),
                unit: authoredUnit
            };
        }
        if (metric === "spareAtTypicalPeak") {
            var _scalars_spareAtTypicalPeak;
            return {
                value: asNumber((_scalars_spareAtTypicalPeak = scalars === null || scalars === void 0 ? void 0 : scalars.spareAtTypicalPeak) !== null && _scalars_spareAtTypicalPeak !== void 0 ? _scalars_spareAtTypicalPeak : null),
                unit: authoredUnit
            };
        }
        if (metric === "estTypicalPeakHeadcount") {
            var _scalars_estTypicalPeakHeadcount;
            var est = asNumber((_scalars_estTypicalPeakHeadcount = scalars === null || scalars === void 0 ? void 0 : scalars.estTypicalPeakHeadcount) !== null && _scalars_estTypicalPeakHeadcount !== void 0 ? _scalars_estTypicalPeakHeadcount : null);
            return {
                value: est == null ? null : Math.round(est),
                unit: authoredUnit
            };
        }
        if (endpoint === "usage_bands" && metric === "pct_over_60") {
            var pct3 = pctOver60(scopedRow);
            return {
                value: pct3 == null ? null : Math.round(pct3),
                unit: authoredUnit !== null && authoredUnit !== void 0 ? authoredUnit : "%"
            };
        }
        if (endpoint === "now") {
            if (!data) return {
                value: null,
                unit: authoredUnit
            };
            var vm = adaptNow(data);
            var _vm_rows_find;
            var row = (_vm_rows_find = vm.rows.find(function(r) {
                return r.groupType === "spatial";
            })) !== null && _vm_rows_find !== void 0 ? _vm_rows_find : vm.rows[0];
            var pct31 = row === null || row === void 0 ? void 0 : row.utilisationPct;
            return {
                value: pct31 == null ? null : Math.round(pct31),
                unit: authoredUnit !== null && authoredUnit !== void 0 ? authoredUnit : "%"
            };
        }
        var headline = data === null || data === void 0 ? void 0 : data.data;
        var _headline_value;
        return {
            value: (_headline_value = headline === null || headline === void 0 ? void 0 : headline.value) !== null && _headline_value !== void 0 ? _headline_value : null,
            unit: authoredUnit !== null && authoredUnit !== void 0 ? authoredUnit : asString(headline === null || headline === void 0 ? void 0 : headline.unit)
        };
    }, [
        metric,
        endpoint,
        data,
        scalars,
        dayType,
        props.unit,
        scopedRow
    ]), value = _useMemo10.value, unit = _useMemo10.unit;
    var subtextDescriptor = asString(props.subtext);
    var subtext = useMemo10(function() {
        if (subtextDescriptor === "capacityTracked") {
            var _scalars_trackedCapacity;
            var tracked = asNumber((_scalars_trackedCapacity = scalars === null || scalars === void 0 ? void 0 : scalars.trackedCapacity) !== null && _scalars_trackedCapacity !== void 0 ? _scalars_trackedCapacity : null);
            var _scalars_capacity;
            var cap = asNumber((_scalars_capacity = scalars === null || scalars === void 0 ? void 0 : scalars.capacity) !== null && _scalars_capacity !== void 0 ? _scalars_capacity : null);
            return tracked != null && cap != null ? "".concat(tracked, " / ").concat(cap, " tracked") : void 0;
        }
        if (subtextDescriptor === "absoluteMax") {
            var _scalars_estAbsolutePeakHeadcount;
            var absPeak = asNumber((_scalars_estAbsolutePeakHeadcount = scalars === null || scalars === void 0 ? void 0 : scalars.estAbsolutePeakHeadcount) !== null && _scalars_estAbsolutePeakHeadcount !== void 0 ? _scalars_estAbsolutePeakHeadcount : null);
            var _scalars_capacity1;
            var cap1 = asNumber((_scalars_capacity1 = scalars === null || scalars === void 0 ? void 0 : scalars.capacity) !== null && _scalars_capacity1 !== void 0 ? _scalars_capacity1 : null);
            return absPeak != null && cap1 != null ? "Absolute max: ".concat(Math.round(absPeak), " / ").concat(cap1) : void 0;
        }
        if (subtextDescriptor === "avgSpareFree") {
            var _scalars_avgSpare;
            var avgSpare = asNumber((_scalars_avgSpare = scalars === null || scalars === void 0 ? void 0 : scalars.avgSpare) !== null && _scalars_avgSpare !== void 0 ? _scalars_avgSpare : null);
            return avgSpare != null ? "average ".concat(Math.round(avgSpare), " during peak hours") : void 0;
        }
        if (subtextDescriptor && !KNOWN_SUBTEXT_DESCRIPTORS.includes(subtextDescriptor)) {
            return subtextDescriptor;
        }
        return void 0;
    }, [
        subtextDescriptor,
        scalars
    ]);
    var denominatorDescriptor = asString(props.denominator);
    var denominatorValue = useMemo10(function() {
        if (denominatorDescriptor === "capacity") {
            var _scalars_capacity, _asNumber;
            return (_asNumber = asNumber((_scalars_capacity = scalars === null || scalars === void 0 ? void 0 : scalars.capacity) !== null && _scalars_capacity !== void 0 ? _scalars_capacity : null)) !== null && _asNumber !== void 0 ? _asNumber : void 0;
        }
        return void 0;
    }, [
        denominatorDescriptor,
        scalars
    ]);
    return /* @__PURE__ */ jsx31(KPICard, {
        label: label,
        value: value,
        unit: unit,
        subtext: subtext,
        highlight: props.highlight === true,
        denominatorValue: denominatorValue,
        size: size,
        deltaSuffix: asString(props.deltaSuffix),
        invertDelta: props.invertDelta === true,
        loading: state === "loading"
    });
};
var BandHistogramPanel = function(param) {
    var props = param.props, data = param.data, state = param.state, dataIsCurrent = param.dataIsCurrent, controlState = param.controlState, context = param.context;
    var row = useUsageBandsRow({
        data: data,
        state: state,
        dataIsCurrent: dataIsCurrent,
        controlState: controlState,
        context: context
    }, "usage-histogram-chart");
    return /* @__PURE__ */ jsx31(BandHistogram, {
        row: row,
        unitMode: asString(props.unitMode),
        emptyMessage: asString(props.emptyMessage),
        loading: state === "loading"
    });
};
var BarChartPanel = function(param) {
    var props = param.props, data = param.data, state = param.state, endpoint = param.endpoint, controlState = param.controlState;
    var labelQualifiers = labelQualifiersOf(controlState);
    var precision = asNumber(props.precision);
    var bars = useMemo10(function() {
        var rows = endpoint === "manufacturer_comparison" ? // ⚠️ `Array.isArray`, NOT `?? []` — and the difference is a grey card for a typo.
        // `measure` selects WHICH PROJECTION the provider returns, and the provider accepts
        // `by_hour` from any binding: paired with this component it hands back the metric-keyed
        // OBJECT, and `.map` on that throws `data.data.map is not a function`. A throw here does
        // not stay local — the composite's error boundary is one level up, so a single
        // mis-authored `measure` takes the whole CARD to `render-error`. Degrading to the empty
        // state is the honest failure for an authoring mistake, and the pairing itself is caught
        // earlier and more cheaply by the component↔measure sweep in `definitions.spec.ts`.
        // (Copilot, PR #1195.)
        (Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : []).map(function(r) {
            return {
                label: r.group_label,
                value: r.value
            };
        }) : // U17 — qualification applies to the RANKED arm ONLY, and it is placed inside this
        // branch rather than over the union above because `manufacturer_comparison`'s rows are
        // comparison groups, not equipment variations: they carry no variation bID, so there is
        // nothing to look up and nothing to qualify. Narrowing here also means a later
        // projection that happened to supply a `bid` could not start qualifying manufacturer
        // labels by accident.
        //
        // ⚠️ The null-label guard, as on every other surface: qualification is keyed by bID, so
        // an unlabelled row whose bID is ambiguous would otherwise paint `— (Pin selected)`.
        adaptRanking(data).rows.map(function(r) {
            if (!r.label) return r;
            var label = qualifyLabel(r.bid, r.label, labelQualifiers);
            return label === r.label ? r : _object_spread_props(_object_spread({}, r), {
                label: label,
                qualified: true
            });
        });
        var round = function(v) {
            return v === null || precision === null || !Number.isFinite(v) ? v : Number(v.toFixed(precision));
        };
        return rows.map(function(r) {
            return _object_spread({
                label: r.label,
                value: round(r.value)
            }, "qualified" in r && r.qualified ? {
                qualified: true
            } : {});
        });
    }, [
        data,
        endpoint,
        precision,
        labelQualifiers
    ]);
    var _asNumber;
    return /* @__PURE__ */ jsx31(BarChart, {
        bars: bars,
        orientation: asString(props.orientation),
        unit: asString(props.unit),
        metricLabel: asString(props.metricLabel),
        valueAxisTitle: props.valueAxisTitle === true,
        maxValue: (_asNumber = asNumber(props.maxValue)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        legend: props.legend === true,
        emptyMessage: asString(props.emptyMessage),
        loading: state === "loading"
    });
};
function asMetricColumns(v) {
    if (!Array.isArray(v)) return [];
    var out = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var raw = _step.value;
            if ((typeof raw === "undefined" ? "undefined" : _type_of(raw)) !== "object" || raw === null) continue;
            var c = raw;
            var key = asString(c.key);
            var header = asString(c.header);
            if (!key || !header) continue;
            var _asNumber, _asNumber1;
            out.push({
                key: key,
                header: header,
                unit: asString(c.unit),
                // Clamped at the component (`toFixed` throws outside 0–100 and would take the whole card to
                // `render-error`); passed through here so the authored value stays visible in a props dump.
                precision: (_asNumber = asNumber(c.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
                scaleMax: (_asNumber1 = asNumber(c.scaleMax)) !== null && _asNumber1 !== void 0 ? _asNumber1 : void 0,
                align: c.align === "left" || c.align === "right" ? c.align : void 0,
                width: asString(c.width),
                sortable: typeof c.sortable === "boolean" ? c.sortable : void 0,
                // MC-F3① — a `text` column reads `row.labels[key]` and renders only where some row supplies
                // the key, which is how the dimension columns follow the split level.
                kind: c.kind === "text" || c.kind === "metric" ? c.kind : void 0,
                // MC-F3② — the per-cell indicator. A RULED override of design card 11; see
                // docs/specs/design-ruling-table-second-indicator.md.
                indicator: typeof c.indicator === "boolean" ? c.indicator : void 0
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
var MetricTablePanel = function(param) {
    var props = param.props, data = param.data, state = param.state;
    var _columns_find;
    var columns = useMemo10(function() {
        return asMetricColumns(props.columns);
    }, [
        props.columns
    ]);
    var colorForValue = useValueColor((_columns_find = columns.find(function(c) {
        return c.indicator;
    })) === null || _columns_find === void 0 ? void 0 : _columns_find.key).colorForValue;
    var rows = useMemo10(function() {
        if (!Array.isArray(data === null || data === void 0 ? void 0 : data.data)) return [];
        return data.data.filter(function(r) {
            return (typeof r === "undefined" ? "undefined" : _type_of(r)) === "object" && r !== null && _type_of(r.values) === "object";
        }).map(function(r, index) {
            var _r_values;
            return {
                // The provider's identity, which is `split_bid` where the row has one and an
                // ancestry-derived key where it does not — never an invented bid. The index tail covers a
                // row that arrives with NO bid; it does not de-duplicate two rows that share one, which is
                // the leg's job (`manufacturerRowIdentity` already guarantees it for this endpoint).
                id: r.group_bid || "row-".concat(index),
                // ⚠️ COERCED, NOT PASSED THROUGH. `MetricTable`'s sort comparator calls
                // `a.label.localeCompare(b.label)`, so an absent `group_label` throws
                // `Cannot read properties of undefined` — on the DEFAULT sort, and only when the bad row
                // lands on the left of a comparison, so it would fail intermittently on row order. The
                // manufacturer leg already degrades a null label to an em dash, but this wrapper is
                // deliberately leg-agnostic and must not trust the next one to.
                label: typeof r.group_label === "string" ? r.group_label : "\u2014",
                values: (_r_values = r.values) !== null && _r_values !== void 0 ? _r_values : {},
                // ⚠️ THREADED, AND THE ABSENT/PRESENT DISTINCTION MUST SURVIVE (MC-F3①). `labels` is SPARSE
                // by design: a key the provider omitted means "this level is not covered by the split", and a
                // key present with `null` means "BI supplied no label". The table turns the first into "no
                // column" and the second into an em dash, so anything here that normalised the shape — a
                // `?? {}` filling in the three keys, or spreading defaults — would collapse the two meanings
                // and give every split three dimension columns. Passed through untouched, and `undefined`
                // only when the provider sent no `labels` at all (an older leg).
                labels: _type_of(r.labels) === "object" && r.labels !== null ? r.labels : void 0
            };
        });
    }, [
        data
    ]);
    return /* @__PURE__ */ jsx31(MetricTable, {
        rows: rows,
        columns: columns,
        colorForValue: colorForValue,
        labelHeader: asString(props.labelHeader),
        labelWidth: asString(props.labelWidth),
        showLabelColumn: props.showLabelColumn === false ? false : void 0,
        defaultSortKey: asString(props.defaultSortKey),
        defaultSortDirection: props.defaultSortDirection === "asc" || props.defaultSortDirection === "desc" ? props.defaultSortDirection : void 0,
        railColumn: asString(props.railColumn),
        emptyMessage: asString(props.emptyMessage),
        ariaLabel: asString(props.ariaLabel),
        loading: state === "loading"
    });
};
function comparisonError(a, b, aLabel, bLabel) {
    if (!b) return "".concat(bLabel, " has no data binding, so there is nothing to compare.");
    if (!a) return "".concat(aLabel, " has no data binding, so there is nothing to compare.");
    if (a.state === "error" && b.state === "error") return "Neither side could be loaded.";
    if (b.state === "error") return "".concat(bLabel, " could not be loaded, so there is nothing to compare.");
    if (a.state === "error") return "".concat(aLabel, " could not be loaded, so there is nothing to compare.");
    return null;
}
var COMPARISON_PROFILE_ENDPOINT = "baseline_view";
function comparisonProfileFamilyError(a, b) {
    var foreign = [
        a,
        b
    ].map(function(side) {
        return side === null || side === void 0 ? void 0 : side.endpoint;
    }).filter(function(endpoint, i) {
        var _i;
        return typeof endpoint === "string" && endpoint !== COMPARISON_PROFILE_ENDPOINT && ((_i = [
            a,
            b
        ][i]) === null || _i === void 0 ? void 0 : _i.state) !== "loading";
    }).filter(function(endpoint, i, all) {
        return all.indexOf(endpoint) === i;
    });
    if (foreign.length === 0) return null;
    return {
        // 🚨 ONE SENTENCE, AND IT IS THE ONLY PART ANNOUNCED. `ComparisonChart` renders `error` in an
        // ASSERTIVE live region, so this is what a screen reader interrupts the listener to say. It
        // states what happened and names nothing a person cannot act on by ear.
        alert: "This panel could not be drawn: its dashboard and this app disagree about where its data comes from.",
        // The reference half — visible, re-readable, and NOT announced. Endpoint names are exactly the
        // material a developer needs on screen and exactly the material nobody needs read aloud. See
        // `ComparisonChartProps.errorDetail`.
        detail: "Bound to ".concat(foreign.map(function(e) {
            return '"'.concat(e, '"');
        }).join(" and "), '; the hour-of-day profile is read from "').concat(COMPARISON_PROFILE_ENDPOINT, '". The panel cannot tell which side is stale: either the published dashboard predates this build of the app (re-import and publish the dashboard), or this build predates the dashboard (deploy the current app).')
    };
}
function sideLabel(side, context, authored) {
    var _context_twins_find, _context_twins;
    if (!side) return authored;
    var _side_group_label;
    var group = side.whole_gym ? "Whole gym" : (_side_group_label = side.group_label) !== null && _side_group_label !== void 0 ? _side_group_label : authored;
    var _context_twins_find_name, _ref;
    var gym = (_ref = (_context_twins_find_name = context === null || context === void 0 ? void 0 : (_context_twins = context.twins) === null || _context_twins === void 0 ? void 0 : (_context_twins_find = _context_twins.find(function(t) {
        return t.bid === side.twin_bid;
    })) === null || _context_twins_find === void 0 ? void 0 : _context_twins_find.name) !== null && _context_twins_find_name !== void 0 ? _context_twins_find_name : // The host twin's own name, for a host that supplies `twinName` but no list yet. Then the bid, which
    // is not ideal and is still better than an unlabelled side.
    side.twin_bid === (context === null || context === void 0 ? void 0 : context.twinBid) ? context === null || context === void 0 ? void 0 : context.twinName : void 0) !== null && _ref !== void 0 ? _ref : side.twin_bid;
    return "".concat(group, " \xb7 ").concat(gym);
}
function asComparisonMeasures(v) {
    if (!Array.isArray(v)) return [];
    var out = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var raw = _step.value;
            if ((typeof raw === "undefined" ? "undefined" : _type_of(raw)) !== "object" || raw === null) continue;
            var c = raw;
            var key = asString(c.key);
            var label = asString(c.label);
            if (!key || !label) continue;
            var _asNumber;
            out.push({
                key: key,
                label: label,
                unit: asString(c.unit),
                // Clamped at the component (`toFixed` throws outside 0–100 and would take the whole card to
                // `render-error`); passed through here so an authored value stays visible in a props dump.
                precision: (_asNumber = asNumber(c.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
function asSideCard(env) {
    var data = env === null || env === void 0 ? void 0 : env.data;
    if (!data || (typeof data === "undefined" ? "undefined" : _type_of(data)) !== "object") return {
        side: null,
        values: null
    };
    var _data_side;
    return {
        side: (_data_side = data.side) !== null && _data_side !== void 0 ? _data_side : null,
        values: data.values && _type_of(data.values) === "object" ? data.values : null
    };
}
function asComparisonKpiMeasures(v) {
    if (!Array.isArray(v)) return [];
    return v.flatMap(function(raw) {
        if (!raw || (typeof raw === "undefined" ? "undefined" : _type_of(raw)) !== "object") return [];
        var m = raw;
        var key = asString(m.key);
        var label = asString(m.label);
        if (!key || !label) return [];
        var _asNumber, _asString;
        return [
            {
                key: key,
                label: label,
                unit: asString(m.unit),
                precision: (_asNumber = asNumber(m.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
                // `grid` is the default and is what every measure authored before this field means.
                source: m.source === "summary" ? "summary" : m.source === "peak" ? "peak" : "grid",
                // The row's identity (`key`) and the metric it reads are the same thing until two rows read
                // one metric over different windows — see the props schema.
                metric: (_asString = asString(m.metric)) !== null && _asString !== void 0 ? _asString : key
            }
        ];
    });
}
function baselineSideLabel(controlState, context, scopeKey, twinKey) {
    var _context_twins_find, _context_twins;
    var scope = controlState === null || controlState === void 0 ? void 0 : controlState[scopeKey];
    var _ref;
    var selection = (_ref = typeof (scope === null || scope === void 0 ? void 0 : scope.label) === "string" && scope.label !== "" ? scope.label : null) !== null && _ref !== void 0 ? _ref : WHOLE_GYM_SCOPE;
    var twinBid = asString(controlState === null || controlState === void 0 ? void 0 : controlState[twinKey]);
    var _context_twins_find_name, _ref1;
    var gym = (_ref1 = (_context_twins_find_name = context === null || context === void 0 ? void 0 : (_context_twins = context.twins) === null || _context_twins === void 0 ? void 0 : (_context_twins_find = _context_twins.find(function(t) {
        return t.bid === twinBid;
    })) === null || _context_twins_find === void 0 ? void 0 : _context_twins_find.name) !== null && _context_twins_find_name !== void 0 ? _context_twins_find_name : // The host twin's own name, for a host that supplies `twinName` but no list yet. Then the
    // bid — not ideal, and still better than an unlabelled side. Never blank.
    twinBid === (context === null || context === void 0 ? void 0 : context.twinBid) ? context === null || context === void 0 ? void 0 : context.twinName : void 0) !== null && _ref1 !== void 0 ? _ref1 : twinBid;
    return gym ? "".concat(selection, " \xb7 ").concat(gym) : selection;
}
function baselineValues(envs, measures, dayType) {
    var _envs_grid, _envs_peak, _envs_scalars;
    var _envs_grid_data;
    var grid = (_envs_grid_data = (_envs_grid = envs.grid) === null || _envs_grid === void 0 ? void 0 : _envs_grid.data) !== null && _envs_grid_data !== void 0 ? _envs_grid_data : void 0;
    if (!grid) return null;
    var _envs_peak_data;
    var peak = (_envs_peak_data = (_envs_peak = envs.peak) === null || _envs_peak === void 0 ? void 0 : _envs_peak.data) !== null && _envs_peak_data !== void 0 ? _envs_peak_data : void 0;
    var _envs_scalars_data;
    var scalars = (_envs_scalars_data = (_envs_scalars = envs.scalars) === null || _envs_scalars === void 0 ? void 0 : _envs_scalars.data) !== null && _envs_scalars_data !== void 0 ? _envs_scalars_data : void 0;
    var out = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = measures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            if (m.source === "summary") {
                out[m.key] = baselineSummaryScalar(scalars, m.metric);
                continue;
            }
            var env = m.source === "peak" ? peak : grid;
            out[m.key] = env ? adaptBaselineScalar(env, {
                metric: m.metric,
                dayType: dayType
            }) : null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
function baselineSideSeries(env, dayType) {
    var _env_data;
    var grid = (_env_data = env === null || env === void 0 ? void 0 : env.data) !== null && _env_data !== void 0 ? _env_data : void 0;
    var series = {};
    if (!grid) return {
        side: null,
        series: series
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(grid)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var metric = _step.value;
            var _adaptBaselineProfile = adaptBaselineProfile(grid, {
                metric: metric,
                dayType: dayType
            }), got = _adaptBaselineProfile.series, isEmpty = _adaptBaselineProfile.isEmpty;
            var first = got[0];
            if (!first || isEmpty) continue;
            series[metric] = first.points.map(function(pt) {
                return [
                    Number(pt.x),
                    pt.y
                ];
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        side: null,
        series: series
    };
}
var ComparisonKPIPanel = function(param) {
    var props = param.props, _param_bindings = param.bindings, bindings = _param_bindings === void 0 ? {} : _param_bindings, controlState = param.controlState, context = param.context;
    var sideA = bindings["sideA.grid"];
    var sideB = bindings["sideB.grid"];
    var sideAScalars = bindings["sideA.scalars"];
    var sideBScalars = bindings["sideB.scalars"];
    var sideAPeak = bindings["sideA.peak"];
    var sideBPeak = bindings["sideB.peak"];
    var liveData = function(binding) {
        return (binding === null || binding === void 0 ? void 0 : binding.state) === "error" ? void 0 : binding === null || binding === void 0 ? void 0 : binding.data;
    };
    var allSix = [
        sideA,
        sideAPeak,
        sideAScalars,
        sideB,
        sideBPeak,
        sideBScalars
    ];
    var measures = useMemo10(function() {
        return asComparisonKpiMeasures(props.measures);
    }, [
        props.measures
    ]);
    var dayType = dayTypeOf(controlState);
    var rawA = baselineSideLabel(controlState, context, "scopeA", "sideA");
    var rawB = baselineSideLabel(controlState, context, "scopeB", "sideB");
    var _asString;
    var authoredA = (_asString = asString(props.aLabel)) !== null && _asString !== void 0 ? _asString : "Side A";
    var _asString1;
    var authoredB = (_asString1 = asString(props.bLabel)) !== null && _asString1 !== void 0 ? _asString1 : "Side B";
    var collides = rawA === rawB;
    var aLabel = (sideA === null || sideA === void 0 ? void 0 : sideA.state) === "error" ? authoredA : collides ? "".concat(authoredA, " \xb7 ").concat(rawA) : rawA;
    var bLabel = (sideB === null || sideB === void 0 ? void 0 : sideB.state) === "error" ? authoredB : collides ? "".concat(authoredB, " \xb7 ").concat(rawB) : rawB;
    var a = useMemo10(function() {
        return {
            label: aLabel,
            values: baselineValues({
                grid: liveData(sideA),
                peak: liveData(sideAPeak),
                scalars: liveData(sideAScalars)
            }, measures, dayType)
        };
    }, [
        aLabel,
        sideA === null || sideA === void 0 ? void 0 : sideA.data,
        sideA === null || sideA === void 0 ? void 0 : sideA.state,
        sideAPeak === null || sideAPeak === void 0 ? void 0 : sideAPeak.data,
        sideAPeak === null || sideAPeak === void 0 ? void 0 : sideAPeak.state,
        sideAScalars === null || sideAScalars === void 0 ? void 0 : sideAScalars.data,
        sideAScalars === null || sideAScalars === void 0 ? void 0 : sideAScalars.state,
        measures,
        dayType
    ]);
    var b = useMemo10(function() {
        return {
            label: bLabel,
            values: baselineValues({
                grid: liveData(sideB),
                peak: liveData(sideBPeak),
                scalars: liveData(sideBScalars)
            }, measures, dayType)
        };
    }, [
        bLabel,
        sideB === null || sideB === void 0 ? void 0 : sideB.data,
        sideB === null || sideB === void 0 ? void 0 : sideB.state,
        sideBPeak === null || sideBPeak === void 0 ? void 0 : sideBPeak.data,
        sideBPeak === null || sideBPeak === void 0 ? void 0 : sideBPeak.state,
        sideBScalars === null || sideBScalars === void 0 ? void 0 : sideBScalars.data,
        sideBScalars === null || sideBScalars === void 0 ? void 0 : sideBScalars.state,
        measures,
        dayType
    ]);
    var _asNumber;
    return /* @__PURE__ */ jsx31(ComparisonKPI, {
        measures: measures,
        a: a,
        b: b,
        deltaMode: props.deltaMode === "ratio" ? "ratio" : "difference",
        summaryMeasure: asString(props.summaryMeasure),
        summaryNoun: asString(props.summaryNoun),
        roughlyEqualBelow: (_asNumber = asNumber(props.roughlyEqualBelow)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        emptyMessage: asString(props.emptyMessage),
        loading: allSix.some(function(x) {
            return (x === null || x === void 0 ? void 0 : x.state) === "loading";
        }),
        summarySuppressed: allSix.some(function(x) {
            return x && x.state !== "ready";
        }),
        error: comparisonError(sideA, sideB, aLabel, bLabel)
    });
};
var ComparisonTablePanel = function(param) {
    var props = param.props, _param_bindings = param.bindings, bindings = _param_bindings === void 0 ? {} : _param_bindings, context = param.context;
    var sideA = bindings.sideA;
    var sideB = bindings.sideB;
    var measures = useMemo10(function() {
        return asComparisonMeasures(props.measures);
    }, [
        props.measures
    ]);
    var a = useMemo10(function() {
        return asSideCard(sideA === null || sideA === void 0 ? void 0 : sideA.data);
    }, [
        sideA === null || sideA === void 0 ? void 0 : sideA.data
    ]);
    var b = useMemo10(function() {
        return asSideCard(sideB === null || sideB === void 0 ? void 0 : sideB.data);
    }, [
        sideB === null || sideB === void 0 ? void 0 : sideB.data
    ]);
    var _asString;
    var aLabel = sideLabel((sideA === null || sideA === void 0 ? void 0 : sideA.state) === "error" ? null : a.side, context, (_asString = asString(props.aLabel)) !== null && _asString !== void 0 ? _asString : "A");
    var _asString1;
    var bLabel = sideLabel((sideB === null || sideB === void 0 ? void 0 : sideB.state) === "error" ? null : b.side, context, (_asString1 = asString(props.bLabel)) !== null && _asString1 !== void 0 ? _asString1 : "B");
    var rows = useMemo10(function() {
        return measures.map(function(m) {
            var _a_values, _b_values;
            var _a_values_m_key, _b_values_m_key;
            return {
                label: m.label,
                // `?? null`, never `?? 0`: an absent key and an explicit null are the same statement — "not
                // measurable" — and both must reach the cell as the em dash.
                a: (_a_values_m_key = (_a_values = a.values) === null || _a_values === void 0 ? void 0 : _a_values[m.key]) !== null && _a_values_m_key !== void 0 ? _a_values_m_key : null,
                b: (_b_values_m_key = (_b_values = b.values) === null || _b_values === void 0 ? void 0 : _b_values[m.key]) !== null && _b_values_m_key !== void 0 ? _b_values_m_key : null,
                unit: m.unit,
                precision: m.precision
            };
        });
    }, [
        measures,
        a,
        b
    ]);
    var _asString2, _asNumber;
    return /* @__PURE__ */ jsx31(ComparisonTable, {
        rows: rows,
        aLabel: aLabel,
        bLabel: bLabel,
        labelHeader: (_asString2 = asString(props.labelHeader)) !== null && _asString2 !== void 0 ? _asString2 : "Measure",
        showLabelHeader: props.showLabelHeader !== false,
        labelWidth: asString(props.labelWidth),
        ariaLabel: asString(props.ariaLabel),
        unit: asString(props.unit),
        precision: (_asNumber = asNumber(props.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        spotlightVariant: props.spotlightVariant === "B" ? "B" : void 0,
        deltaTone: props.deltaTone === "up-good" || props.deltaTone === "down-good" ? props.deltaTone : void 0,
        emptyMessage: asString(props.emptyMessage),
        loading: (sideA === null || sideA === void 0 ? void 0 : sideA.state) === "loading" || (sideB === null || sideB === void 0 ? void 0 : sideB.state) === "loading",
        error: comparisonError(sideA, sideB, aLabel, bLabel)
    });
};
var ComparisonChartPanel = function(param) {
    var props = param.props, _param_bindings = param.bindings, bindings = _param_bindings === void 0 ? {} : _param_bindings, controlState = param.controlState, context = param.context;
    var sideA = bindings.sideA;
    var sideB = bindings.sideB;
    var dayType = dayTypeOf(controlState);
    var familyMismatch = comparisonProfileFamilyError(sideA, sideB);
    var a = useMemo10(function() {
        return baselineSideSeries(sideA === null || sideA === void 0 ? void 0 : sideA.data, dayType);
    }, [
        sideA === null || sideA === void 0 ? void 0 : sideA.data,
        dayType
    ]);
    var b = useMemo10(function() {
        return baselineSideSeries(sideB === null || sideB === void 0 ? void 0 : sideB.data, dayType);
    }, [
        sideB === null || sideB === void 0 ? void 0 : sideB.data,
        dayType
    ]);
    var rawA = baselineSideLabel(controlState, context, "scopeA", "sideA");
    var rawB = baselineSideLabel(controlState, context, "scopeB", "sideB");
    var collides = rawA === rawB;
    var _asString, _asString1;
    var aLabel = (sideA === null || sideA === void 0 ? void 0 : sideA.state) === "error" ? (_asString = asString(props.aLabel)) !== null && _asString !== void 0 ? _asString : "Side A" : collides ? "".concat((_asString1 = asString(props.aLabel)) !== null && _asString1 !== void 0 ? _asString1 : "Side A", " \xb7 ").concat(rawA) : rawA;
    var _asString2, _asString3;
    var bLabel = (sideB === null || sideB === void 0 ? void 0 : sideB.state) === "error" ? (_asString2 = asString(props.bLabel)) !== null && _asString2 !== void 0 ? _asString2 : "Side B" : collides ? "".concat((_asString3 = asString(props.bLabel)) !== null && _asString3 !== void 0 ? _asString3 : "Side B", " \xb7 ").concat(rawB) : rawB;
    var metric = useMemo10(function() {
        if (props.metricMatrix && _type_of(props.metricMatrix) === "object") {
            return resolveProfileMetric(props, controlState);
        }
        var _asString;
        var controlId = (_asString = asString(props.metricControl)) !== null && _asString !== void 0 ? _asString : "metric";
        var selected = asString(controlState === null || controlState === void 0 ? void 0 : controlState[controlId]);
        if (selected) return selected;
        var _Object_keys_, _ref;
        return (_ref = (_Object_keys_ = Object.keys(a.series)[0]) !== null && _Object_keys_ !== void 0 ? _Object_keys_ : Object.keys(b.series)[0]) !== null && _ref !== void 0 ? _ref : "";
    }, [
        props.metricMatrix,
        props.metricControl,
        controlState,
        a.series,
        b.series
    ]);
    var toPoints2 = function(pairs) {
        return (pairs !== null && pairs !== void 0 ? pairs : []).map(function(param) {
            var _param = _sliced_to_array(param, 2), x = _param[0], y = _param[1];
            return {
                x: x,
                y: y
            };
        });
    };
    var _props_metricMeta;
    var meta = (_props_metricMeta = props.metricMeta) !== null && _props_metricMeta !== void 0 ? _props_metricMeta : {};
    var _ref;
    var entry = (_ref = (typeof meta === "undefined" ? "undefined" : _type_of(meta)) === "object" && meta !== null ? meta[metric] : void 0) !== null && _ref !== void 0 ? _ref : {};
    var _asString4, _asString5, _asString6, _asNumber, _familyMismatch_alert;
    return /* @__PURE__ */ jsx31(ComparisonChart, {
        a: {
            label: aLabel,
            points: toPoints2(a.series[metric])
        },
        b: {
            label: bLabel,
            points: toPoints2(b.series[metric])
        },
        grain: (_asString4 = asString(props.grain)) !== null && _asString4 !== void 0 ? _asString4 : "hourly",
        profile: true,
        xAxisLabel: asString(props.xAxisLabel),
        metricLabel: (_asString5 = asString(entry.label)) !== null && _asString5 !== void 0 ? _asString5 : asString(props.metricLabel),
        unit: (_asString6 = asString(entry.unit)) !== null && _asString6 !== void 0 ? _asString6 : asString(props.unit),
        precision: (_asNumber = asNumber(entry.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        loading: (sideA === null || sideA === void 0 ? void 0 : sideA.state) === "loading" || (sideB === null || sideB === void 0 ? void 0 : sideB.state) === "loading",
        error: (_familyMismatch_alert = familyMismatch === null || familyMismatch === void 0 ? void 0 : familyMismatch.alert) !== null && _familyMismatch_alert !== void 0 ? _familyMismatch_alert : comparisonError(sideA, sideB, aLabel, bLabel),
        errorDetail: familyMismatch === null || familyMismatch === void 0 ? void 0 : familyMismatch.detail
    });
};
var GymSelectControl = function(param) {
    var props = param.props, value = param.value, onChange = param.onChange, context = param.context;
    var _options_;
    var twins = context === null || context === void 0 ? void 0 : context.twins;
    var _asString;
    var selected = (_asString = asString(value)) !== null && _asString !== void 0 ? _asString : "";
    var options = useMemo10(function() {
        var listed = (twins !== null && twins !== void 0 ? twins : []).map(function(t) {
            return {
                bid: t.bid,
                label: t.name
            };
        });
        if (listed.length > 0) return listed;
        var fallbackBid = selected || (context === null || context === void 0 ? void 0 : context.twinBid);
        var _context_twinName;
        if (fallbackBid) return [
            {
                bid: fallbackBid,
                label: (_context_twinName = context === null || context === void 0 ? void 0 : context.twinName) !== null && _context_twinName !== void 0 ? _context_twinName : fallbackBid
            }
        ];
        return [
            {
                bid: "",
                label: "No gym available"
            }
        ];
    }, [
        twins,
        selected,
        context === null || context === void 0 ? void 0 : context.twinBid,
        context === null || context === void 0 ? void 0 : context.twinName
    ]);
    var reachable = twins !== void 0 && twins.length > 0;
    var resolvable = !reachable || twins.some(function(t) {
        return t.bid === selected;
    });
    var seeded = useRef4(false);
    useEffect3(function() {
        if (resolvable || seeded.current || !onChange) return;
        seeded.current = true;
        var host = twins.find(function(t) {
            return t.bid === (context === null || context === void 0 ? void 0 : context.twinBid);
        });
        onChange((host !== null && host !== void 0 ? host : twins[0]).bid);
    }, [
        resolvable,
        twins,
        onChange,
        context === null || context === void 0 ? void 0 : context.twinBid
    ]);
    return /* @__PURE__ */ jsx31(GymSelect, {
        value: selected || ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.bid) || "",
        options: options,
        onChange: function(bid) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(bid);
        },
        disabled: props.disabled === true || options.length <= 1,
        title: asString(props.title)
    });
};
function liveGymCap(props, levelCount) {
    var positive = function(v) {
        return typeof v === "number" && Number.isFinite(v) && v >= 1 ? Math.floor(v) : void 0;
    };
    var staticCap = positive(props.maxSelected);
    var maxReads = positive(props.maxReads);
    var perLevel = positive(props.readsPerTwinPerLevel);
    var levels = positive(levelCount);
    if (maxReads === void 0 || perLevel === void 0 || levels === void 0) return staticCap;
    var budgetCap = Math.max(1, Math.floor(maxReads / (perLevel * levels)));
    return staticCap === void 0 ? budgetCap : Math.min(staticCap, budgetCap);
}
var GymMultiSelectControl = function(param) {
    var props = param.props, value = param.value, onChange = param.onChange, context = param.context, controlState = param.controlState;
    var _twins_find, _twins_, _twins_1;
    var twins = context === null || context === void 0 ? void 0 : context.twins;
    var raw = useMemo10(function() {
        var list = Array.isArray(value) ? value : typeof value === "string" && value !== "" ? [
            value
        ] : [];
        var seen = /* @__PURE__ */ new Set();
        var out = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var v = _step.value;
                if (typeof v !== "string" || v === "" || seen.has(v)) continue;
                seen.add(v);
                out.push(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return out;
    }, [
        value
    ]);
    var reachable = twins !== void 0 && twins.length > 0;
    var clamped = useMemo10(function() {
        return reachable ? raw.filter(function(bid) {
            return twins.some(function(t) {
                return t.bid === bid;
            });
        }) : raw;
    }, [
        reachable,
        raw,
        twins
    ]);
    var _twins_find_bid, _ref;
    var fallback = (_ref = reachable ? (_twins_find_bid = (_twins_find = twins.find(function(t) {
        return t.bid === (context === null || context === void 0 ? void 0 : context.twinBid);
    })) === null || _twins_find === void 0 ? void 0 : _twins_find.bid) !== null && _twins_find_bid !== void 0 ? _twins_find_bid : (_twins_ = twins[0]) === null || _twins_ === void 0 ? void 0 : _twins_.bid : context === null || context === void 0 ? void 0 : context.twinBid) !== null && _ref !== void 0 ? _ref : twins === null || twins === void 0 ? void 0 : (_twins_1 = twins[0]) === null || _twins_1 === void 0 ? void 0 : _twins_1.bid;
    var selection = useMemo10(function() {
        if (clamped.length > 0) return [
            clamped[0]
        ].concat(_to_consumable_array(clamped.slice(1)));
        return fallback ? [
            fallback
        ] : void 0;
    }, [
        clamped,
        fallback
    ]);
    useEffect3(function() {
        if (!onChange || selection === void 0) return;
        var stored = Array.isArray(value) ? value : void 0;
        if (stored && stored.length === selection.length && stored.every(function(v, i) {
            return v === selection[i];
        })) return;
        onChange(_to_consumable_array(selection));
    }, [
        onChange,
        selection,
        value
    ]);
    var options = useMemo10(function() {
        var listed = (twins !== null && twins !== void 0 ? twins : []).map(function(t) {
            return {
                value: t.bid,
                label: t.name
            };
        });
        if (listed.length > 0) return listed;
        return selection ? selection.map(function(bid) {
            var _context_twinName;
            return {
                value: bid,
                label: bid === (context === null || context === void 0 ? void 0 : context.twinBid) ? (_context_twinName = context === null || context === void 0 ? void 0 : context.twinName) !== null && _context_twinName !== void 0 ? _context_twinName : bid : bid
            };
        }) : [];
    }, [
        twins,
        selection,
        context === null || context === void 0 ? void 0 : context.twinBid,
        context === null || context === void 0 ? void 0 : context.twinName
    ]);
    var _asString;
    var scopeState = controlState === null || controlState === void 0 ? void 0 : controlState[(_asString = asString(props.scopeControl)) !== null && _asString !== void 0 ? _asString : ""];
    var liveCap = liveGymCap(props, scopeState === null || scopeState === void 0 ? void 0 : scopeState.levelCount);
    if (selection === void 0) {
        return /* @__PURE__ */ jsx31(GymMultiSelect, {
            value: [
                ""
            ],
            options: [
                {
                    value: "",
                    label: "No gym available"
                }
            ],
            onChange: function() {
                return void 0;
            },
            disabled: true
        });
    }
    return /* @__PURE__ */ jsx31(GymMultiSelect, {
        value: selection,
        options: options,
        onChange: function(next) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(_to_consumable_array(next));
        },
        maxSelected: liveCap,
        disabled: props.disabled === true || options.length <= 1
    });
};
var RoomSelectControl = function(param) {
    var props = param.props, data = param.data, state = param.state, value = param.value, onChange = param.onChange;
    var _data_data;
    var entities = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.entities;
    var options = useMemo10(function() {
        var rows = Array.isArray(entities) ? entities : [];
        var byBid = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (typeof (e === null || e === void 0 ? void 0 : e.bid) !== "string" || e.bid === "") continue;
                if (byBid.has(e.bid)) continue;
                byBid.set(e.bid, {
                    bid: e.bid,
                    // ⚠️ Falls back to the bid ONLY as a last resort for an unlabelled room, so the option is
                    // still selectable rather than a blank line the user cannot tell apart from another blank
                    // line. This is not the row-35 violation it resembles: it is a degraded DISPLAY for a
                    // missing label, not a bid used as an identity.
                    label: typeof e.label === "string" && e.label !== "" ? e.label : e.bid
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Array.from(byBid.values());
    }, [
        entities
    ]);
    var selected = typeof value === "string" && value !== "" ? value : null;
    var arrived = Array.isArray(entities);
    var resolvable = selected === null || !arrived || options.some(function(o) {
        return o.bid === selected;
    });
    var corrected = useRef4(false);
    useEffect3(function() {
        if (corrected.current || !onChange) return;
        var illegal = value === "" || selected !== null && arrived && !resolvable;
        if (!illegal) return;
        corrected.current = true;
        onChange(null);
    }, [
        value,
        selected,
        arrived,
        resolvable,
        onChange
    ]);
    var _asString;
    return /* @__PURE__ */ jsx31(RoomSelect, {
        value: resolvable ? selected : null,
        options: options,
        onChange: function(bid) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(bid);
        },
        allLabel: state === "error" ? "All rooms \u2014 room list unavailable" : (_asString = asString(props.allLabel)) !== null && _asString !== void 0 ? _asString : void 0,
        ariaLabel: "Room",
        disabled: props.disabled === true || options.length === 0
    });
};
function resolveProfileMetric(props, controlState) {
    var matrix = props.metricMatrix;
    if (matrix && (typeof matrix === "undefined" ? "undefined" : _type_of(matrix)) === "object") {
        var _asString, _asString1;
        var key = "".concat((_asString = asString(controlState === null || controlState === void 0 ? void 0 : controlState.metricKind)) !== null && _asString !== void 0 ? _asString : "", "|").concat((_asString1 = asString(controlState === null || controlState === void 0 ? void 0 : controlState.aggregation)) !== null && _asString1 !== void 0 ? _asString1 : "");
        var _asString2;
        var resolved = (_asString2 = asString(matrix[key])) !== null && _asString2 !== void 0 ? _asString2 : asString(Object.values(matrix)[0]);
        if (resolved) return resolved;
    }
    var _asString3;
    return (_asString3 = asString(controlState === null || controlState === void 0 ? void 0 : controlState.metric)) !== null && _asString3 !== void 0 ? _asString3 : "baselineUtilisation";
}
var TimeSeriesProfilePanel = function(param) {
    var props = param.props, data = param.data, state = param.state, controlState = param.controlState, endpoint = param.endpoint, // ⭐ For the TREND mode's gym labels only. `context.twins` is built by the host from the twins
    // the caller can already reach — no fetch — and is the same source `GymMultiSelect` and the
    // comparison rails read their gym names from.
    context = param.context;
    var isTrend = endpoint === "timeseries";
    var isRowProfile = endpoint === "manufacturer_comparison";
    var metric = resolveProfileMetric(props, controlState);
    var dayType = dayTypeOf(controlState);
    var meta = metricMeta(metric);
    var authoredGrain = asString(props.grain);
    var grainFromState = asString(controlState === null || controlState === void 0 ? void 0 : controlState.grain);
    var _ref;
    var trendGrain = (_ref = grainFromState !== null && grainFromState !== void 0 ? grainFromState : authoredGrain) !== null && _ref !== void 0 ? _ref : "daily";
    var requestedTwinBids = useMemo10(function() {
        var raw = controlState === null || controlState === void 0 ? void 0 : controlState.gyms;
        if (typeof raw === "string") return raw.trim() === "" ? void 0 : [
            raw.trim()
        ];
        if (!Array.isArray(raw)) return void 0;
        var bids = raw.filter(function(v) {
            return typeof v === "string" && v.trim() !== "";
        }).map(function(b) {
            return b.trim();
        });
        return bids.length > 0 ? bids : void 0;
    }, [
        controlState === null || controlState === void 0 ? void 0 : controlState.gyms
    ]);
    var _useMemo10 = useMemo10(function() {
        if (isTrend) {
            try {
                return _object_spread_props(_object_spread({}, adaptTimeseriesByTwin(data, {
                    twins: context === null || context === void 0 ? void 0 : context.twins,
                    hostTwinBid: context === null || context === void 0 ? void 0 : context.twinBid,
                    hostTwinName: context === null || context === void 0 ? void 0 : context.twinName,
                    requestedTwinBids: requestedTwinBids
                })), {
                    shapeError: void 0
                });
            } catch (err) {
                if (_instanceof(err, TimeseriesShapeError)) {
                    warnShapeError(err.message);
                    return {
                        series: [],
                        isEmpty: true,
                        // 🔻 ONE SENTENCE, IN THIS SLOT'S ESTABLISHED FORM (design review). The first version
                        // was three sentences and about forty-five words, and it explained a DEPLOYMENT concept
                        // — which version of the data service is answering — to a gym operator who can act on
                        // none of it. Every other occupant of this same inline slot is one short sentence
                        // ("The group list could not be loaded, so there are no rows to show.", "Utilisation is
                        // not bound, so the tiles cannot be shown.", "Scope filter unavailable — showing whole
                        // gym"), and copy that departs from the register of the slot it lands in reads as a
                        // different product. The developer-facing detail stays where it belongs: in
                        // `TimeseriesShapeError`'s own message, which names the envelope, the path and the
                        // shape it wanted.
                        //
                        // ⚠️ IT STILL SAYS THE DATA IS FINE, and that half is not trimmable. Without it this
                        // reads as "your gym has no data", which is the exact false conclusion the empty chart
                        // this replaces invited.
                        shapeError: "This chart cannot be shown right now \u2014 the data itself is fine, but it needs a service update."
                    };
                }
                throw err;
            }
        }
        if (isRowProfile) {
            var _data_data;
            var byMetric = (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : {};
            var hours = rowProfileOpenHours(byMetric);
            var selected = Object.prototype.hasOwnProperty.call(byMetric, metric) ? _define_property({}, metric, byMetric[metric]) : {};
            var cropped = Object.fromEntries(Object.entries(selected).map(function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], byGroup = _param[1];
                return [
                    key,
                    narrowRowProfileToHours(byGroup, hours)
                ];
            }));
            return _object_spread_props(_object_spread({}, adaptTimeseries(_object_spread_props(_object_spread({}, data), {
                data: cropped
            }))), {
                shapeError: void 0
            });
        }
        var _data_data1;
        return _object_spread_props(_object_spread({}, adaptBaselineProfile((_data_data1 = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data1 !== void 0 ? _data_data1 : void 0, {
            metric: metric,
            dayType: dayType
        })), {
            shapeError: void 0
        });
    }, [
        isTrend,
        isRowProfile,
        data,
        metric,
        dayType,
        context,
        requestedTwinBids
    ]), series = _useMemo10.series, shapeError = _useMemo10.shapeError;
    var _asString, _asString1, _authoredMetricPrecision, _ref1;
    return /* @__PURE__ */ jsxs25(Fragment12, {
        children: [
            /* @__PURE__ */ jsx31(DataChangeAnnouncer, {
                changeKey: isTrend && requestedTwinBids ? requestedTwinBids.join(",") : null,
                message: isTrend && requestedTwinBids ? "Showing ".concat(requestedTwinBids.length, " ").concat(requestedTwinBids.length === 1 ? "gym" : "gyms", ", ").concat(series.length, " ").concat(series.length === 1 ? "line" : "lines", ".") : null
            }),
            /* @__PURE__ */ jsx31(TimeSeriesChart, {
                series: series,
                grain: isTrend ? trendGrain : "hourly",
                profile: !isTrend,
                metricLabel: (_asString = asString(props.metricLabel)) !== null && _asString !== void 0 ? _asString : isTrend ? void 0 : meta.label,
                unit: (_asString1 = asString(props.unit)) !== null && _asString1 !== void 0 ? _asString1 : isTrend ? void 0 : meta.unit,
                precision: (_ref1 = (_authoredMetricPrecision = authoredMetricPrecision(props, metric)) !== null && _authoredMetricPrecision !== void 0 ? _authoredMetricPrecision : asNumber(props.precision)) !== null && _ref1 !== void 0 ? _ref1 : isTrend ? void 0 : meta.precision,
                xAxisLabel: asString(props.xAxisLabel),
                legend: props.legend === void 0 ? void 0 : props.legend === true,
                loading: state === "loading",
                error: shapeError !== null && shapeError !== void 0 ? shapeError : null
            })
        ]
    });
};
var HierarchicalFilterControl = function(param) {
    var props = param.props, data = param.data, state = param.state, value = param.value, onChange = param.onChange;
    var _data_data;
    var rawRows = (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : [];
    var rows = useMemo10(function() {
        if (!rawRows.some(function(r) {
            return r.tree === "equipment_type";
        })) return rawRows;
        var pruned = pruneHierarchyRoots(rawRows, function(name) {
            return /unknown/i.test(name);
        });
        return pruned.length === 0 ? rawRows : pruned;
    }, [
        rawRows
    ]);
    var index = useMemo10(function() {
        return buildHierarchyTree(rows);
    }, [
        rows
    ]);
    var labelQualifiers = useMemo10(function() {
        return buildLabelQualifiers(rawRows);
    }, [
        rawRows
    ]);
    var seeded = useRef4(false);
    var publishedFor = useRef4(void 0);
    var valueRef = useRef4(value);
    valueRef.current = value;
    var seedRoots = asString(props.wholeGroupScope) === "roots";
    var emit = useCallback2(function(sel) {
        var hasSelection = sel.bids.length > 0;
        var selectedBid = sel.bids[0];
        var row = rows.find(function(r) {
            return r.bid === selectedBid;
        });
        var _row_tree;
        var groupType = hasSelection ? (_row_tree = row === null || row === void 0 ? void 0 : row.tree) !== null && _row_tree !== void 0 ? _row_tree : "equipment_type" : "spatial";
        var next = {
            pathKeys: sel.pathKeys,
            // Per-node scope (trend): the selection, or the ROOTS when whole-gym (defect ①). Legacy
            // consumers keep the empty-is-whole-twin contract.
            bids: hasSelection ? sel.bids : seedRoots ? rootBids(index) : [],
            // Ranked scope (bars): the selection's leaf equipment, or `[]` (twin-wide) when
            // whole-gym. See ScopeSelection.leafBids and D6.
            leafBids: hasSelection ? leafBidsUnder(sel.bids, index) : [],
            // The READ-BUDGET projection (lane 7b). Computed over the SELECTION, not over `next.bids`,
            // so the `wholeGroupScope: "roots"` seed — which substitutes every root — does not report a
            // whole-gym read as a one-level scope it is not. Whole gym is 1 either way; a roots seed
            // that spans one depth is also 1, and both are correct.
            levelCount: distinctDepths(sel.bids, index),
            groupType: groupType,
            label: row === null || row === void 0 ? void 0 : row.name,
            // U17 — carried on every emission so a user selection does not DROP the qualifiers the
            // mount publication below put there. Ambiguity is a property of the catalogue, not of
            // the selection, so it is the same map at every scope.
            labelQualifiers: labelQualifiers
        };
        publishedFor.current = labelQualifiers;
        onChange === null || onChange === void 0 ? void 0 : onChange(next);
    }, [
        rows,
        index,
        onChange,
        seedRoots,
        labelQualifiers
    ]);
    useEffect3(function() {
        if (index.roots.length === 0) return;
        if (seedRoots && !seeded.current) {
            seeded.current = true;
            publishedFor.current = labelQualifiers;
            emit({
                pathKeys: [],
                bids: []
            });
            return;
        }
        if (publishedFor.current === labelQualifiers) return;
        publishedFor.current = labelQualifiers;
        var latest = valueRef.current;
        var current = (typeof latest === "undefined" ? "undefined" : _type_of(latest)) === "object" && latest !== null ? latest : {};
        onChange === null || onChange === void 0 ? void 0 : onChange(_object_spread_props(_object_spread({}, current), {
            labelQualifiers: labelQualifiers
        }));
    }, [
        seedRoots,
        index,
        emit,
        onChange,
        labelQualifiers
    ]);
    return(// No `colorForValue` below: this control supplies no `nodeMeta`, so no status dot renders and
    // there is no colour metric to resolve against. The component's own default — the design-token
    // band ramp — is the right answer for whenever `nodeMeta` is wired.
    /* @__PURE__ */ jsx31(HierarchicalFilter, {
        rows: rows,
        mode: asString(props.mode),
        clearable: props.clearable === true,
        initialExpanded: asString(props.initialExpanded),
        defaultRootIndex: typeof props.defaultRootIndex === "number" ? props.defaultRootIndex : void 0,
        title: asString(props.title),
        emptyMessage: asString(props.emptyMessage),
        onChange: emit,
        loading: state === "loading",
        error: state === "error" ? seedRoots || typeof props.defaultRootIndex === "number" ? "Scope filter unavailable \u2014 reload to try again" : "Scope filter unavailable \u2014 showing whole gym" : null
    }));
};
var DayTypeSelectControl = function(param) {
    var props = param.props, value = param.value, onChange = param.onChange;
    return /* @__PURE__ */ jsx31(DayTypeSelect, {
        value: value === "weekday" || value === "weekend" ? value : "all",
        label: asString(props.title),
        onChange: function(dt) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(dt);
        }
    });
};
var SegmentedControlControl = function(param) {
    var props = param.props, value = param.value, onChange = param.onChange, ariaControls = param.ariaControls;
    var _options_;
    var options = Array.isArray(props.options) ? props.options : [];
    var raw = value;
    var isValid = options.some(function(o) {
        return o.value === raw;
    });
    var _options__value;
    var selected = isValid ? raw : (_options__value = (_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.value) !== null && _options__value !== void 0 ? _options__value : "";
    useEffect3(function() {
        if (!isValid && options.length > 0) onChange === null || onChange === void 0 ? void 0 : onChange(options[0].value);
    }, [
        isValid,
        options,
        onChange
    ]);
    var _asString;
    return /* @__PURE__ */ jsx31(SegmentedControl, {
        label: (_asString = asString(props.label)) !== null && _asString !== void 0 ? _asString : "",
        options: options,
        value: selected,
        size: asString(props.size),
        onChange: function(v) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(v);
        },
        ariaControls: ariaControls
    });
};
var DateRangePickerControl = function(param) {
    var props = param.props, value = param.value, onChange = param.onChange;
    var defaultWindow = asString(props.defaultWindow);
    var maxSpan = asString(props.maxSpan);
    var today = /* @__PURE__ */ new Date().toISOString().slice(0, 10);
    var raw = value;
    var hasValue = isValidWindow(raw);
    var resolved = useMemo10(function() {
        var seeded = hasValue ? {
            start: raw.start,
            end: raw.end
        } : seedWindow(today, defaultWindow);
        return seeded ? clampWindow(seeded, maxSpan) : null;
    }, [
        hasValue,
        raw === null || raw === void 0 ? void 0 : raw.start,
        raw === null || raw === void 0 ? void 0 : raw.end,
        today,
        defaultWindow,
        maxSpan
    ]);
    useEffect3(function() {
        if (!resolved || !onChange) return;
        if ((raw === null || raw === void 0 ? void 0 : raw.start) === resolved.start && (raw === null || raw === void 0 ? void 0 : raw.end) === resolved.end) return;
        onChange(resolved);
    }, [
        resolved,
        raw === null || raw === void 0 ? void 0 : raw.start,
        raw === null || raw === void 0 ? void 0 : raw.end,
        onChange
    ]);
    var bounds = boundsFor(today, maxSpan);
    var _bounds_min, _bounds_max;
    var shown = resolved !== null && resolved !== void 0 ? resolved : {
        start: (_bounds_min = bounds.min) !== null && _bounds_min !== void 0 ? _bounds_min : "",
        end: (_bounds_max = bounds.max) !== null && _bounds_max !== void 0 ? _bounds_max : ""
    };
    var _asString, _asString1;
    return /* @__PURE__ */ jsx31(DateRangePicker, {
        value: shown,
        onChange: function(next) {
            if (isValidWindow(next)) onChange === null || onChange === void 0 ? void 0 : onChange(clampWindow(next, maxSpan));
        },
        min: (_asString = asString(props.min)) !== null && _asString !== void 0 ? _asString : bounds.min,
        max: (_asString1 = asString(props.max)) !== null && _asString1 !== void 0 ? _asString1 : bounds.max
    });
};
var ChartHeaderPanel = function(param) {
    var props = param.props, data = param.data, controlState = param.controlState;
    var _controlState_scope;
    var _asString;
    var authoredTitle = (_asString = asString(props.title)) !== null && _asString !== void 0 ? _asString : "";
    var scopeLabel = controlState === null || controlState === void 0 ? void 0 : (_controlState_scope = controlState.scope) === null || _controlState_scope === void 0 ? void 0 : _controlState_scope.label;
    var title = props.useScopeTitle === true ? scopeLabel !== null && scopeLabel !== void 0 ? scopeLabel : authoredTitle || "Gym Total" : authoredTitle;
    var dayType = dayTypeOf(controlState);
    var note = useMemo10(function() {
        var raw = data === null || data === void 0 ? void 0 : data.data;
        var windows = Array.isArray(raw) ? raw : raw === null || raw === void 0 ? void 0 : raw.peak_windows;
        if (!windows || windows.length === 0) return void 0;
        return peakHoursNote(windows, dayType);
    }, [
        data,
        dayType
    ]);
    return /* @__PURE__ */ jsx31(ChartHeader, {
        title: title,
        subtitle: asString(props.subtitle),
        note: note
    });
};
var KPICardLivePanel = function(param) {
    var props = param.props, data = param.data, state = param.state, hostValues = param.hostValues, title = param.title;
    var vm = useMemo10(function() {
        return adaptNow(data);
    }, [
        data
    ]);
    var row = pickSpatialRow(vm.rows.map(function(r) {
        return _object_spread_props(_object_spread({}, r), {
            group_type: r.groupType
        });
    }));
    var liveKey = asString(props.liveValue);
    var hasLive = liveKey !== void 0 && hostValues !== void 0 && liveKey in hostValues;
    var _hostValues_liveKey, _row_headcount;
    var value = hasLive ? (_hostValues_liveKey = hostValues[liveKey]) !== null && _hostValues_liveKey !== void 0 ? _hostValues_liveKey : null : (_row_headcount = row === null || row === void 0 ? void 0 : row.headcount) !== null && _row_headcount !== void 0 ? _row_headcount : null;
    var pct3 = row === null || row === void 0 ? void 0 : row.pctOfTypicalPeak;
    var subline = pct3 === null || pct3 === void 0 ? void 0 : "".concat(Math.round(pct3), "% of typical max");
    var panelDrawsTheHeading = (title !== null && title !== void 0 ? title : "").trim().length > 0;
    var _asString;
    return /* @__PURE__ */ jsx31(KPICardLive, {
        label: (_asString = asString(props.label)) !== null && _asString !== void 0 ? _asString : "",
        renderLabel: !panelDrawsTheHeading,
        value: value,
        unit: asString(props.unit),
        subline: subline,
        minutesAgo: hasLive ? void 0 : row === null || row === void 0 ? void 0 : row.minutesAgo,
        onGlass: props.onGlass === true,
        loading: state === "loading"
    });
};
var RankedRowsPanel = function(param) {
    var props = param.props, data = param.data, state = param.state, endpoint = param.endpoint, hostActions = param.hostActions, controlState = param.controlState;
    var labelQualifiers = labelQualifiersOf(controlState);
    var orderedMeasure = endpoint === "equipment_recommendations" ? orderedMeasureOf(data === null || data === void 0 ? void 0 : data.stats) : null;
    var rows = useMemo10(function() {
        if (endpoint === "predicted_busy_next_hour") {
            var src = Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : [];
            return src.filter(measurable2(function(r) {
                return r.baseline_utilisation_pct;
            })).map(function(r) {
                var _r_group_label;
                return {
                    bid: r.group_bid,
                    // `group_label` is nullable upstream. An em dash, never the bid: a bID is an opaque
                    // catalogue key and is never displayed (row 35).
                    label: (_r_group_label = r.group_label) !== null && _r_group_label !== void 0 ? _r_group_label : "\u2014",
                    value: r.baseline_utilisation_pct
                };
            });
        }
        if (endpoint === "equipment_recommendations") {
            var src1 = Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : [];
            var field = orderedMeasureOf(data === null || data === void 0 ? void 0 : data.stats);
            return src1.map(function(r) {
                var _r_field, _r_peak_utilisation_pct;
                return {
                    bid: r.group_bid,
                    // `group_label` is nullable upstream. An em dash, never the bid: a bID is an opaque
                    // catalogue key and is never displayed (row 35).
                    //
                    // U17 — qualified with the equipment TYPE where the variation name is ambiguous across
                    // the twin's portfolio (AC2). ⚠️ THE NULL-LABEL GUARD IS LOAD-BEARING: qualification is
                    // keyed by bID, so an unlabelled row whose bID happens to be ambiguous would otherwise
                    // render `— (Pin selected)` — a qualifier attached to nothing. No label, no qualifier.
                    label: r.group_label ? qualifyLabel(r.group_bid, r.group_label, labelQualifiers) : "\u2014",
                    // ⚠️ NO `measurable` FILTER HERE, and its absence is the point of row 16's component
                    // change. `RankedRowVM.value` is now `number | null` and `RankedRows` draws an em dash
                    // with no wash, so an unmeasurable group is SHOWN as unmeasurable instead of being
                    // dropped. Dropping it would present "we could not measure this" as "this is fine",
                    // and on a ranked-by-lowest list a fabricated 0 sorts to the very top. Measured on BI
                    // Staging 2026-08-25: at PUL-CON all 47 variations have a null peak utilisation, so
                    // the drop rendered an EMPTY list for a gym with 47 tracked variations.
                    value: field ? (_r_field = r[field]) !== null && _r_field !== void 0 ? _r_field : null : null,
                    // ⭐ COLOUR IS BUSYNESS, WHATEVER THE NUMBERS SAY — the estate rule, and the second
                    // surface it has had to be applied to. The heatmap resolves its ink against a COLOUR
                    // measure the definition names; this list needs no authoring because its colour measure
                    // does not VARY — there is exactly one busyness reading on the row and it is the one
                    // every list on this endpoint should be coloured by.
                    //
                    // ⚠️ `peak_utilisation_pct`, NOT `utilisation_pct`, and the choice is forced rather than
                    // preferred: it is the measure this dashboard's own toggle offers, the measure R16 rules
                    // on, and — decisively — the one that leaves the utilisation setting BYTE-IDENTICAL.
                    // Colouring by the all-hours figure would have quietly restyled a card nobody reported.
                    //
                    // ⚠️ NULL IS NOT ZERO HERE EITHER. A variation with no peak reading falls back to
                    // colouring by its own value (`RankedRowVM.colorValue`), which is the pre-existing
                    // behaviour — painting it as idle would state a fact BI could not compute, and at PUL-CON
                    // that is all 47 variations.
                    //
                    // ⭐ IT COSTS NOTHING. `peak_utilisation_pct` is on every row of the SAME read already —
                    // the endpoint serves the whole measure set per row and each card takes one column — so
                    // the colour follows the toggle with no refetch, exactly as the printed value does.
                    colorValue: (_r_peak_utilisation_pct = r.peak_utilisation_pct) !== null && _r_peak_utilisation_pct !== void 0 ? _r_peak_utilisation_pct : null
                };
            });
        }
        if (endpoint === "now") {
            var src2 = Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : [];
            return src2.filter(measurable2(function(r) {
                return r.utilisation_pct;
            })).map(function(r) {
                var _r_group_label;
                return {
                    bid: r.group_bid,
                    label: (_r_group_label = r.group_label) !== null && _r_group_label !== void 0 ? _r_group_label : "\u2014",
                    value: r.utilisation_pct
                };
            });
        }
        return adaptRanking(data).rows.filter(measurable2(function(r) {
            return r.value;
        }));
    }, [
        data,
        endpoint,
        labelQualifiers
    ]);
    var unmeasurableNow = endpoint === "now" && rows.length === 0 && Array.isArray(data === null || data === void 0 ? void 0 : data.data) && data.data.length > 0;
    var emptyMessage = unmeasurableNow ? "Areas are reporting, but none has a utilisation figure" : asString(props.emptyMessage);
    var _asString, _asNumber, _asNumber1;
    return /* @__PURE__ */ jsx31(RankedRows, {
        rows: rows,
        unit: (_asString = asString(props.unit)) !== null && _asString !== void 0 ? _asString : orderedMeasure ? RANKED_MEASURE_UNITS[orderedMeasure] : void 0,
        maxValue: (_asNumber = asNumber(props.maxValue)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        precision: (_asNumber1 = asNumber(props.precision)) !== null && _asNumber1 !== void 0 ? _asNumber1 : void 0,
        inScope: props.inScope !== false,
        emptyMessage: emptyMessage,
        onActivate: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onActivate,
        onHover: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onHover,
        loading: state === "loading"
    });
};
var SuggestionsPanel = function(param) {
    var props = param.props, data = param.data, state = param.state, hostActions = param.hostActions, controlState = param.controlState;
    var labelQualifiers = labelQualifiersOf(controlState);
    var buckets = useMemo10(function() {
        var src = Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : [];
        var kind = suggestionKindOf(data === null || data === void 0 ? void 0 : data.stats);
        var all = adaptEquipmentRecommendations(src);
        var mine = kind ? all.filter(function(b) {
            return b.kind === kind;
        }) : all;
        if (!labelQualifiers) return mine;
        return mine.map(function(b) {
            return _object_spread_props(_object_spread({}, b), {
                // The null-label guard again: `toItem` already falls back to `—`, and a qualifier hung off
                // an em dash is worse than no qualifier at all.
                items: b.items.map(function(it) {
                    return it.label && it.label !== "\u2014" ? _object_spread_props(_object_spread({}, it), {
                        label: qualifyLabel(it.bid, it.label, labelQualifiers)
                    }) : it;
                })
            });
        });
    }, [
        data,
        labelQualifiers
    ]);
    return /* @__PURE__ */ jsx31(Suggestions_default, {
        buckets: buckets,
        emptyMessage: asString(props.emptyMessage),
        onActivate: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onActivate,
        onHover: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onHover,
        loading: state === "loading"
    });
};
var EquipmentCheckTablePanel = function(param) {
    var props = param.props, data = param.data, state = param.state, hostActions = param.hostActions;
    var vm = useMemo10(function() {
        return adaptEquipmentHealth(data);
    }, [
        data
    ]);
    var loading = state === "loading";
    if (vm.siteWide.isEvent) return /* @__PURE__ */ jsx31(SiteWideBanner, {
        siteWide: vm.siteWide
    });
    if (vm.isEmpty && !loading) {
        var _asString;
        return /* @__PURE__ */ jsx31(EmptyState_default, {
            message: (_asString = asString(props.emptyMessage)) !== null && _asString !== void 0 ? _asString : "All clear \u2014 no equipment to check"
        });
    }
    return /* @__PURE__ */ jsx31(EquipmentCheckTable, {
        rows: vm.rows,
        spotlightVariant: asString(props.spotlightVariant),
        emptyMessage: asString(props.emptyMessage),
        onActivate: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onActivate,
        onHover: hostActions === null || hostActions === void 0 ? void 0 : hostActions.onHover,
        loading: loading
    });
};
function resolveGroups(envelope) {
    var byGroup = envelope === null || envelope === void 0 ? void 0 : envelope.data;
    if (!byGroup || (typeof byGroup === "undefined" ? "undefined" : _type_of(byGroup)) !== "object" || Array.isArray(byGroup)) return [];
    var labels = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(byGroup)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), bid = _step_value[0], cell = _step_value[1];
            var label = asString(cell === null || cell === void 0 ? void 0 : cell.group_label);
            if (label) labels[bid] = label;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return groupsFromSummary(byGroup, labels);
}
function asStringTriple(v) {
    if (!Array.isArray(v) || v.length !== 3) return void 0;
    return v.every(function(x) {
        return typeof x === "string" && x.trim() !== "";
    }) ? [
        v[0],
        v[1],
        v[2]
    ] : void 0;
}
function resolveFromMatrix(matrix, key) {
    if (!matrix || (typeof matrix === "undefined" ? "undefined" : _type_of(matrix)) !== "object" || Array.isArray(matrix)) return void 0;
    var k = asString(key);
    return k ? asString(matrix[k]) : void 0;
}
var HeatmapPanel = function(param) {
    var props = param.props, _param_bindings = param.bindings, bindings = _param_bindings === void 0 ? {} : _param_bindings, controlState = param.controlState;
    var view = bindings.view;
    var summary2 = bindings.summary;
    var metric = resolveProfileMetric(props, controlState);
    var meta = metricMeta(metric);
    var dayType = dayTypeOf(controlState);
    var dayCollapse = dayCollapseOf(controlState);
    var colorMetric = resolveFromMatrix(props.colorMetricMatrix, controlState === null || controlState === void 0 ? void 0 : controlState.aggregation);
    var groups = useMemo10(function() {
        return resolveGroups(summary2 === null || summary2 === void 0 ? void 0 : summary2.data);
    }, [
        summary2 === null || summary2 === void 0 ? void 0 : summary2.data
    ]);
    var _useValueColor = useValueColor(colorMetric !== null && colorMetric !== void 0 ? colorMetric : metric), colorForValue = _useValueColor.colorForValue, inkForValue = _useValueColor.inkForValue;
    var vm = useMemo10(function() {
        var _view_data;
        return adaptBaselineMatrix(view === null || view === void 0 ? void 0 : (_view_data = view.data) === null || _view_data === void 0 ? void 0 : _view_data.data, {
            metric: metric,
            colorMetric: colorMetric,
            dayType: dayType,
            dayCollapse: dayCollapse,
            groups: groups,
            // Read against the COLOUR measure, which is a utilisation wherever one is authored — and a
            // utilisation above 100 IS the headcount exceeding capacity. That is what makes the flag
            // fire on every lens rather than only on the one that happens to be a percentage.
            overCapacityAbove: colorMetric || meta.unit === "%" ? 100 : void 0
        });
    }, [
        view === null || view === void 0 ? void 0 : view.data,
        metric,
        colorMetric,
        dayType,
        dayCollapse,
        groups,
        meta.unit
    ]);
    var _asString, _resolveFromMatrix, _asString1, _asNumber;
    return /* @__PURE__ */ jsxs25(Fragment12, {
        children: [
            /* @__PURE__ */ jsx31(DataChangeAnnouncer, {
                changeKey: (_asString = asString(controlState === null || controlState === void 0 ? void 0 : controlState.aggregation)) !== null && _asString !== void 0 ? _asString : null,
                message: aggregationAnnouncement(controlState === null || controlState === void 0 ? void 0 : controlState.aggregation)
            }),
            /* @__PURE__ */ jsx31(Heatmap, {
                cells: vm.cells,
                rows: vm.rows,
                hours: vm.hours,
                rowHeader: (_resolveFromMatrix = resolveFromMatrix(props.rowHeaderMatrix, controlState === null || controlState === void 0 ? void 0 : controlState.level)) !== null && _resolveFromMatrix !== void 0 ? _resolveFromMatrix : asString(props.rowHeader),
                metricLabel: (_asString1 = asString(props.metricLabel)) !== null && _asString1 !== void 0 ? _asString1 : meta.label,
                unit: meta.unit === "%" ? "%" : "",
                precision: (_asNumber = asNumber(props.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
                colorForValue: colorForValue,
                inkForValue: inkForValue,
                showRampLegend: props.showRampLegend === true,
                rampLabels: asStringTriple(props.rampLabels),
                emptyMessage: asString(props.emptyMessage),
                error: !summary2 ? "The group list is not bound, so there are no rows to show." : summary2.state === "error" ? "The group list could not be loaded, so there are no rows to show." : null,
                loading: (view === null || view === void 0 ? void 0 : view.state) === "loading" || (summary2 === null || summary2 === void 0 ? void 0 : summary2.state) === "loading"
            })
        ]
    });
};
var CapacityTreemapPanel = function(param) {
    var props = param.props, _param_bindings = param.bindings, bindings = _param_bindings === void 0 ? {} : _param_bindings, controlState = param.controlState;
    var view = bindings.view;
    var summary2 = bindings.summary;
    var metric = resolveProfileMetric(props, controlState);
    var meta = metricMeta(metric);
    var dayType = dayTypeOf(controlState);
    var dayCollapse = dayCollapseOf(controlState);
    var colorMetric = resolveFromMatrix(props.colorMetricMatrix, controlState === null || controlState === void 0 ? void 0 : controlState.aggregation);
    var groups = useMemo10(function() {
        return resolveGroups(summary2 === null || summary2 === void 0 ? void 0 : summary2.data);
    }, [
        summary2 === null || summary2 === void 0 ? void 0 : summary2.data
    ]);
    var _useValueColor = useValueColor(colorMetric !== null && colorMetric !== void 0 ? colorMetric : metric), colorForValue = _useValueColor.colorForValue, inkForValue = _useValueColor.inkForValue;
    var items = useMemo10(function() {
        var _view_data;
        return adaptCapacityTiles(view === null || view === void 0 ? void 0 : (_view_data = view.data) === null || _view_data === void 0 ? void 0 : _view_data.data, {
            metric: metric,
            colorMetric: colorMetric,
            dayType: dayType,
            dayCollapse: dayCollapse,
            groups: groups
        });
    }, [
        view === null || view === void 0 ? void 0 : view.data,
        metric,
        colorMetric,
        dayType,
        dayCollapse,
        groups
    ]);
    var _asString, _resolveFromMatrix, _asNumber;
    return /* @__PURE__ */ jsx31(CapacityTreemap, {
        items: items,
        colorForValue: colorForValue,
        inkForValue: inkForValue,
        unit: colorMetric ? "%" : meta.unit === "%" ? "%" : "",
        sizeLabel: asString(props.sizeLabel),
        metricLabel: (_asString = asString(props.metricLabel)) !== null && _asString !== void 0 ? _asString : colorMetric ? metricMeta(colorMetric).label : meta.label,
        rowHeader: (_resolveFromMatrix = resolveFromMatrix(props.rowHeaderMatrix, controlState === null || controlState === void 0 ? void 0 : controlState.level)) !== null && _resolveFromMatrix !== void 0 ? _resolveFromMatrix : asString(props.rowHeader),
        precision: (_asNumber = asNumber(props.precision)) !== null && _asNumber !== void 0 ? _asNumber : void 0,
        showRampLegend: props.showRampLegend === true,
        rampLabels: asStringTriple(props.rampLabels),
        emptyMessage: asString(props.emptyMessage),
        error: !view ? "Utilisation is not bound, so the tiles cannot be shown." : view.state === "error" ? "Utilisation could not be loaded, so the tiles cannot be shown." : null,
        loading: (summary2 === null || summary2 === void 0 ? void 0 : summary2.state) === "loading" || (view === null || view === void 0 ? void 0 : view.state) === "loading"
    });
};
var CHART_PANEL_COMPONENTS = {
    KPICard: KPICardPanel,
    // Row 26 (Operations) — the three components the ops surface binds. `EntitySpotlight` is
    // deliberately NOT here: the two below compose it directly, which needs no manifest entry
    // and no registry key, and registering it would make it bindable as a panel in its own
    // right with nothing sensible to render. See `chartManifest.ts` for the full reasoning.
    KPICardLive: KPICardLivePanel,
    RankedRows: RankedRowsPanel,
    Suggestions: SuggestionsPanel,
    EquipmentCheckTable: EquipmentCheckTablePanel,
    BandHistogram: BandHistogramPanel,
    TimeSeriesChart: TimeSeriesProfilePanel,
    BarChart: BarChartPanel,
    MetricTable: MetricTablePanel,
    // Row 14 (Dashboard 1.2a) — the A/B pair. Both read side A on `sideA` and side B on `sideB`, and
    // both are written against a SHAPE rather than an endpoint, so any leg projecting a comparison side
    // that way binds them unchanged.
    ComparisonKPI: ComparisonKPIPanel,
    ComparisonTable: ComparisonTablePanel,
    ComparisonChart: ComparisonChartPanel,
    // Row 17 (Dashboard 3.1, `spatial-heatmap`) — the two marks that have been SCHEMA-ONLY since
    // inception, bound for the first time. Both read the enumerated baseline pair, in opposite
    // primary/aux roles: see `resolveGroups` for why that is a decision rather than an inconsistency.
    Heatmap: HeatmapPanel,
    CapacityTreemap: CapacityTreemapPanel,
    ChartHeader: ChartHeaderPanel,
    // Control wrappers (FR2) — injected through the same overlay; the renderer hands
    // controls `value`/`onChange` (+ the resolved `data` for data-driven controls).
    HierarchicalFilter: HierarchicalFilterControl,
    // Row 14 / P2 — options from the HOST CONTEXT, not from a binding: no catalogue endpoint lists the
    // caller's organisation's twins, and the host already resolves the list for its own twin selector.
    GymSelect: GymSelectControl,
    // Row 18 (Dashboard 1.2, `classes`) — the first DATA-BOUND single select. Options come from
    // `event_filters`, and its cleared value (`null`) reaches the wire as an ABSENT `entity_bid`,
    // which is how the ranked read expresses "every room".
    GymMultiSelect: GymMultiSelectControl,
    RoomSelect: RoomSelectControl,
    DayTypeSelect: DayTypeSelectControl,
    SegmentedControl: SegmentedControlControl,
    DateRangePicker: DateRangePickerControl
};
// src/charts/components/EmptyState/propsSchema.ts
var emptyStatePropsSchema = {
    type: "object",
    properties: {
        message: {
            type: "string",
            description: 'Message to show; defaults to "No data available".'
        }
    },
    additionalProperties: false
};
// src/charts/components/BusyOverlay/propsSchema.ts
var busyOverlayPropsSchema = {
    type: "object",
    properties: {
        loading: {
            type: "boolean",
            description: "Show the spinner scrim over content."
        },
        stale: {
            type: "boolean",
            description: "Show the stale overlay tint + badge."
        },
        skeleton: {
            type: "boolean",
            description: "Replace content with a shimmer (first load)."
        },
        staleLabel: {
            type: "string",
            description: "Marker text for the stale badge."
        }
    },
    additionalProperties: false
};
// src/charts.ts
registerCharts();
applyChartTheme();
export { BandHistogram, BarChart, BusyOverlay, CHART_PANEL_COMPONENTS, CapacityTreemap, ChartHeader, ChartsDataProviderProvider, CompanionTable, ComparisonChart, ComparisonKPI, ComparisonTable, DataChangeAnnouncer, DateRangePicker, DayTypeSelect, EVENT_INSTANCES_LABEL_KEYS, EVENT_INSTANCES_VALUE_KEYS, EVENT_RANKING_VALUE_KEYS, EmptyState, EntitySpotlight, EquipmentCheckTable, GymMultiSelect, GymSelect, Heatmap, HierarchicalFilter, KPICard, KPICardLive, MetricTable, PEAK_BANDS_PLUGIN_ID, PanelCard, RampLegend, RankedRows, RoomSelect, SeriesColorChip, Suggestions, TimeSeriesChart, TimeseriesShapeError, adaptEquipmentHealth, adaptNow, adaptRanking, adaptTimeseries, adaptTimeseriesByTwin, adaptUsageBands, applyChartTheme, bandHistogramPropsSchema, barChartPropsSchema, buildBandColors, buildMatrixCompanion, buildSeriesDatasets, buildTreemapCompanion, busyOverlayPropsSchema, capacityTreemapPropsSchema, chartHeaderPropsSchema, comparisonChartPropsSchema, comparisonKpiPropsSchema, comparisonTablePropsSchema, createFixtureProvider, dateRangePickerPropsSchema, dayTypeSelectPropsSchema, durationToMs, emptyStatePropsSchema, entitySpotlightPropsSchema, equipmentCheckTablePropsSchema, formatHourRange, gymMultiSelectPropsSchema, gymSelectPropsSchema, heatmapPropsSchema, hierarchicalFilterPropsSchema, kpiCardLivePropsSchema, kpiCardPropsSchema, makeTimeTickCallback, metricTablePropsSchema, panelCardPropsSchema, peakBandsPlugin, pickNowGroup, rankedRowsPropsSchema, registerCharts, resolvePeakBands, roomSelectPropsSchema, suggestionsPropsSchema, timeSeriesChartPropsSchema, useChartJs, useChartsDataProvider, useEquipmentHealth, useNow, useRanking, useTimeseries, useUsageBands, visuallyHidden };
